import PropTypes from 'prop-types';
import React, { forwardRef, Component, PureComponent, useState, useRef, useEffect, useCallback, createRef } from 'react';
import { createTheming, createUseStyles } from 'react-jss';
import classNames$1 from 'classnames';
import noop from 'lodash.noop';
import color from 'color';
import { faSignOutAlt, faCalendarDay, faBell, faUser, faAngleRight, faTicketAlt, faHome, faPlusCircle, faBars, faTimes, faBoxOpen, faBarcode, faSort, faSortDown, faSortUp, faExclamationTriangle, faInfoCircle, faEye, faEyeSlash, faCheck, faPlus, faChevronLeft, faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import FocusTrap from 'focus-trap-react';
import Select$1, { components } from 'react-select';
import get from 'lodash/get';
import uuid from 'uuid/v4';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { noop as noop$1 } from 'lodash';

var createTestId = function createTestId(id) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return id ? id + (suffix ? "-".concat(suffix) : '') : undefined;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

var styles = function styles(_ref) {
  var mixins = _ref.mixins;
  return {
    address: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'Address'
    }),
    addressRow: {
      fontStyle: 'italic',
      composes: 'AddressRow'
    }
  };
};

var reactContext = /*#__PURE__*/React.createContext({});
var theming = createTheming(reactContext);
var withTheme = theming.withTheme,
    ThemeProvider = theming.ThemeProvider,
    useTheme = theming.useTheme;

var withStyles = function withStyles(styles) {
  return function (Component) {
    return /*#__PURE__*/forwardRef(function (props, ref) {
      var theme = useTheme();
      var useStyles = createUseStyles(styles, {
        theming: theming
      });
      var classes = useStyles(_objectSpread2(_objectSpread2({}, props), {}, {
        theme: theme
      }));
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        classes: classes,
        theme: theme,
        forwardRef: ref
      }));
    });
  };
};

withStyles.displayName = "withStyles(".concat(withStyles.displayName || withStyles.name, ")");

/* eslint-disable camelcase */

var Address = function Address(_ref) {
  var address = _ref.address,
      classes = _ref.classes,
      className = _ref.className,
      testId = _ref.testId;
  var address_1 = address.address_1,
      address_2 = address.address_2,
      address_3 = address.address_3,
      city = address.city,
      county = address.county,
      postcode = address.postcode,
      country = address.country;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.address, " ").concat(className !== null && className !== void 0 ? className : ''),
    "data-test": createTestId(testId)
  }, address_1 && /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId, 'addressOne'),
    className: classes.addressRow
  }, address_1), address_2 && /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId, 'addressTwo'),
    className: classes.addressRow
  }, address_2), address_3 && /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId, 'addressThree'),
    className: classes.addressRow
  }, address_3), city && /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId, 'addressCity'),
    className: classes.addressRow
  }, city), county && /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId, 'addressCounty'),
    className: classes.addressRow
  }, county), postcode && /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId, 'postcode'),
    className: classes.addressRow
  }, postcode), country && /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId, 'country'),
    className: classes.addressRow
  }, country.name));
};

Address.displayName = "Address";
Address.propTypes = {
  address: PropTypes.shape({
    address_1: PropTypes.string.isRequired,
    address_2: PropTypes.string,
    address_3: PropTypes.string,
    city: PropTypes.string.isRequired,
    county: PropTypes.string,
    postcode: PropTypes.string.isRequired,
    country: PropTypes.shape({
      id: PropTypes.number,
      code: PropTypes.string,
      name: PropTypes.string
    })
  }).isRequired,
  classes: PropTypes.object,
  className: PropTypes.string,
  testId: PropTypes.string
};
Address.defaultProps = {
  classes: {},
  className: '',
  testId: ''
};
var Address$1 = withStyles(styles)(Address);

var styles$1 = function styles(_ref) {
  var variables = _ref.variables;
  return {
    badge: {
      composes: 'Badge',
      fontSize: '0.8em',
      borderRadius: '1em',
      padding: '0 0.4em',
      verticalAlign: 'baseline'
    },
    "default": {
      composes: 'Badge--default',
      border: "".concat(variables.colors.greyTwo, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.typeDefault
    },
    success: {
      composes: 'Badge--success',
      border: "".concat(variables.colors.typeSuccess, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.typeSuccess,
      color: variables.colors.light
    },
    info: {
      composes: 'Badge--info',
      border: "".concat(variables.colors.typeInfo, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.typeInfo,
      color: variables.colors.light
    },
    warning: {
      composes: 'Badge--warning',
      border: "".concat(variables.colors.typeWarning, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.typeWarning,
      color: variables.colors.dark
    },
    danger: {
      composes: 'Badge--danger',
      border: "".concat(variables.colors.typeDanger, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.typeDanger,
      color: variables.colors.light
    },
    text: {
      lineHeight: 1,
      position: 'relative',
      fontStyle: 'normal'
    }
  };
};

var Badge = function Badge(_ref) {
  var classes = _ref.classes,
      text = _ref.text,
      type = _ref.type,
      className = _ref.className,
      testId = _ref.testId;
  var badgeClasses = classNames$1(classes.badge, classes[type] || classes["default"], className);
  return /*#__PURE__*/React.createElement("span", {
    "data-test": createTestId(testId),
    className: badgeClasses
  }, /*#__PURE__*/React.createElement("span", {
    "data-test": createTestId(testId, 'text'),
    className: classes.text
  }, text));
};

Badge.displayName = "Badge";
Badge.propTypes = {
  classes: PropTypes.shape({
    badge: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    success: PropTypes.string.isRequired,
    "default": PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    warning: PropTypes.string.isRequired,
    danger: PropTypes.string.isRequired
  }).isRequired,
  className: PropTypes.string,
  testId: PropTypes.string,
  text: PropTypes.string.isRequired,
  type: PropTypes.string
};
Badge.defaultProps = {
  className: '',
  testId: '',
  type: 'default'
};
var Badge$1 = withStyles(styles$1)(Badge);

var styles$2 = function styles(_ref) {
  var variables = _ref.variables,
      mixins = _ref.mixins,
      breakpoints = _ref.breakpoints,
      type = _ref.type;
  var stylesheet = {
    container: _objectSpread2(_objectSpread2({
      composes: 'Boilerplate'
    }, mixins.box()), {}, {
      padding: '0 2rem 2rem',
      borderRadius: '2px',
      margin: '2rem',
      fontSize: '16px',
      transition: 'all 0.2s ease-in'
    }),
    header: _defineProperty({
      composes: 'Boilerplate__header',
      color: variables.kaboodleGreen,
      transition: 'all 0.2s ease-in'
    }, breakpoints.desktop, {
      fontSize: '24px'
    }),
    button: {
      composes: 'Boilerplate__button',
      appearance: 'none',
      padding: '0.5rem 1rem',
      backgroundColor: variables.kaboodleGreen,
      color: 'white',
      fontSize: '0.8rem',
      border: 'none',
      transition: 'all 0.2s ease-in',
      '&:hover': {
        backgroundColor: 'red'
      }
    },
    containerActive: {
      composes: '$container',
      backgroundColor: variables.kaboodleGreen,
      color: 'white',
      '& $header': {
        color: 'white'
      },
      '& $button': {
        color: variables.kaboodleGreen,
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: 'red'
        }
      }
    }
  };

  if (type === 'gradient') {
    stylesheet = Object.assign(stylesheet, {
      containerActive: _objectSpread2(_objectSpread2({}, stylesheet.containerActive), mixins.gradientBackground(variables.kaboodleOrange, variables.kaboodleRed))
    });
  }

  return stylesheet;
};

var Boilerplate = function Boilerplate(_ref) {
  var classes = _ref.classes,
      _onClick = _ref.onClick,
      selected = _ref.selected,
      name = _ref.name,
      id = _ref.id,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: selected ? classes.containerActive : classes.container
  }, /*#__PURE__*/React.createElement("h1", {
    className: classes.header
  }, "This is an example component called ", name, "."), /*#__PURE__*/React.createElement("p", null, "By running ", /*#__PURE__*/React.createElement("b", null, "npm run create"), ", you can copy the contents of this component whlist renaming all the required files and class names accordingly."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, children)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classes.button,
    onClick: function onClick(event) {
      _onClick(id, event);
    }
  }, "Click Me!"));
};

Boilerplate.displayName = "Boilerplate";
Boilerplate.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool
};
Boilerplate.defaultProps = {
  children: null,
  classes: {},
  selected: false
};
var Boilerplate$1 = withStyles(styles$2)(Boilerplate);

var styles$3 = function styles(_ref) {
  var variables = _ref.variables,
      mixins = _ref.mixins;
  return {
    '@global': {
      '@keyframes spin': {
        to: {
          transform: 'rotate(360deg)'
        }
      }
    },
    loading: {
      cursor: 'default',
      '& $title': {
        opacity: 0
      }
    },
    loader: {
      composes: 'Button__loader',
      position: 'absolute',
      display: 'block',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    },
    loaderInner: {
      composes: 'Button__loader-inner',
      display: 'inline-block',
      width: '1em',
      height: '1em',
      borderStyle: 'solid',
      borderWidth: '3px',
      borderColor: "".concat(color(variables.colors.greyThree).fade(0.8)),
      borderTopColor: "".concat(variables.colors.greyFour),
      borderRadius: '50%',
      animation: 'spin 1s ease-in-out infinite',
      '&:before': {
        transition: 'unset',
        background: 'unset'
      },
      '&:hover:before': {
        transition: 'unset',
        background: 'unset'
      }
    },
    button: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      fontFamily: variables.fontFamily,
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '1em 2em',
      overflow: 'hidden',
      position: 'relative',
      outline: 'none',
      borderRadius: 3,
      cursor: 'pointer',
      fontWeight: 700,
      transition: 'all 0.1s ease-out',
      '& svg': {
        display: 'inline-block',
        marginRight: '0.5em'
      }
    }),
    "default": {
      extend: 'button',
      composes: 'Button Button--default',
      border: "".concat(variables.colors.greyTwo, " ").concat(variables.border, " solid"),
      backgroundColor: 'transparent',
      color: variables.colors.text,
      '& .Button__loader-inner': {
        borderColor: "".concat(color(variables.colors.greyThree).fade(0.8)),
        borderTopColor: "".concat(variables.colors.greyFour)
      },
      '&:hover, &:active, &:focus': {
        border: "".concat(variables.colors.greyTwo, " ").concat(variables.border, " solid"),
        boxShadow: "0px 0px 0px 3px ".concat(color(variables.colors.greyFour).fade(0.8))
      },
      '&$loading': {
        border: "".concat(variables.colors.greyTwo, " ").concat(variables.border, " solid"),
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    primary: {
      extend: 'button',
      composes: 'Button Button--primary',
      border: "".concat(variables.colors.primaryAccent, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.primary,
      color: variables.colors.light,
      '&:hover, &:active, &:focus': {
        backgroundColor: variables.colors.primaryAccent,
        boxShadow: "0px 0px 0px 3px ".concat(color(variables.colors.primary).fade(0.8))
      },
      '& .Button__loader-inner': {
        borderColor: "".concat(variables.colors.primaryAccent),
        borderTopColor: "".concat(variables.colors.light)
      },
      '&$loading': {
        border: "".concat(variables.colors.primaryAccent, " ").concat(variables.border, " solid"),
        backgroundColor: variables.colors.primary,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    secondary: {
      extend: 'button',
      composes: ' Button Button--secondary',
      border: "".concat(variables.colors.secondaryAccent, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.secondary,
      color: variables.colors.light,
      '& .Button__loader-inner': {
        borderColor: "".concat(variables.colors.borderColor),
        borderTopColor: "".concat(variables.colors.light)
      },
      '&:hover, &:active, &:focus': {
        backgroundColor: variables.colors.secondaryAccent,
        boxShadow: "0px 0px 0px 3px ".concat(color(variables.colors.secondary).fade(0.8))
      },
      '&$loading': {
        backgroundColor: variables.colors.secondary,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    success: {
      extend: 'button',
      composes: 'Button Button--success',
      border: "".concat(variables.colors.typeSuccess, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.typeSuccess,
      color: variables.colors.light,
      '& .Button__loader-inner': {
        borderColor: "".concat(color(variables.colors.typeSuccess).lighten(0.2)),
        borderTopColor: "".concat(variables.colors.light)
      },
      '&:hover, &:active, &:focus': {
        border: "".concat(variables.colors.typeSuccess, " ").concat(variables.border, " solid"),
        backgroundColor: "".concat(color(variables.colors.typeSuccess).lighten(0.1)),
        boxShadow: "0px 0px 0px 3px ".concat(color(variables.colors.typeSuccess).fade(0.7))
      },
      '&$loading': {
        border: "".concat(variables.colors.typeSuccess, " ").concat(variables.border, " solid"),
        backgroundColor: variables.colors.typeSuccess,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    info: {
      extend: 'button',
      composes: 'Button Button--info',
      border: "".concat(variables.colors.typeInfo, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.typeInfo,
      color: variables.colors.light,
      '& .Button__loader-inner': {
        borderColor: "".concat(color(variables.colors.typeInfo).lighten(0.2)),
        borderTopColor: "".concat(variables.colors.light)
      },
      '&:hover, &:active, &:focus': {
        backgroundColor: "".concat(color(variables.colors.typeInfo).lighten(0.1)),
        boxShadow: "0px 0px 0px 3px ".concat(color(variables.colors.typeInfo).fade(0.8))
      },
      '&$loading': {
        border: "".concat(variables.colors.typeInfo, " ").concat(variables.border, " solid"),
        backgroundColor: variables.colors.typeInfo,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    warning: {
      extend: 'button',
      composes: 'Button Button--warning',
      border: "".concat(variables.colors.typeWarning, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.typeWarning,
      color: variables.colors.dark,
      '& .Button__loader-inner': {
        borderColor: "".concat(color(variables.colors.typeWarning).lighten(0.2)),
        borderTopColor: "".concat(variables.colors.light)
      },
      '&:hover, &:active, &:focus': {
        backgroundColor: "".concat(color(variables.colors.typeWarning).lighten(0.1)),
        boxShadow: "0px 0px 0px 3px ".concat(color(variables.colors.typeWarning).fade(0.8))
      },
      '&$loading': {
        border: "".concat(variables.colors.typeWarning, " ").concat(variables.border, " solid"),
        backgroundColor: variables.colors.typeWarning,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    danger: {
      extend: 'button',
      composes: 'Button Button--danger',
      border: "".concat(variables.colors.typeDanger, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.typeDanger,
      color: variables.colors.light,
      '& .Button__loader-inner': {
        borderColor: color(variables.colors.typeDanger).lighten(0.1),
        borderTopColor: "".concat(variables.colors.light)
      },
      '&:hover, &:active, &:focus': {
        backgroundColor: "".concat(color(variables.colors.typeDanger).lighten(0.1)),
        boxShadow: "0px 0px 0px 3px ".concat(color(variables.colors.typeDanger).fade(0.8))
      },
      '&$loading': {
        border: "".concat(variables.colors.typeDanger, " ").concat(variables.border, " solid"),
        backgroundColor: variables.colors.typeDanger,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    disabled: {
      cursor: 'default',
      extend: 'default',
      backgroundColor: "".concat(color(variables.colors.typeDefault).desaturate(0.5)),
      border: "".concat(color(variables.colors.typeDefault).desaturate(0.5), " ").concat(variables.border, " solid"),
      color: variables.colors.light,
      '& $title': {
        color: "".concat(color(variables.colors.dark).fade(0.2))
      },
      '&:hover, &:active, &:focus': {
        backgroundColor: "".concat(color(variables.colors.typeDefault).desaturate(0.5)),
        border: "".concat(color(variables.colors.typeDefault).desaturate(0.5), " ").concat(variables.border, " solid"),
        boxShadow: 'unset'
      },
      '&$loading': {
        backgroundColor: "".concat(color(variables.colors.typeDefault).desaturate(0.5)),
        border: "".concat(color(variables.colors.typeDefault).desaturate(0.5), " ").concat(variables.border, " solid"),
        boxShadow: 'unset'
      }
    },
    title: {
      display: 'block',
      transition: 'opacity 0.2s ease-out'
    },
    large: {
      composes: ' Button Button--large',
      padding: '1em 1.75em'
    },
    medium: {
      composes: ' Button Button--medium',
      padding: '0.75em 1.5em'
    },
    small: {
      composes: ' Button Button--small',
      padding: '0.25em 0.75em'
    }
  };
};

var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function () {
      return !_this.props.disabled && !_this.props.loading && _this.props.onClick();
    });

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          classes = _this$props.classes,
          dataAction = _this$props.dataAction,
          disabled = _this$props.disabled,
          loading = _this$props.loading,
          size = _this$props.size,
          testId = _this$props.testId,
          type = _this$props.type,
          variant = _this$props.variant,
          ariaLabel = _this$props.ariaLabel;
      return /*#__PURE__*/React.createElement("button", {
        className: classNames$1(classes[variant], classes[size], (_classNames = {}, _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.loading, loading), _defineProperty(_classNames, className, true), _classNames)),
        "data-action": dataAction,
        "data-test": createTestId(testId),
        disabled: disabled,
        type: type,
        "aria-label": ariaLabel,
        onClick: this.handleOnClick
      }, loading && /*#__PURE__*/React.createElement("span", {
        className: classes.loader
      }, /*#__PURE__*/React.createElement("span", {
        "data-test": createTestId(testId, 'isLoading'),
        className: classes.loaderInner
      })), /*#__PURE__*/React.createElement("span", {
        "data-test": createTestId(testId, 'text'),
        className: classes.title
      }, children));
    }
  }]);

  return Button;
}(Component);

Button.displayName = "Button";

_defineProperty(Button, "propTypes", {
  ariaLabel: PropTypes.string,
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.string,
  dataAction: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  testId: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  variant: PropTypes.oneOf(['danger', 'default', 'info', 'primary', 'secondary', 'success', 'warning'])
});

_defineProperty(Button, "defaultProps", {
  ariaLabel: '',
  children: null,
  classes: {},
  className: '',
  dataAction: null,
  disabled: false,
  loading: false,
  onClick: noop,
  size: 'medium',
  testId: '',
  type: 'button',
  variant: 'default'
});

var Button$1 = withStyles(styles$3)(Button);

var styles$4 = function styles(_ref) {
  var variables = _ref.variables,
      mixins = _ref.mixins;
  var stylesheet = {
    form: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'Form',
      transition: 'all 0.2s ease-in'
    }),
    fieldset: {
      composes: 'Fieldset',
      margin: '1.5rem 0',
      border: 'none',
      padding: '0'
    },
    legend: {
      composes: 'Legend',
      color: variables.colors.text,
      display: 'block',
      fontSize: '1em',
      fontWeight: 700,
      textTransform: 'uppercase'
    }
  };
  return stylesheet;
};

var FormFieldset = function FormFieldset(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      testId = _ref.testId,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("fieldset", {
    "data-test": createTestId(testId),
    className: "".concat(classes.fieldset, " ").concat(className !== null && className !== void 0 ? className : '')
  }, children);
};

FormFieldset.displayName = "FormFieldset";
FormFieldset.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  classes: PropTypes.object,
  className: PropTypes.string,
  testId: PropTypes.string
};
FormFieldset.defaultProps = {
  children: null,
  classes: {},
  className: null,
  testId: null
};
var FormFieldset$1 = withStyles(styles$4)(FormFieldset);

var FormLegend = function FormLegend(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      testId = _ref.testId,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("legend", {
    "data-test": createTestId(testId),
    className: "".concat(classes.legend, " ").concat(className !== null && className !== void 0 ? className : '')
  }, children);
};

FormLegend.displayName = "FormLegend";
FormLegend.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  classes: PropTypes.object,
  className: PropTypes.string,
  testId: PropTypes.string
};
FormLegend.defaultProps = {
  children: null,
  classes: {},
  className: null,
  testId: null
};
var FormLegend$1 = withStyles(styles$4)(FormLegend);

var Form = function Form(_ref) {
  var classes = _ref.classes,
      id = _ref.id,
      onSubmit = _ref.onSubmit,
      children = _ref.children,
      testId = _ref.testId,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("form", {
    "data-test": createTestId(testId),
    className: "".concat(classes.form, " ").concat(className !== null && className !== void 0 ? className : ''),
    id: id,
    onSubmit: onSubmit
  }, children);
};

Form.displayName = "Form";
Form.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  classes: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSubmit: PropTypes.func.isRequired,
  testId: PropTypes.string
};
Form.defaultProps = {
  children: null,
  classes: {},
  className: null,
  id: null,
  testId: null
};
var WrappedForm = withStyles(styles$4)(Form);
WrappedForm.Fieldset = FormFieldset$1;
WrappedForm.Legend = FormLegend$1;

var styles$5 = function styles(_ref) {
  var _objectSpread2$1;

  var variables = _ref.variables,
      breakpoints = _ref.breakpoints;
  return {
    hello: _objectSpread2(_objectSpread2({
      composes: 'Hello',
      extend: variables.baseMobile
    }, variables.type.h1), {}, (_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, breakpoints.lg, _objectSpread2({
      extend: variables.baseDesktop
    }, variables.type.h1)), _defineProperty(_objectSpread2$1, "fontFamily", variables.fontFamily), _defineProperty(_objectSpread2$1, "color", variables.colors.primary), _objectSpread2$1))
  };
};

var Hello = function Hello(_ref) {
  var classes = _ref.classes,
      greeting = _ref.greeting,
      name = _ref.name,
      suffix = _ref.suffix;
  var hello = name ? "".concat(greeting, ", ").concat(name).concat(suffix) : "".concat(greeting).concat(suffix);
  return /*#__PURE__*/React.createElement("p", {
    className: classes.hello
  }, hello);
};

Hello.displayName = "Hello";
Hello.propTypes = {
  classes: PropTypes.object,
  greeting: PropTypes.string,
  name: PropTypes.string,
  suffix: PropTypes.string
};
Hello.defaultProps = {
  classes: {},
  greeting: 'Hi',
  name: '',
  suffix: '!'
};
var Hello$1 = withStyles(styles$5)(Hello);

var ICON_LOGOUT = 'iconLogout';
var ICON_BOOKINGS = 'iconBookings';
var ICON_NOTIFICATIONS = 'iconNotifications';
var ICON_PROFILE = 'iconProfile';
var ICON_CHEVRON_RIGHT = 'iconChevronRight';
var ICON_TICKET = 'iconTicket';
var ICON_ACCOMMODATION = 'iconAccommodation';
var ICON_EXTRA = 'iconExtra';
var ICON_MENU = 'iconMenu';
var ICON_CLOSE = 'iconClose';
var ICON_DELIVERY = 'iconDelivery';
var ICON_BARCODE = 'iconBarcode';
var ICON_CUSTOMER = 'iconCustomer';
var ICON_SORT = 'iconSort';
var ICON_SORT_UP = 'iconSortUp';
var ICON_SORT_DOWN = 'iconSortDown';
var ICON_THUMBS_UP = 'iconThumbsUp';
var ICON_WARNING = 'iconWarning';
var ICON_INFO = 'iconInfo';
var ICON_EYE = 'iconEye';
var ICON_EYE_SLASH = 'iconEyeSlash';
var ICON_CHECK = 'iconCheck';
var ICON_PLUS = 'iconPlus';

var _RESALE_MESSAGES;

var RESALABLE = 1;
var RESALE_ENABLED = 2;
var RESALE_SOLD = 3;
var RESALE_MESSAGES = (_RESALE_MESSAGES = {}, _defineProperty(_RESALE_MESSAGES, RESALABLE, 'Available for Resale'), _defineProperty(_RESALE_MESSAGES, RESALE_ENABLED, 'On Resale'), _defineProperty(_RESALE_MESSAGES, RESALE_SOLD, 'Resold'), _RESALE_MESSAGES);

var styles$6 = function styles(_ref) {
  var variables = _ref.variables;
  return {
    icon: _objectSpread2({
      composes: 'Icon'
    }, variables.type.p)
  };
};

var Icon = /*#__PURE__*/function (_PureComponent) {
  _inherits(Icon, _PureComponent);

  var _super = _createSuper(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          classes = _this$props.classes,
          className = _this$props.className;
      return Icon.getIcon(icon) && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        className: "".concat(classes.icon, " ").concat(className !== null && className !== void 0 ? className : ''),
        icon: Icon.getIcon(icon)
      }) || '';
    }
  }], [{
    key: "getIcon",
    value: function getIcon(icon) {
      var _iconMappings;

      var iconMappings = (_iconMappings = {}, _defineProperty(_iconMappings, ICON_LOGOUT, faSignOutAlt), _defineProperty(_iconMappings, ICON_BOOKINGS, faCalendarDay), _defineProperty(_iconMappings, ICON_NOTIFICATIONS, faBell), _defineProperty(_iconMappings, ICON_PROFILE, faUser), _defineProperty(_iconMappings, ICON_CHEVRON_RIGHT, faAngleRight), _defineProperty(_iconMappings, ICON_TICKET, faTicketAlt), _defineProperty(_iconMappings, ICON_ACCOMMODATION, faHome), _defineProperty(_iconMappings, ICON_EXTRA, faPlusCircle), _defineProperty(_iconMappings, ICON_MENU, faBars), _defineProperty(_iconMappings, ICON_CLOSE, faTimes), _defineProperty(_iconMappings, ICON_DELIVERY, faBoxOpen), _defineProperty(_iconMappings, ICON_BARCODE, faBarcode), _defineProperty(_iconMappings, ICON_CUSTOMER, faUser), _defineProperty(_iconMappings, ICON_SORT, faSort), _defineProperty(_iconMappings, ICON_SORT_DOWN, faSortDown), _defineProperty(_iconMappings, ICON_SORT_UP, faSortUp), _defineProperty(_iconMappings, ICON_THUMBS_UP, faThumbsUp), _defineProperty(_iconMappings, ICON_WARNING, faExclamationTriangle), _defineProperty(_iconMappings, ICON_INFO, faInfoCircle), _defineProperty(_iconMappings, ICON_EYE, faEye), _defineProperty(_iconMappings, ICON_EYE_SLASH, faEyeSlash), _defineProperty(_iconMappings, ICON_CHECK, faCheck), _defineProperty(_iconMappings, ICON_PLUS, faPlus), _iconMappings);
      return iconMappings[icon];
    }
  }]);

  return Icon;
}(PureComponent);

Icon.displayName = "Icon";

_defineProperty(Icon, "propTypes", {
  classes: PropTypes.object,
  className: PropTypes.string,
  icon: PropTypes.string.isRequired
});

_defineProperty(Icon, "defaultProps", {
  classes: {},
  className: null
});

var Icon$1 = withStyles(styles$6)(Icon);

var styles$7 = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    inputField: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'InputField',
      display: 'block'
    }),
    valid: {
      composes: 'InputField InputField--valid',
      extend: 'inputField',
      '& $input': {
        borderColor: variables.colors.primaryAccent,
        '&:hover, :focus, :active': {
          borderColor: variables.colors.primaryAccent
        }
      }
    },
    invalid: {
      composes: 'InputField InputField--invalid',
      extend: 'inputField',
      '& $input': {
        borderColor: variables.colors.typeDanger,
        '&:hover, :focus, :active': {
          borderColor: variables.colors.typeDanger
        }
      }
    },
    disabled: {
      composes: 'InputField InputField--disabled',
      extend: 'inputField',
      '& $input': {
        border: "1px solid ".concat(variables.colors.greyTwo),
        backgroundColor: variables.colors.greyOne,
        cursor: 'not-allowed',
        '&:hover, &:focus, &:active': {
          borderColor: variables.colors.greyTwo
        }
      }
    },
    required: {
      composes: 'InputField__required',
      color: 'red'
    },
    label: {
      composes: 'InputField__label',
      display: 'block',
      color: 'grey',
      marginBottom: '0.5em'
    },
    inputContainer: {
      display: 'flex',
      position: 'relative'
    },
    input: {
      composes: 'InputField__input',
      appearance: 'none',
      border: "1px solid ".concat(variables.colors.greyTwo),
      padding: '0.5em',
      width: '100%',
      display: 'block',
      color: '#333',
      transition: 'border 0.2s ease-in-out',
      '&:hover, &:focus, &:active': {
        border: "1px solid ".concat(variables.colors.greyFour),
        outline: 'none'
      }
    },
    error: {
      composes: 'InputField__error',
      display: 'block',
      fontSize: '0.8em',
      padding: '0.5em',
      backgroundColor: variables.colors.typeDanger,
      color: variables.colors.light,
      marginTop: '0.25em'
    }
  };
};

var InputField = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputField, _PureComponent);

  var _super = _createSuper(InputField);

  function InputField() {
    var _this;

    _classCallCheck(this, InputField);

    for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(props));

    _defineProperty(_assertThisInitialized(_this), "getInputState", function () {
      if (_this.props.disabled) {
        return _this.props.classes.disabled;
      } else if (_this.props.errors.length) {
        return _this.props.classes.invalid;
      } else if (_this.props.valid && !_this.props.errors.length) {
        return _this.props.classes.valid;
      }

      return _this.props.classes.inputField;
    });

    _defineProperty(_assertThisInitialized(_this), "formatValue", function (value) {
      return _this.props.valueFormatter ? _this.props.valueFormatter(value) : value;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.props.onChange(_this.formatValue(event.target.value));

      _this.setState({
        value: _this.formatValue(event.target.value)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      _this.props.onBlur(_this.formatValue(event.target.value));
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      _this.props.onFocus(_this.formatValue(event.target.value));
    });

    _this.state = {
      value: _this.props.value ? _this.props.value : _this.props.defaultValue
    };
    return _this;
  }

  _createClass(InputField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          required = _this$props.required,
          type = _this$props.type,
          id = _this$props.id,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          classes = _this$props.classes,
          errors = _this$props.errors,
          maxLength = _this$props.maxLength,
          className = _this$props.className,
          testId = _this$props.testId,
          suffix = _this$props.suffix,
          passwordrules = _this$props.passwordrules;
      var optionalProps = {
        disabled: disabled,
        maxLength: maxLength,
        placeholder: placeholder,
        passwordrules: passwordrules
      };
      var value = this.state.value;
      return /*#__PURE__*/React.createElement("div", {
        "data-test": createTestId(testId),
        className: "".concat(this.getInputState(), " ").concat(className !== null && className !== void 0 ? className : '')
      }, /*#__PURE__*/React.createElement("label", {
        className: classes.label,
        htmlFor: id
      }, label, required && /*#__PURE__*/React.createElement("span", {
        "data-test": createTestId(testId, 'label'),
        className: classes.required
      }, "*")), /*#__PURE__*/React.createElement("span", {
        className: classes.inputContainer
      }, /*#__PURE__*/React.createElement("input", _extends({
        "data-test": createTestId(testId, 'input'),
        className: classes.input,
        type: type,
        id: id,
        name: id,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        value: value
      }, optionalProps)), suffix), errors.map(function (error) {
        return /*#__PURE__*/React.createElement("span", {
          key: error,
          className: classes.error
        }, error);
      }));
    }
  }]);

  return InputField;
}(PureComponent);

InputField.displayName = "InputField";

_defineProperty(InputField, "propTypes", {
  classes: PropTypes.object,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  passwordrules: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  suffix: PropTypes.node,
  testId: PropTypes.string,
  type: PropTypes.string,
  valid: PropTypes.bool,
  value: PropTypes.string,
  valueFormatter: PropTypes.func
});

_defineProperty(InputField, "defaultProps", {
  classes: {},
  className: null,
  defaultValue: '',
  disabled: false,
  errors: [],
  maxLength: null,
  onBlur: noop,
  onFocus: noop,
  passwordrules: null,
  placeholder: '',
  required: false,
  suffix: null,
  testId: null,
  type: 'text',
  valid: null,
  value: null,
  valueFormatter: null
});

var InputField$1 = withStyles(styles$7)(InputField);

var styles$8 = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    '@global': {
      '@keyframes spinner': {
        to: {
          transform: 'rotate(360deg)'
        }
      }
    },
    loader: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'Loader',
      position: 'absolute',
      zIndex: '600',
      top: '0',
      left: '0',
      bottom: '0',
      backgroundColor: "".concat(color(variables.colors.light).fade(0.2)),
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      width: '100%',
      height: '100%'
    }),
    wrapLoader: {
      composes: 'WrapLoader',
      position: 'relative'
    },
    components: {
      composes: 'WrapLoader__components',
      opacity: '0.8',
      '& *': {
        fontFamily: 'Redacted'
      }
    },
    inner: {
      textAlign: 'center'
    },
    spinner: {
      display: 'inline-block',
      width: "3em",
      height: "3em",
      border: "3px solid ".concat(variables.colors.greyTwo),
      borderRadius: '50%',
      borderTopColor: variables.colors.greyFive,
      animation: 'spinner 1s ease-in-out infinite'
    },
    message: {
      marginTop: '0.5em',
      display: 'block',
      color: variables.colors.dark
    }
  };
};

var Loader = function Loader(_ref) {
  var hide = _ref.hide,
      message = _ref.message,
      classes = _ref.classes,
      testId = _ref.testId,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hide && /*#__PURE__*/React.createElement("span", {
    "data-test": createTestId(testId),
    className: "".concat(classes.loader, " ").concat(className !== null && className !== void 0 ? className : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.inner
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.spinner
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.message
  }, message))));
};

Loader.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  hide: PropTypes.bool,
  message: PropTypes.string,
  testId: PropTypes.string
};
Loader.defaultProps = {
  classes: {},
  className: null,
  hide: false,
  message: '',
  testId: null
};
var Loader$1 = withStyles(styles$8)(Loader);

var styles$9 = function styles(_ref) {
  var variables = _ref.variables,
      mixins = _ref.mixins;
  return {
    menuEntry: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'MenuEntry',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: variables.colors.greyOne,
      padding: '1.5em',
      lineHeight: '1.4',
      borderBottom: '1px solid #ededed',
      color: '#4a4a4a',
      cursor: 'pointer',
      '&:hover': {
        transition: '100ms linear background-color',
        backgroundColor: color(variables.colors.greyOne).darken(0.03).string()
      },
      '&:last-child': {
        border: 'none'
      },
      '& .Icon': {
        fontSize: '1.7em'
      }
    })
  };
};

var MenuEntry = function MenuEntry(_ref) {
  var children = _ref.children,
      classes = _ref.classes;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.menuEntry
  }, /*#__PURE__*/React.createElement("div", null, children), /*#__PURE__*/React.createElement(Icon$1, {
    icon: ICON_CHEVRON_RIGHT
  }));
};

MenuEntry.displayName = "MenuEntry";
MenuEntry.propTypes = {
  children: PropTypes.any.isRequired,
  classes: PropTypes.object
};
MenuEntry.defaultProps = {
  classes: {}
};
var MenuEntry$1 = withStyles(styles$9)(MenuEntry);

var Menu = function Menu(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "Menu"
  }, children);
};

Menu.displayName = "Menu";
Menu.propTypes = {
  children: PropTypes.any
};
Menu.defaultProps = {
  children: []
};

var styles$a = (function (_ref) {
  var breakpoints = _ref.breakpoints;
  return {
    actions: _defineProperty({
      composes: 'MessageActions',
      display: 'flex',
      flexDirection: 'column',
      marginTop: '0.5em',
      width: '100%'
    }, breakpoints.lg, {
      width: 'auto',
      flexDirection: 'row',
      marginTop: 0,
      marginLeft: '0.5em',
      alignItems: 'stretch',
      flexShrink: 0
    }),
    action: _defineProperty({
      composes: 'MessageActions__action',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      '& + &': _defineProperty({
        marginTop: '1em'
      }, breakpoints.lg, {
        marginTop: 0,
        marginLeft: '0.5em'
      })
    }, breakpoints.lg, {
      width: 'auto',
      flexDirection: 'row'
    })
  };
});

var MessageActions = function MessageActions(_ref) {
  var children = _ref.children,
      classes = _ref.classes;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.action
    }, child);
  }));
};

MessageActions.displayName = "MessageActions";
MessageActions.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object.isRequired
};
MessageActions.defaultProps = {
  children: null
};
var MessageActions$1 = withStyles(styles$a)(MessageActions);

var styles$b = (function (_ref) {
  var breakpoints = _ref.breakpoints,
      mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    content: _defineProperty({
      extend: mixins.init(),
      lineHeight: '1.2',
      composes: 'MessageContent',
      color: variables.colors.text,
      textAlign: 'center'
    }, breakpoints.lg, {
      lineHeight: '1.2',
      flexGrow: 1,
      textAlign: 'left'
    })
  };
});

var MessageContent = function MessageContent(_ref) {
  var children = _ref.children,
      classes = _ref.classes;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, children);
};

MessageContent.displayName = "MessageContent";
MessageContent.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object.isRequired
};
MessageContent.defaultProps = {
  children: null
};
var MessageContent$1 = withStyles(styles$b)(MessageContent);

var styles$c = (function (_ref) {
  var breakpoints = _ref.breakpoints,
      variables = _ref.variables;
  return {
    message: _defineProperty({
      composes: 'Message',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '0.5em 0.5em 0.5em 1em',
      color: variables.colors.text,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: 0
    }, breakpoints.lg, {
      flexDirection: 'row'
    }),
    'message-danger': {
      composes: 'Message--danger',
      borderColor: variables.colors.typeDanger
    },
    'message-info': {
      composes: 'Message--info',
      borderColor: variables.colors.typeInfo
    },
    'message-success': {
      composes: 'Message--success',
      borderColor: variables.colors.typeSuccess
    },
    'message-warning': {
      composes: 'Message--warning',
      borderColor: variables.colors.typeWarning
    },
    'message-default': {
      composes: 'Message--default',
      borderColor: variables.colors.typeDefault
    },
    icon: _defineProperty({
      composes: 'Message__icon',
      fontSize: '1.5em',
      marginBottom: '0.5em'
    }, breakpoints.lg, {
      marginBottom: 0,
      marginRight: '0.5em'
    }),
    'icon-danger': {
      composes: 'Message__icon--danger',
      color: variables.colors.typeDanger
    },
    'icon-info': {
      composes: 'Message__icon--info',
      color: variables.colors.typeInfo
    },
    'icon-success': {
      composes: 'Message__icon--success',
      color: variables.colors.typeSuccess
    },
    'icon-warning': {
      composes: 'Message__icon--warning',
      color: variables.colors.typeWarning
    },
    'icon-default': {
      composes: 'Message__icon--default',
      color: variables.colors.typeDefault
    }
  };
});

var Message = function Message(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      variant = _ref.variant,
      icon = _ref.icon,
      className = _ref.className,
      testId = _ref.testId;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId),
    className: classNames$1(classes.message, className, classes["message-".concat(variant)])
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: classNames$1(classes.icon, classes["icon-".concat(variant)])
  }, /*#__PURE__*/React.createElement(Icon$1, {
    icon: icon
  })), children);
};

Message.displayName = "Message";
Message.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  icon: PropTypes.string,
  testId: PropTypes.string,
  variant: PropTypes.oneOf(['danger', 'info', 'success', 'warning', 'default']).isRequired
};
Message.defaultProps = {
  children: null,
  className: null,
  icon: '',
  testId: null
};
var WrappedMessage = withStyles(styles$c)(Message); // Make message sub-components accessible via Message.*.

WrappedMessage.Actions = MessageActions$1;
WrappedMessage.Content = MessageContent$1;

var formatPrice = function formatPrice(currencySymbol, value, currencyExponent) {
  return (value < 0 ? '-' : '') + currencySymbol + parseFloat(Math.abs(value)).toFixed(currencyExponent);
};

var styles$d = function styles(_ref) {
  var mixins = _ref.mixins;
  return {
    price: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'Price',
      display: 'flex',
      flexDirection: 'column'
    }),
    label: {
      composes: 'Price__label',
      color: '#666',
      lineHeight: '1.2'
    },
    value: {
      composes: 'Price__value',
      fontSize: '1.3em',
      lineHeight: '1.2',
      fontWeight: 'bold'
    }
  };
};

var defaultContext = {
  currencyExponent: 2,
  currencySymbol: '£'
};

var UIContext = /*#__PURE__*/React.createContext(defaultContext);

var withUI = function withUI(Component) {
  var UIComponent = function UIComponent(props) {
    return /*#__PURE__*/React.createElement(UIContext.Consumer, null, function (contexts) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, contexts));
    });
  };

  UIComponent.displayName = "withUI(".concat(Component.displayName || Component.name, ")");
  return UIComponent;
};

var Price = function Price(_ref) {
  var label = _ref.label,
      value = _ref.value,
      currencyExponent = _ref.currencyExponent,
      currencySymbol = _ref.currencySymbol,
      classes = _ref.classes,
      className = _ref.className,
      testId = _ref.testId;
  var price = formatPrice(currencySymbol, value, currencyExponent);
  return /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId),
    className: "".concat(classes.price, " ").concat(className !== null && className !== void 0 ? className : '')
  }, label && /*#__PURE__*/React.createElement("span", {
    className: classes.label
  }, label), /*#__PURE__*/React.createElement("span", {
    className: classes.value
  }, price));
};

Price.displayName = "Price";
Price.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  currencyExponent: PropTypes.number.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  label: PropTypes.string,
  testId: PropTypes.string,
  value: PropTypes.number.isRequired
};
Price.defaultProps = {
  classes: {},
  className: null,
  label: null,
  testId: null
};
var Price$1 = withStyles(styles$d)(withUI(Price));

var styles$e = function styles(_ref) {
  var variables = _ref.variables,
      mixins = _ref.mixins;
  return {
    prompt: _objectSpread2(_objectSpread2(_objectSpread2({}, mixins.init()), mixins.box()), {}, {
      composes: 'Prompt',
      border: "1px solid ".concat(variables.colors.greyTwo),
      borderRadius: '0.2rem',
      maxWidth: '40em'
    }),
    overlay: {
      composes: 'PromptOverlay',
      backgroundColor: color(variables.colors.trueWhite).fade(0.2).string(),
      width: '100vw',
      height: '100vh',
      position: 'absolute',
      left: '0',
      top: '0',
      zIndex: 100,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    header: {
      composes: 'Prompt__header',
      borderBottom: '1px solid #eee',
      color: variables.colors.greyFive,
      backgroundColor: variables.colors.light,
      padding: '1em'
    },
    body: _objectSpread2(_objectSpread2({}, variables.type.p), {}, {
      composes: 'Prompt__body',
      padding: '2em 1.5em'
    }),
    actions: {
      composes: 'Prompt__actions',
      padding: '0.8em 1em',
      borderTop: '1px solid #eee',
      textAlign: 'right',
      '& .Button': {
        marginRight: '0.5em',
        '&:last-child': {
          marginRight: '0'
        }
      }
    },
    center: {
      display: 'flex',
      justifyContent: 'center'
    }
  };
};

var Prompt = /*#__PURE__*/function (_Component) {
  _inherits(Prompt, _Component);

  var _super = _createSuper(Prompt);

  function Prompt() {
    var _this;

    _classCallCheck(this, Prompt);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      if (!_this.node.contains(event.target)) {
        _this.props.onClickOutside();
      }
    });

    return _this;
  }

  _createClass(Prompt, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClick, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClick, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          header = _this$props.header,
          children = _this$props.children,
          actions = _this$props.actions,
          testId = _this$props.testId,
          className = _this$props.className;
      var component = /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.overlay, " ").concat(className),
        "data-test": createTestId(testId)
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.prompt,
        ref: function ref(node) {
          return _this2.node = node;
        }
      }, header && /*#__PURE__*/React.createElement("div", {
        "data-test": createTestId(testId, 'header'),
        className: classes.header
      }, header), children && /*#__PURE__*/React.createElement("div", {
        "data-test": createTestId(testId, 'body'),
        className: classes.body
      }, children), actions.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.actions, " ").concat(actions.length === 1 ? classes.center : '')
      }, actions.map(function (action) {
        return /*#__PURE__*/React.createElement(Button$1, {
          "data-test": createTestId(testId, action.type + action.text),
          key: action.type + action.text,
          variant: action.type,
          onClick: action.onClick || noop
        }, action.text);
      }))));

      if (actions.length > 0) {
        return /*#__PURE__*/React.createElement(FocusTrap, null, component);
      }

      return component;
    }
  }]);

  return Prompt;
}(Component);

Prompt.displayName = "Prompt";

_defineProperty(Prompt, "propTypes", {
  actions: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.string,
    onClick: PropTypes.func
  })),
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.string,
  header: PropTypes.string,
  onClickOutside: PropTypes.func,
  testId: PropTypes.string
});

_defineProperty(Prompt, "defaultProps", {
  actions: [],
  children: null,
  classes: {},
  className: null,
  header: null,
  onClickOutside: noop,
  testId: null
});

var Prompt$1 = withStyles(styles$e)(Prompt);

var styles$f = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    select: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'Select',
      display: 'block',
      '& .Select__input': {
        outline: 'none'
      },
      '& .Select__control': {
        border: "1px solid ".concat(variables.colors.greyThree),
        boxShadow: 'none',
        borderRadius: '0',
        color: variables.colors.dark,
        '&:hover, &--is-focused': {
          border: "1px solid ".concat(variables.colors.greyFour)
        },
        '&--is-disabled': {
          backgroundColor: variables.colors.greyOne,
          border: "1px solid ".concat(variables.colors.greyTwo)
        }
      },
      '& .Select__menu': {
        borderRadius: '0',
        marginTop: '0'
      },
      '& .Select__option': {
        cursor: 'pointer',
        '&:hover, &--is-focused': {
          backgroundColor: variables.colors.greyOne
        },
        '&--is-selected, &--is-selected:hover': {
          backgroundColor: variables.colors.primaryAccent,
          cursor: 'auto'
        }
      }
    }),
    wrapper: {
      composes: 'Select__wrapper',
      outline: 'none'
    },
    label: {
      composes: 'Select__label',
      display: 'block',
      color: variables.colors.dark,
      marginBottom: '0.5em'
    },
    required: {
      composes: 'Select__required',
      color: variables.colors.typeDanger
    },
    error: {
      composes: 'Select__error',
      display: 'block',
      fontSize: '0.8em',
      padding: '0.5em',
      backgroundColor: variables.colors.typeDanger,
      color: variables.colors.light,
      marginTop: '0.25em'
    }
  };
};

/* eslint no-undef: "off", max-lines-per-function: "off" */

var WrappedSelect = function WrappedSelect(_ref) {
  var label = _ref.label,
      placeholder = _ref.placeholder,
      options = _ref.options,
      defaultValue = _ref.defaultValue,
      required = _ref.required,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      searchable = _ref.searchable,
      disabled = _ref.disabled,
      errors = _ref.errors,
      classes = _ref.classes,
      testId = _ref.testId,
      className = _ref.className,
      value = _ref.value;

  var TextOption = function TextOption(props) {
    return components.Option &&
    /*#__PURE__*/
    // eslint-disable-next-line react/prop-types
    React.createElement(components.Option, props, props.label);
  };

  var addTestAttribute = function addTestAttribute(Component) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return function (props) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        innerProps: _objectSpread2(_objectSpread2({}, props.innerProps), {}, {
          // eslint-disable-next-line react/prop-types
          'data-test': createTestId(testId, suffix !== null && suffix !== void 0 ? suffix : props.value)
        })
      }));
    };
  };

  var CUSTOM_COMPONENTS = {
    Option: addTestAttribute(TextOption),
    Menu: addTestAttribute(components.Menu, 'menu')
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId),
    className: "".concat(classes.select, " ").concat(className !== null && className !== void 0 ? className : '')
  }, label && /*#__PURE__*/React.createElement("label", {
    "data-test": createTestId(testId, 'label'),
    className: classes.label
  }, label, required && /*#__PURE__*/React.createElement("span", {
    className: classes.required
  }, "*")), /*#__PURE__*/React.createElement(Select$1, {
    "data-test": createTestId(testId, 'select'),
    className: classes.wrapper,
    classNamePrefix: "Select",
    placeholder: placeholder,
    components: CUSTOM_COMPONENTS,
    options: options,
    defaultValue: defaultValue,
    required: required,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    isSearchable: searchable,
    isDisabled: disabled,
    value: value
  }), errors.map(function (error) {
    return /*#__PURE__*/React.createElement("span", {
      key: error,
      className: classes.error
    }, error);
  }));
};

WrappedSelect.displayName = "WrappedSelect";
WrappedSelect.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  defaultValue: PropTypes.object,
  disabled: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  searchable: PropTypes.bool,
  testId: PropTypes.string,
  value: PropTypes.object
};
WrappedSelect.defaultProps = {
  classes: {},
  className: null,
  defaultValue: null,
  disabled: false,
  errors: [],
  label: null,
  onBlur: noop,
  onChange: noop,
  onFocus: noop,
  options: [],
  placeholder: 'Please Select',
  required: false,
  searchable: true,
  testId: null,
  value: null
};
var Select = withStyles(styles$f)(WrappedSelect);

var styles$g = function styles(_ref) {
  var variables = _ref.variables;
  return {
    "switch": {
      composes: 'Switch',
      border: "2px solid ".concat(variables.colors.greyTwo),
      backgroundColor: '#fff',
      height: '1.25rem',
      width: '3rem',
      boxSizing: 'unset',
      borderRadius: "1.25rem",
      padding: '0.125rem',
      display: 'flex',
      transition: '100ms linear box-shadow',
      '&:hover': {
        boxShadow: "0 0 0 3px ".concat(color(variables.colors.greyTwo).fade(0.8).string())
      }
    },
    switchChecked: {
      extend: 'switch',
      composes: 'Switch Switch--checked',
      borderColor: variables.colors.typeSuccess,
      '&:hover': {
        boxShadow: "0 0 0 3px ".concat(color(variables.colors.typeSuccess).fade(0.9).string())
      },
      '& $slider': {
        transform: 'translateX(1.75rem)',
        backgroundColor: variables.colors.typeSuccess
      }
    },
    switchLabel: {
      composes: 'Switch__label',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    switchText: {
      composes: 'Switch__text',
      color: variables.colors.greyFive,
      fontSize: '0.95rem',
      marginRight: '0.75rem',
      userSelect: 'none',
      transition: '100ms linear color',
      '&:hover': {
        color: color(variables.colors.greyFive).darken(0.3).string()
      }
    },
    checkbox: {
      composes: 'Switch__checkbox',
      display: 'none'
    },
    slider: {
      composes: 'Switch__slider',
      height: '1.25rem',
      width: '1.25rem',
      backgroundColor: color(variables.colors.greyTwo).darken(0.1).string(),
      transition: '175ms ease-in-out all',
      display: 'inline-block',
      borderRadius: '1.25rem'
    }
  };
};

var Switch = function Switch(_ref) {
  var classes = _ref.classes,
      label = _ref.label,
      onChange = _ref.onChange,
      checked = _ref.checked,
      testId = _ref.testId,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("label", {
    "data-test": createTestId(testId),
    className: "".concat(classes.switchLabel, " ").concat(className !== null && className !== void 0 ? className : '')
  }, label && /*#__PURE__*/React.createElement("span", {
    "data-test": createTestId(testId, 'label'),
    className: classes.switchText
  }, label), /*#__PURE__*/React.createElement("div", {
    className: checked ? classes.switchChecked : classes["switch"]
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    "data-test": createTestId(testId, 'input'),
    className: classes.checkbox,
    checked: checked,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.slider
  })));
};

Switch.displayName = "Switch";
Switch.propTypes = {
  checked: PropTypes.bool,
  classes: PropTypes.shape({
    "switch": PropTypes.string,
    switchChecked: PropTypes.string,
    switchLabel: PropTypes.string,
    switchText: PropTypes.string,
    checkbox: PropTypes.string,
    slider: PropTypes.string
  }).isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  testId: PropTypes.string
};
Switch.defaultProps = {
  checked: false,
  className: null,
  label: null,
  onChange: noop,
  testId: null
};
var Switch$1 = withStyles(styles$g)(Switch);

var styles$h = (function (_ref) {
  var variables = _ref.variables;
  var stylesheet = {
    Table: {
      composes: 'Table',
      borderRadius: '2px',
      border: '1px solid #ddd',
      fontFamily: variables.fontFamily,
      color: variables.colors.primary,
      overflow: 'auto',
      position: 'relative',
      boxSizing: 'border-box',
      '&:not(&--loading)': {
        '@media (max-width: 701px)': {
          border: 'none'
        }
      },
      sortIcon: {
        composes: 'Table__sort-icon',
        marginLeft: 5,
        opacity: 0.2
      },
      sortIconActive: {
        composes: 'Table__sort-icon--active',
        opacity: 1
      }
    },
    loading: {
      composes: 'Table--loading',
      height: 150
    },
    cell: {
      composes: 'Table__cell',
      padding: '10px',
      textAlign: 'left',
      fontSize: '1.5vw',
      overflow: 'auto',
      '@media (max-width: 700px)': {
        padding: '5px',
        display: 'flex',
        justifyContent: 'space-between',
        textAlign: 'right',
        fontSize: '2.5vw',
        '&::before': {
          content: 'attr(data-column-name)',
          "float": 'left',
          paddingRight: 20
        }
      }
    },
    alignRight: {
      composes: 'Table__cell--align-right',
      textAlign: 'right'
    },
    alignCenter: {
      composes: 'Table__cell--align-center',
      textAlign: 'center'
    },
    alignLeft: {
      composes: 'Table__cell--align-left',
      textAlign: 'left'
    },
    success: {
      composes: 'Table__cell--success',
      '&:last-child': {
        color: variables.colors.typeSuccess
      },
      '&::before': {
        color: variables.colors.primary
      }
    },
    failed: {
      composes: 'Table__cell--failed',
      '&:last-child': {
        color: variables.colors.typeDanger
      },
      '&::before': {
        color: variables.colors.primary
      }
    },
    warning: {
      composes: 'Table__cell--warning',
      '&:last-child': {
        color: variables.colors.typeWarning
      },
      '&::before': {
        color: variables.colors.primary
      }
    },
    info: {
      composes: 'Table__cell--info',
      '&:last-child': {
        color: variables.colors.typeInfo
      },
      '&::before': {
        color: variables.colors.primary
      }
    },
    message: {
      composes: 'Table__cell--message',
      textAlign: 'center'
    },
    sortable: {
      composes: 'Table__cell--sortable',
      padding: 0
    },
    mobileHeading: {
      composes: 'Table__cell--heading',
      '@media (max-width: 700px)': {
        textAlign: 'left',
        fontWeight: 'bold',
        fontSize: '4vw',
        display: 'block',
        background: 'inherit',
        margin: '-10px -10px 10px 0px'
      },
      '&::before': {
        display: 'none'
      }
    },
    row: {
      composes: 'Table__row',
      backgroundColor: variables.background,
      padding: '10px',
      fontWeight: 'bold',
      overflow: 'hidden',
      '@media (max-width: 701px)': {
        display: 'block',
        fontWeight: 'normal',
        borderRadius: '2px',
        '&:not(:last-child)': {
          marginBottom: '10px',
          borderBottom: '1px solid #ddd'
        }
      }
    },
    header: {
      composes: 'Table__row--header',
      backgroundColor: 'inherit',
      fontSize: '1em',
      color: '#56787b',
      borderBottom: '1px solid #ddd',
      verticalAlign: 'bottom',
      '@media (max-width: 701px)': {
        display: 'none'
      }
    },
    table: {
      composes: 'Table__table',
      borderCollapse: 'collapse',
      width: '100%'
    },
    sortHeading: {
      composes: 'Table__sort-heading',
      alignItems: 'center',
      backgroundColor: variables.background,
      cursor: 'pointer',
      display: 'flex',
      fontWeight: 'normal',
      fontSize: '1.3vw',
      justifyContent: 'space-between',
      padding: '20px 10px',
      transition: 'background-color 0.1s',
      '@media (max-width: 701px)': {
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }
      }
    }
  };
  return stylesheet;
});

var SortIcon = function SortIcon(_ref) {
  var order = _ref.order,
      classes = _ref.classes;
  var icon = ICON_SORT;
  var active = false;

  if (order === 'ascending') {
    icon = ICON_SORT_UP;
    active = true;
  } else if (order === 'descending') {
    icon = ICON_SORT_DOWN;
    active = true;
  }

  var className = classNames$1(classes.sortIcon, _defineProperty({}, classes.sortIconActive, active));
  return /*#__PURE__*/React.createElement(Icon$1, {
    className: className,
    icon: icon
  });
};

SortIcon.displayName = "SortIcon";
SortIcon.propTypes = {
  classes: PropTypes.object,
  order: PropTypes.oneOf(['ascending', 'descending'])
};
SortIcon.defaultProps = {
  classes: {},
  order: undefined
};

var HeaderColumn = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(HeaderColumn, _React$PureComponent);

  var _super = _createSuper(HeaderColumn);

  function HeaderColumn() {
    var _this;

    _classCallCheck(this, HeaderColumn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      return _this.props.onClick();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      if (event.key !== 'Enter' && event.key !== 'Space') {
        return;
      }

      event.preventDefault();

      _this.props.onClick();
    });

    return _this;
  }

  _createClass(HeaderColumn, [{
    key: "getClassName",
    value: function getClassName() {
      var _classNames2;

      var _this$props = this.props,
          align = _this$props.align,
          className = _this$props.className,
          classes = _this$props.classes,
          sortable = _this$props.sortable;
      return classNames$1(classes.cell, (_classNames2 = {}, _defineProperty(_classNames2, classes.alignLeft, align === 'left'), _defineProperty(_classNames2, classes.alignCenter, align === 'center'), _defineProperty(_classNames2, classes.alignRight, align === 'right'), _defineProperty(_classNames2, classes.sortable, sortable), _classNames2), className);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          children = _this$props2.children,
          sortOrder = _this$props2.sortOrder,
          sortable = _this$props2.sortable,
          path = _this$props2.path,
          testId = _this$props2.testId;
      var className = this.getClassName();
      return /*#__PURE__*/React.createElement(React.Fragment, null, !sortable && /*#__PURE__*/React.createElement("th", {
        className: className,
        id: "heading"
      }, children), sortable && /*#__PURE__*/React.createElement("th", {
        className: className,
        "aria-sort": sortOrder || 'none'
      }, /*#__PURE__*/React.createElement("div", {
        "data-test": createTestId(testId, "header-".concat(path)),
        className: classes.sortHeading,
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        role: "button",
        tabIndex: "0"
      }, children, /*#__PURE__*/React.createElement(SortIcon, {
        order: sortOrder,
        classes: classes
      }))));
    }
  }]);

  return HeaderColumn;
}(React.PureComponent);

HeaderColumn.displayName = "HeaderColumn";

_defineProperty(HeaderColumn, "propTypes", {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.any,
  onClick: PropTypes.func,
  path: PropTypes.string,
  sortable: PropTypes.bool,
  sortOrder: PropTypes.oneOf(['ascending', 'descending']),
  testId: PropTypes.string
});

_defineProperty(HeaderColumn, "defaultProps", {
  align: 'left',
  children: undefined,
  classes: {},
  className: undefined,
  onClick: noop,
  path: null,
  sortable: false,
  sortOrder: undefined,
  testId: null
});

var HeaderColumn$1 = withStyles(styles$h)(HeaderColumn);

var Column = function Column(_ref) {
  var _classNames;

  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      classes = _ref.classes,
      name = _ref.name,
      isMobileHeading = _ref.isMobileHeading,
      testId = _ref.testId,
      path = _ref.path;
  var columnClassName = classNames$1(classes.cell, (_classNames = {}, _defineProperty(_classNames, classes.alignLeft, align === 'left'), _defineProperty(_classNames, classes.alignCenter, align === 'center'), _defineProperty(_classNames, classes.alignRight, align === 'right'), _defineProperty(_classNames, classes.mobileHeading, isMobileHeading), _defineProperty(_classNames, classes.success, className === 'success'), _defineProperty(_classNames, classes.failed, className === 'failed'), _defineProperty(_classNames, classes.warning, className === 'warning'), _defineProperty(_classNames, classes.info, className === 'info'), _classNames), className);
  return /*#__PURE__*/React.createElement("td", {
    className: columnClassName,
    "data-column-name": name,
    "data-test": createTestId(testId, path)
  }, children);
};

Column.displayName = "Column";
Column.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.any,
  isMobileHeading: PropTypes.bool,
  name: PropTypes.string,
  path: PropTypes.string,
  testId: PropTypes.string
};
Column.defaultProps = {
  align: 'left',
  children: undefined,
  classes: {},
  className: undefined,
  isMobileHeading: false,
  name: undefined,
  path: null,
  testId: null
};
var Column$1 = withStyles(styles$h)(Column);

var Row = function Row(_ref) {
  var classes = _ref.classes,
      columns = _ref.columns,
      showMobileHeading = _ref.showMobileHeading,
      testId = _ref.testId;
  return /*#__PURE__*/React.createElement("tr", {
    className: classes.row,
    "data-test": createTestId(testId)
  }, columns.map(function (_ref2, index) {
    var key = _ref2.key,
        value = _ref2.value,
        column = _objectWithoutProperties(_ref2, ["key", "value"]);

    return /*#__PURE__*/React.createElement(Column$1, _extends({}, column, {
      isMobileHeading: index === 0 && showMobileHeading,
      classes: classes,
      testId: testId,
      key: key
    }), value);
  }));
};

Row.displayName = "Row";
Row.propTypes = {
  classes: PropTypes.object,
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.any.isRequired,
    value: PropTypes.node
  })),
  showMobileHeading: PropTypes.bool,
  testId: PropTypes.string
};
Row.defaultProps = {
  classes: {},
  columns: [],
  showMobileHeading: false,
  testId: null
};
var Row$1 = withStyles(styles$h)(Row);

var valueKeyMap = new WeakMap();
/**
 * Get a unique ID for the provided value.
 *
 * Passing the same value multiple times will return the same ID.
 *
 * This method uses a global WeakMap internally, meaning that any values which
 * are garbage collected will be removed from the map.
 *
 * @param {Object} value the value to get the ID for
 * @returns {String} the ID for the value
 */

var keyFor = (function (value) {
  // We don't have to generate a new key if the value is in the map.
  if (valueKeyMap.has(value)) {
    return valueKeyMap.get(value);
  } // We use UUID v4 to [attempt to] guarantee uniqueness (there is a 1 in 2.71
  // quintillion chance of a collision though!).


  var key = uuid();
  valueKeyMap.set(value, key);
  return key;
});

var Table = /*#__PURE__*/function (_PureComponent) {
  _inherits(Table, _PureComponent);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      sortedBy: null,
      sortOrder: null
    });

    _this.state.sortedBy = _this.props.initialSortColumn;
    _this.state.sortOrder = _this.props.initialSortOrder;
    return _this;
  }
  /**
   * Get a list of columns with their classes, unique keys and values.
   *
   * @returns {Object[]} the columns in this table
   */


  _createClass(Table, [{
    key: "getColumns",
    value: function getColumns() {
      var _this2 = this;

      return this.props.columns.map(function (column, index) {
        var sortOrder = null;

        if (index === _this2.state.sortedBy) {
          sortOrder = _this2.state.sortOrder;
        }

        return _objectSpread2(_objectSpread2({}, column), {}, {
          key: keyFor(column),
          sortOrder: sortOrder,
          sortable: Boolean(column.compare)
        });
      });
    }
    /**
     * Get a list of rows for the table.
     *
     * @returns {Object[]} the rows in this table
     */

  }, {
    key: "getRows",
    value: function getRows() {
      var _this3 = this;

      var rows = this.props.rows.map(function (row) {
        return {
          key: keyFor(row),
          columns: _this3.props.columns.map(function (column) {
            // Retrieve the value at the path of the column.
            var pathValue = column.path !== null && column.path !== undefined ? get(row, column.path) : row; // Pass the resulting value into the get method if it exists.

            var getValue = column.get !== null && column.get !== undefined ? column.get(pathValue) : pathValue; // Pass the resulting value into the render method if it exists.

            var renderedValue = column.render !== null && column.render !== undefined ? column.render(getValue) : getValue; // if a type value is passed in, this will be assigned as the classname

            var classNameType = getValue.type;
            return _objectSpread2(_objectSpread2({}, column), {}, {
              key: keyFor(column),
              rawValue: getValue,
              value: renderedValue,
              className: classNameType
            });
          })
        };
      });
      var _this$state = this.state,
          sortOrder = _this$state.sortOrder,
          sortedBy = _this$state.sortedBy;
      var sortColumn = this.props.columns[sortedBy]; // Apply the sorting if the active column has a sort method.

      if (sortColumn && sortColumn.compare) {
        rows.sort(function (first, second) {
          return sortColumn.compare(first.columns[sortedBy].rawValue, second.columns[sortedBy].rawValue);
        }); // We need to reverse the results if we're not sorting in ascending order,
        // as we assume the sort method provided sorts things in ascending order.

        if (sortOrder !== 'ascending') {
          rows.reverse();
        }
      }

      return rows;
    }
  }, {
    key: "onClick",
    value: function onClick(index) {
      // Reset if we've clicked a new heading.
      if (this.state.sortedBy !== index) {
        this.setState(function (state, _ref) {
          var columns = _ref.columns;
          return {
            sortOrder: columns[index].defaultSortOrder || 'ascending',
            sortedBy: index
          };
        });
        return;
      } // Otherwise toggle the current sort order.


      this.setState(function (_ref2) {
        var sortOrder = _ref2.sortOrder;
        return {
          sortOrder: sortOrder === 'ascending' ? 'descending' : 'ascending'
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          message = _this$props.message,
          showMobileHeading = _this$props.showMobileHeading,
          className = _this$props.className,
          testId = _this$props.testId,
          summary = _this$props.summary;
      var columns = this.getColumns();
      var rows = this.getRows();
      return /*#__PURE__*/React.createElement("div", {
        "data-test": createTestId(testId),
        className: "".concat(classes.Table, " ").concat(className !== null && className !== void 0 ? className : '')
      }, /*#__PURE__*/React.createElement("table", {
        className: "".concat(classes.Table, " ").concat(classes.table),
        "data-test": createTestId(testId, 'table'),
        summary: summary
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
        className: "".concat(classes.row, " ").concat(classes.header)
      }, columns.map(function (_ref3, index) {
        var key = _ref3.key,
            name = _ref3.name,
            column = _objectWithoutProperties(_ref3, ["key", "name"]);

        return /*#__PURE__*/React.createElement(HeaderColumn$1, _extends({}, column, {
          key: key,
          testId: testId,
          onClick: function onClick() {
            return _this4.onClick(index);
          }
        }), name);
      }))), (message || rows.length > 0) && /*#__PURE__*/React.createElement("tbody", null, message ? /*#__PURE__*/React.createElement("tr", {
        className: classes.row
      }, /*#__PURE__*/React.createElement("td", {
        className: "".concat(classes.cell, " ").concat(classes.message),
        colSpan: columns.length
      }, message)) : rows.map(function (_ref4, iterator) {
        var key = _ref4.key,
            row = _objectWithoutProperties(_ref4, ["key"]);

        return /*#__PURE__*/React.createElement(Row$1, _extends({}, row, {
          key: key,
          classes: classes,
          testId: createTestId(testId, "row-".concat(iterator)),
          showMobileHeading: showMobileHeading
        }));
      })))));
    }
  }]);

  return Table;
}(PureComponent);

Table.displayName = "Table";

_defineProperty(Table, "propTypes", {
  classes: PropTypes.object,
  className: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({
    align: PropTypes.oneOf(['left', 'center', 'right']),
    className: PropTypes.any,
    compare: PropTypes.func,
    defaultSortOrder: PropTypes.oneOf(['ascending', 'descending']),
    get: PropTypes.func,
    name: PropTypes.string,
    path: PropTypes.string,
    render: PropTypes.func
  })),
  initialSortColumn: PropTypes.number,
  initialSortOrder: PropTypes.oneOf(['ascending', 'descending']),
  message: PropTypes.node,
  rows: PropTypes.arrayOf(PropTypes.object),
  showMobileHeading: PropTypes.bool,
  summary: PropTypes.string,
  testId: PropTypes.string
});

_defineProperty(Table, "defaultProps", {
  classes: {},
  className: undefined,
  columns: [],
  initialSortColumn: null,
  initialSortOrder: null,
  message: undefined,
  rows: [],
  showMobileHeading: false,
  summary: '',
  testId: null
});

var Table$1 = withStyles(styles$h)(Table);

var styles$i = function styles(_ref) {
  var variables = _ref.variables;
  return {
    toast: _objectSpread2(_objectSpread2({}, variables.type.p), {}, {
      padding: '0.5em',
      textAlign: 'center',
      color: '#fff'
    }),
    "default": {
      extend: 'toast',
      composes: 'Toast Toast--default',
      backgroundColor: variables.colors.typeDefault,
      color: variables.colors.dark
    },
    primary: {
      extend: 'toast',
      composes: 'Toast Toast--primary',
      backgroundColor: variables.colors.primary,
      color: variables.colors.light
    },
    secondary: {
      extend: 'toast',
      composes: 'Toast Toast--secondary',
      backgroundColor: variables.colors.secondary,
      color: variables.colors.light
    },
    success: {
      extend: 'toast',
      composes: 'Toast Toast--success',
      backgroundColor: variables.colors.typeSuccess,
      color: variables.colors.light
    },
    warning: {
      extend: 'toast',
      composes: 'Toast Toast--warning',
      backgroundColor: variables.colors.typeWarning,
      color: variables.colors.dark
    },
    danger: {
      extend: 'toast',
      composes: 'Toast Toast--danger',
      backgroundColor: variables.colors.typeDanger,
      color: variables.colors.light
    },
    info: {
      extend: 'toast',
      composes: 'Toast Toast--info',
      backgroundColor: variables.colors.typeInfo,
      color: variables.colors.dark
    }
  };
};

var Toast = /*#__PURE__*/function (_PureComponent) {
  _inherits(Toast, _PureComponent);

  var _super = _createSuper(Toast);

  function Toast() {
    var _this;

    _classCallCheck(this, Toast);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getType", function () {
      return _this.props.classes[_this.props.type] ? _this.props.classes[_this.props.type] : _this.props.classes["default"];
    });

    return _this;
  }

  _createClass(Toast, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          testId = _this$props.testId,
          className = _this$props.className,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement("div", {
        "data-test": createTestId(testId),
        className: "".concat(this.getType(), " ").concat(className !== null && className !== void 0 ? className : '')
      }, children);
    }
  }]);

  return Toast;
}(PureComponent);

Toast.displayName = "Toast";

_defineProperty(Toast, "propTypes", {
  children: PropTypes.any.isRequired,
  classes: PropTypes.object,
  className: PropTypes.string,
  testId: PropTypes.string,
  type: PropTypes.string
});

_defineProperty(Toast, "defaultProps", {
  classes: {},
  className: null,
  testId: null,
  type: 'default'
});

var Toast$1 = withStyles(styles$i)(Toast);

var styles$j = function styles(_ref) {
  var variables = _ref.variables,
      mixins = _ref.mixins;
  return {
    container: _objectSpread2(_objectSpread2({
      composes: 'Title'
    }, mixins.init()), {}, {
      borderTop: "1px solid ".concat(variables.colors.greyTwo),
      maxWidth: '20em'
    }),
    title: _objectSpread2(_objectSpread2({}, variables.type.p), {}, {
      fontWeight: 700,
      padding: '1em 0',
      textTransform: 'uppercase',
      color: variables.colors.text
    })
  };
};

var Title = function Title(_ref) {
  var classes = _ref.classes,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.title
  }, children));
};

Title.displayName = "Title";
Title.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object
};
Title.defaultProps = {
  children: null,
  classes: {}
};
var Title$1 = withStyles(styles$j)(Title);

var WrapLoader = function WrapLoader(_ref) {
  var message = _ref.message,
      children = _ref.children,
      classes = _ref.classes;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapLoader
  }, /*#__PURE__*/React.createElement(Loader$1, {
    message: message
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.components
  }, children));
};

WrapLoader.displayName = "WrapLoader";
WrapLoader.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object,
  message: PropTypes.string
};
WrapLoader.defaultProps = {
  children: null,
  classes: {},
  message: ''
};
var WrapLoader$1 = withStyles(styles$8)(WrapLoader);

var styles$k = function styles(_ref) {
  var variables = _ref.variables,
      breakpoints = _ref.breakpoints;
  var stylesheet = {
    container: _defineProperty({
      composes: 'Grid',
      extend: variables.baseMobile,
      color: variables.colors.dark,
      fontFamily: variables.fontFamily,
      margin: '0 auto',
      maxWidth: '75rem'
    }, breakpoints.xl, {
      extend: variables.baseDesktop,
      maxWidth: '90rem'
    }),
    containerInner: {
      display: 'flex',
      margin: '0 -1em'
    },
    grow: {
      composes: 'columnGrow',
      flexGrow: 1
    },
    debug: {
      composes: 'gridDebug',
      borderColor: variables.colors.grayThree,
      borderWidth: '1px',
      borderStyle: 'dotted'
    }
  };
  return stylesheet;
};

var Grid = function Grid(_ref) {
  var classes = _ref.classes,
      debug = _ref.debug,
      children = _ref.children,
      className = _ref.className,
      testId = _ref.testId;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId),
    className: "".concat(classes.container, " ").concat(debug ? classes.debug : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.containerInner, " ").concat(className)
  }, children));
};

Grid.displayName = "Grid";
Grid.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.any,
  className: PropTypes.string,
  debug: PropTypes.bool,
  testId: PropTypes.string
};
Grid.defaultProps = {
  children: null,
  classes: {},
  className: null,
  debug: false,
  testId: null
};
var Grid$1 = withStyles(styles$k)(Grid);

var styles$l = function styles(_ref) {
  var variables = _ref.variables,
      breakpoints = _ref.breakpoints;
  return {
    column: function column(props) {
      var _ref2;

      return _ref2 = {
        composes: 'Column',
        padding: '0 1em',
        flexBasis: 'auto'
      }, _defineProperty(_ref2, breakpoints.xs, {
        flexBasis: props.xs ? "".concat(Math.floor(props.xs / 12 * 100), "%") : null
      }), _defineProperty(_ref2, breakpoints.sm, {
        flexBasis: props.sm ? "".concat(Math.floor(props.sm / 12 * 100), "%") : null
      }), _defineProperty(_ref2, breakpoints.md, {
        flexBasis: props.md ? "".concat(Math.floor(props.md / 12 * 100), "%") : null
      }), _defineProperty(_ref2, breakpoints.lg, {
        flexBasis: props.lg ? "".concat(Math.floor(props.lg / 12 * 100), "%") : null
      }), _defineProperty(_ref2, breakpoints.xl, {
        flexBasis: props.xl ? "".concat(Math.floor(props.xl / 12 * 100), "%") : null
      }), _defineProperty(_ref2, breakpoints.xxl, {
        flexBasis: props.xxl ? "".concat(Math.floor(props.xxl / 12 * 100), "%") : null
      }), _ref2;
    },
    debug: {
      composes: 'gridDebug',
      borderColor: variables.colors.grayThree,
      borderWidth: '1px',
      borderStyle: 'dotted'
    }
  };
};

var Col = function Col(_ref) {
  var _classNames;

  var classes = _ref.classes,
      grow = _ref.grow,
      debug = _ref.debug,
      children = _ref.children,
      className = _ref.className,
      testId = _ref.testId;
  var rootClasses = classNames$1(classes.column, (_classNames = {}, _defineProperty(_classNames, classes.grow, grow), _defineProperty(_classNames, classes.debug, debug), _classNames), className);
  return /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId),
    className: rootClasses
  }, children);
};

Col.displayName = "Col";
Col.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.any,
  className: PropTypes.string,
  debug: PropTypes.bool,
  grow: PropTypes.bool,
  testId: PropTypes.string
};
Col.defaultProps = {
  children: null,
  classes: {},
  className: null,
  debug: false,
  grow: false,
  testId: null
};
var Col$1 = withStyles(styles$l)(Col);

var styles$m = function styles(_ref) {
  var _inputField;

  var mixins = _ref.mixins,
      variables = _ref.variables,
      breakpoints = _ref.breakpoints;
  return {
    fieldWrapper: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'fieldWrapper',
      margin: '0.5rem 0 0',
      width: '100%'
    }),
    inputField: (_inputField = {
      composes: 'inputField',
      borderRadius: 4,
      display: 'block',
      width: '100%',
      backgroundColor: '#ffffff'
    }, _defineProperty(_inputField, breakpoints.xs, {
      marginBottom: '1rem'
    }), _defineProperty(_inputField, '&.inputField--invalid, &.inputField--valid, &:focus-within', {
      boxShadow: '0px 0px 0px 2px #ffffff'
    }), _inputField),
    valid: {
      composes: 'inputField inputField--valid',
      extend: 'inputField',
      '& $inputContainer': {
        '&:before': {
          width: '99%',
          borderBottom: "2px solid ".concat(variables.colors.typeSuccess),
          zIndex: 1
        },
        '& .inputField__input': {
          border: "2px solid ".concat(variables.colors.typeSuccess)
        }
      }
    },
    '@keyframes fadeInAnim': {
      from: {
        opacity: 0,
        transform: 'translate(15px, 14px)'
      },
      to: {
        opacity: 1,
        transform: 'translate(-10px, 14px)'
      }
    },
    validIcon: {
      right: 0,
      top: '4px',
      position: 'absolute',
      color: "".concat(variables.colors.typeSuccess),
      animation: '$fadeInAnim 0.25s ease-out forwards'
    },
    invalid: {
      composes: 'inputField inputField--invalid',
      extend: 'inputField',
      '& $inputContainer': {
        '&:before': {
          width: '99%',
          borderBottom: "2px solid ".concat(variables.colors.typeDanger),
          zIndex: 1
        },
        '& .inputField__input': {
          border: "2px solid ".concat(variables.colors.typeDanger)
        }
      }
    },
    invalidIcon: {
      right: 0,
      top: '4px',
      position: 'absolute',
      color: "".concat(variables.colors.typeDanger),
      animation: '$fadeInAnim 0.25s ease-out forwards'
    },
    disabled: {
      composes: 'inputField inputField--disabled',
      backgroundColor: '#e9ebec',
      extend: 'inputField',
      '& $input': {
        border: "1px solid ".concat(variables.colors.greyTwo),
        backgroundColor: '#f1f1f1',
        color: '#333',
        cursor: 'not-allowed',
        userSelect: 'none',
        '&:hover, &:focus, &:active': {
          border: "1px solid ".concat(variables.colors.greyTwo)
        }
      }
    },
    required: {
      composes: 'inputField__required',
      color: "".concat(variables.colors.requiredRed, " !important")
    },
    label: {
      composes: 'inputField__label',
      position: 'absolute',
      transition: 'all 0.3s ease-out',
      transform: 'translate(0, 0.75rem)',
      marginLeft: '0.75rem',
      color: '#838383',
      pointerEvents: 'none',
      fontSize: '1rem',
      width: '100%',
      zIndex: 1
    },
    labelActive: {
      composes: 'labelActive',
      color: '#333',
      fontSize: '0.8rem',
      marginLeft: '0.75rem',
      pointerEvents: 'none',
      position: 'absolute',
      transform: 'translate(0.1rem, 0.3rem)',
      transition: 'all 0.3s ease-out',
      zIndex: 1
    },
    inputContainer: {
      borderRadius: 'inherit',
      display: 'flex',
      position: 'relative',
      overflow: 'hidden',
      '&:before': {
        display: 'inline-block',
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '8px',
        width: '0%',
        height: '2px',
        borderBottom: '2px solid transparent',
        transition: '0.3s width ease-in-out'
      }
    },
    input: {
      composes: 'inputField__input',
      backgroundColor: 'inherit',
      borderRadius: 'inherit',
      border: '1px solid #e1e7ee',
      appearance: 'none',
      height: 48,
      padding: '0.4rem 0.5em 0',
      width: '100%',
      display: 'block',
      color: '#333',
      transition: 'border 0.2s ease-in-out',
      '&:focus': {
        border: '2px solid #0095ff',
        outline: 'none'
      },
      '&:hover': {
        border: '1px solid #a9bac6'
      },
      '&:-webkit-autofill': {
        '-webkit-box-shadow': '0 0 0px 1000px #ffffff inset',
        '-webkit-text-fill-color': '#333'
      }
    },
    error: {
      composes: 'inputField__error',
      display: 'block',
      fontSize: '0.8em',
      padding: '0 0.5em',
      border: 'none',
      color: variables.colors.typeDanger,
      backgroundColor: variables.colors.blue,
      marginTop: '0.25em'
    },
    lastError: {
      marginTop: 0
    }
  };
};

var InputFieldV2 = function InputFieldV2(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      controlled = _ref.controlled,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      disablePaste = _ref.disablePaste,
      errors = _ref.errors,
      forwardRef = _ref.forwardRef,
      hiddenErrors = _ref.hiddenErrors,
      id = _ref.id,
      inputMode = _ref.inputMode,
      label = _ref.label,
      lineBlank = _ref.lineBlank,
      maxLength = _ref.maxLength,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      pattern = _ref.pattern,
      required = _ref.required,
      showBlankSpace = _ref.showBlankSpace,
      suffix = _ref.suffix,
      testId = _ref.testId,
      type = _ref.type,
      valid = _ref.valid,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      valueFormatter = _ref.valueFormatter;

  var _useState = useState(value !== null && value !== void 0 ? value : defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setValue = _useState2[1];

  var getInputState = function getInputState() {
    if (disabled) {
      return classes === null || classes === void 0 ? void 0 : classes.disabled;
    } else if (errors.length) {
      return classes === null || classes === void 0 ? void 0 : classes.invalid;
    } else if (valid && !errors.length) {
      return classes === null || classes === void 0 ? void 0 : classes.valid;
    }

    return classes === null || classes === void 0 ? void 0 : classes.inputField;
  };

  var formatValue = function formatValue(newValue) {
    return valueFormatter ? valueFormatter(newValue) : newValue;
  };

  var handleChange = function handleChange(event) {
    var newValue = formatValue(event.target.value);
    onChange(newValue);
    setValue(newValue);
  };

  var handleBlur = function handleBlur(event) {
    return onBlur(formatValue(event.target.value));
  };

  var handleFocus = function handleFocus(event) {
    return onFocus(formatValue(event.target.value));
  };

  var getClassName = function getClassName() {
    var checkValue = controlled ? value : inputValue;
    return checkValue === '' ? classes.label : classes.labelActive;
  };

  var displayValue = controlled && value ? value : inputValue;

  var handlePaste = function handlePaste(event) {
    return event.preventDefault();
  };

  var optionalProps = {
    onPaste: disablePaste ? handlePaste : undefined
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes === null || classes === void 0 ? void 0 : classes.fieldWrapper
  }, /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId),
    className: "".concat(getInputState(), " ").concat(className !== null && className !== void 0 ? className : '')
  }, /*#__PURE__*/React.createElement("label", {
    className: getClassName(),
    htmlFor: id
  }, label, required && /*#__PURE__*/React.createElement("span", {
    "data-test": createTestId(testId, 'label'),
    className: classes === null || classes === void 0 ? void 0 : classes.required
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: classes === null || classes === void 0 ? void 0 : classes.inputContainer
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: forwardRef,
    id: id,
    name: name,
    type: type,
    "data-test": createTestId(testId, 'input'),
    className: classes === null || classes === void 0 ? void 0 : classes.input,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    disabled: disabled,
    value: displayValue,
    maxLength: maxLength,
    pattern: pattern,
    inputMode: inputMode
  }, optionalProps)), suffix, (valid || errors.length > 0) && /*#__PURE__*/React.createElement(Icon$1, {
    icon: valid ? 'iconCheck' : 'iconClose',
    className: valid ? classes.validIcon : classes.invalidIcon
  }))), !hiddenErrors && (errors === null || errors === void 0 ? void 0 : errors.length) ? errors.map(function (error) {
    return /*#__PURE__*/React.createElement("span", {
      key: error,
      className: classes === null || classes === void 0 ? void 0 : classes.error,
      "data-test": createTestId(testId, 'errorMsg')
    }, error);
  }) : showBlankSpace && /*#__PURE__*/React.createElement(React.Fragment, null, _toConsumableArray(Array(lineBlank).keys()).map(function (val) {
    return /*#__PURE__*/React.createElement("span", {
      key: val,
      className: classNames$1(classes === null || classes === void 0 ? void 0 : classes.error, _defineProperty({}, classes.lastError, val > 0 && val + 1 === lineBlank))
    }, "\xA0");
  })));
};

InputFieldV2.displayName = "InputFieldV2";
InputFieldV2.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  controlled: PropTypes.bool,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  disablePaste: PropTypes.bool,
  errors: PropTypes.array,
  forwardRef: PropTypes.any,
  hiddenErrors: PropTypes.bool,
  id: PropTypes.string,
  inputMode: PropTypes.string,
  label: PropTypes.string.isRequired,
  lineBlank: PropTypes.number,
  maxLength: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  pattern: PropTypes.string,
  required: PropTypes.bool,
  showBlankSpace: PropTypes.bool,
  suffix: PropTypes.node,
  testId: PropTypes.string,
  type: PropTypes.string,
  valid: PropTypes.bool,
  value: PropTypes.string,
  valueFormatter: PropTypes.func
};
InputFieldV2.defaultProps = {
  classes: {},
  className: null,
  controlled: false,
  defaultValue: '',
  disabled: false,
  disablePaste: false,
  errors: [],
  forwardRef: null,
  hiddenErrors: false,
  id: '',
  inputMode: null,
  lineBlank: 1,
  maxLength: null,
  name: '',
  onBlur: noop,
  onFocus: noop,
  pattern: null,
  required: false,
  showBlankSpace: false,
  suffix: null,
  testId: null,
  type: 'text',
  valid: null,
  value: null,
  valueFormatter: null
};
var InputFieldV2$1 = withStyles(styles$m)(InputFieldV2);

var styles$n = function styles(_ref) {
  var variables = _ref.variables;
  return {
    addressForm: {
      padding: '1rem'
    },
    row: {
      display: 'flex',
      '@media (max-width: 719px)': {
        flexWrap: 'wrap'
      }
    },
    column: {
      width: '33.33%',
      '@media (max-width: 719px)': {
        width: '100%'
      }
    },
    columnPadding: {
      margin: '0 1rem',
      '@media (max-width: 719px)': {
        margin: 0
      }
    },
    btnLink: {
      border: 0,
      backgroundColor: 'transparent',
      textDecoration: 'underline',
      color: variables.colors.trueBlack
    },
    addressFormFooter: {
      display: 'block',
      marginTop: '1rem',
      width: '100%'
    }
  };
};

var AddressForm = function AddressForm(_ref) {
  var address = _ref.address,
      onSubmit = _ref.onSubmit,
      classes = _ref.classes,
      testId = _ref.testId;
  var addressLine1Ref = useRef();
  var addressLine2Ref = useRef();
  var townCityRef = useRef();
  var countyRef = useRef();
  var postcodeRef = useRef();
  var allErrors = {};

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = useState(address),
      _useState4 = _slicedToArray(_useState3, 2),
      currentAddress = _useState4[0],
      setCurrentAddress = _useState4[1];

  var deleteErrorProp = function deleteErrorProp(param) {
    /* eslint-disable-next-line no-unused-vars */
    var undefined$1 = errors[param],
        rest = _objectWithoutProperties(errors, [param].map(_toPropertyKey));

    setErrors(rest);
  };

  var handleUserInput = function handleUserInput(fieldName, value) {
    if (fieldName === 'addressLine1' || fieldName === 'addressTowncity' || fieldName === 'addressPostcode') {
      deleteErrorProp(fieldName);
    }

    setCurrentAddress(_objectSpread2(_objectSpread2({}, currentAddress), {}, _defineProperty({}, fieldName, value)));
  };

  var fieldValidation = function fieldValidation(fieldName, fieldValue) {
    if (fieldValue.trim() === '') {
      allErrors[fieldName] = ["This is a required field"];
    }
    /* if (/[^A-Za-z0-9 _ -]/.test(fieldValue)) { // need good regex code for validation.
      allErrors[fieldName] = [`Invalid characters`];
    }*/

  };

  var validateForm = function validateForm() {
    allErrors = {};
    var validateProps = {
      addressLine1: currentAddress.addressLine1,
      addressTowncity: currentAddress.addressTowncity,
      addressPostcode: currentAddress.addressPostcode
    };
    /* eslint-disable-next-line no-unused-vars */

    for (var _i = 0, _Object$entries = Object.entries(validateProps); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      fieldValidation([key], value);
    }

    if (Object.keys(allErrors).length) {
      setErrors(allErrors);
      return false;
    }

    return true;
  };

  var onHandleSubmit = function onHandleSubmit(evt) {
    evt.preventDefault();

    if (validateForm()) {
      onSubmit(currentAddress);
    }
  };

  var addressLine1 = currentAddress.addressLine1,
      addressLine2 = currentAddress.addressLine2,
      addressTowncity = currentAddress.addressTowncity,
      addressCounty = currentAddress.addressCounty,
      addressPostcode = currentAddress.addressPostcode;
  return /*#__PURE__*/React.createElement("form", {
    "data-test": createTestId(testId, 'form'),
    onSubmit: function onSubmit(evt) {
      return onHandleSubmit(evt);
    },
    className: classes.addressForm
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/React.createElement(InputFieldV2$1, {
    testId: "addressLine1",
    id: "addressLine1",
    forwardRef: addressLine1Ref,
    name: "addressLine1",
    value: addressLine1,
    label: "Line 1",
    required: true,
    onChange: function onChange(value) {
      return handleUserInput('addressLine1', value);
    },
    errors: errors === null || errors === void 0 ? void 0 : errors.addressLine1
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/React.createElement(InputFieldV2$1, {
    testId: "addressLine2",
    id: "addressLine2",
    forwardRef: addressLine2Ref,
    value: addressLine2,
    label: "Line 2",
    name: "address2",
    onChange: function onChange(value) {
      return handleUserInput('addressLine2', value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.row)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.column)
  }, /*#__PURE__*/React.createElement(InputFieldV2$1, {
    testId: "addressTowncity",
    id: "addressTowncity",
    forwardRef: townCityRef,
    name: "addressTowncity",
    value: addressTowncity,
    label: "Town/City",
    required: true,
    onChange: function onChange(value) {
      return handleUserInput('addressTowncity', value);
    },
    errors: errors === null || errors === void 0 ? void 0 : errors.addressTowncity
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.column, " ").concat(classes.columnPadding)
  }, /*#__PURE__*/React.createElement(InputFieldV2$1, {
    testId: "addressCounty",
    id: "addressCounty",
    forwardRef: countyRef,
    name: "addressCounty",
    value: addressCounty,
    label: "County/State",
    onChange: function onChange(value) {
      return handleUserInput('addressCounty', value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: " ".concat(classes.column)
  }, /*#__PURE__*/React.createElement(InputFieldV2$1, {
    testId: "addressPostcode",
    id: "addressPostcode",
    forwardRef: postcodeRef,
    name: "addressPostcode",
    value: addressPostcode,
    label: "Postcode/Zip code",
    required: true,
    onChange: function onChange(value) {
      return handleUserInput('addressPostcode', value);
    },
    errors: errors === null || errors === void 0 ? void 0 : errors.addressPostcode
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.addressFormFooter
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: classes.btnLink,
    "data-test": createTestId(testId, 'button'),
    onClick: function onClick(evt) {
      return onHandleSubmit(evt);
    }
  }, "Use this address")));
};

AddressForm.displayName = "AddressForm";
AddressForm.propTypes = {
  address: PropTypes.shape({
    addressLine1: PropTypes.string.isRequired,
    addressLine2: PropTypes.string.isRequired,
    addressTowncity: PropTypes.string.isRequired,
    addressCounty: PropTypes.string.isRequired,
    addressPostcode: PropTypes.string.isRequired
  }),
  classes: PropTypes.shape({
    addressForm: PropTypes.string.isRequired,
    addressFormFooter: PropTypes.string.isRequired,
    btnLink: PropTypes.string.isRequired,
    column: PropTypes.string.isRequired,
    columnPadding: PropTypes.string.isRequired,
    row: PropTypes.string.isRequired
  }),
  onSubmit: PropTypes.func,
  testId: PropTypes.string
};
AddressForm.defaultProps = {
  address: {},
  classes: {},
  onSubmit: noop,
  testId: null
};
var AddressForm$1 = withStyles(styles$n)(AddressForm);

var styles$o = function styles(_ref) {
  var variables = _ref.variables;
  return {
    customerAddress: {
      padding: '1rem',
      Width: '358px',
      maxWidth: '358px',
      height: '240px',
      backgroundColor: variables.colors.trueWhite,
      boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.25)',
      margin: '1rem'
    },
    customerName: {
      display: 'flex',
      color: variables.colors.trueBlack,
      padding: '0 6px',
      fontWeight: 600
    },
    customerAddressList: {
      padding: '0 6px'
    },
    addressField: {
      display: 'block'
    },
    customerAddressFooter: {
      display: 'block',
      marginTop: '1rem',
      width: '100%'
    },
    btnLink: {
      border: 0,
      backgroundColor: 'transparent',
      textDecoration: 'underline'
    }
  };
};

var CustomerAddress = function CustomerAddress(_ref) {
  var classes = _ref.classes,
      address = _ref.address,
      customerName = _ref.customerName,
      onEdit = _ref.onEdit,
      testId = _ref.testId;

  var renderAddress = function renderAddress() {
    return Object.values(address).map(function (addressField) {
      return /*#__PURE__*/React.createElement("li", {
        className: classes.addressField,
        key: addressField
      }, addressField);
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.customerAddress,
    "data-test": createTestId(testId, 'wrapper')
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.customerName
  }, customerName), /*#__PURE__*/React.createElement("ul", {
    className: classes.customerAddressList
  }, renderAddress()), /*#__PURE__*/React.createElement("div", {
    className: classes.customerAddressFooter
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classes.btnLink,
    onClick: onEdit
  }, "Edit")));
};

CustomerAddress.displayName = "CustomerAddress";
CustomerAddress.propTypes = {
  address: PropTypes.shape({
    addressCountry: PropTypes.string.isRequired,
    addressCounty: PropTypes.string.isRequired,
    addressLine1: PropTypes.string.isRequired,
    addressLine2: PropTypes.string.isRequired,
    addressLine3: PropTypes.string,
    addressPostcode: PropTypes.string.isRequired,
    addressTowncity: PropTypes.string.isRequired
  }).isRequired,
  classes: PropTypes.shape({
    customerAddress: PropTypes.string.isRequired,
    customerName: PropTypes.string.isRequired,
    customerAddressList: PropTypes.string.isRequired,
    addressField: PropTypes.string.isRequired,
    customerAddressFooter: PropTypes.string.isRequired,
    btnLink: PropTypes.string.isRequired
  }).isRequired,
  customerName: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  testId: PropTypes.string
};
CustomerAddress.defaultProps = {
  testId: null
};
var CustomerAddress$1 = withStyles(styles$o)(CustomerAddress);

var styles$p = function styles(_ref) {
  var variables = _ref.variables,
      mixins = _ref.mixins;
  return {
    '@global': {
      '@keyframes spin': {
        to: {
          transform: 'rotate(360deg)'
        }
      }
    },
    loading: {
      cursor: 'default',
      '& $title': {
        opacity: 0
      }
    },
    center: {
      composes: 'button--align-center',
      justifyContent: 'center'
    },
    left: {
      composes: 'button--align-left',
      justifyContent: 'flex-start'
    },
    right: {
      composes: 'button--align-right',
      justifyContent: 'flex-end'
    },
    loader: {
      composes: 'button__loader',
      position: 'absolute',
      display: 'block',
      left: '50%',
      top: '50%',
      pointerEvents: 'none',
      transform: 'translate(-50%, -50%)'
    },
    loaderInner: {
      composes: 'button__loader-inner',
      display: 'inline-block',
      width: '1em',
      height: '1em',
      borderStyle: 'solid',
      borderWidth: '3px',
      borderColor: "".concat(color(variables.colors.greyThree).fade(0.8)),
      borderTopColor: variables.colors.greyFour,
      borderRadius: '50%',
      animation: 'spin 1s ease-in-out infinite',
      '&:before': {
        transition: 'unset',
        background: 'unset'
      },
      '&:hover:before': {
        transition: 'unset',
        background: 'unset'
      }
    },
    button: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      boxShadow: 'unset',
      display: 'flex',
      flexDirection: 'row',
      verticalAlign: 'middle',
      alignItems: 'center',
      fontFamily: 'Montserrat',
      padding: '1em 2em',
      overflow: 'hidden',
      position: 'relative',
      outline: 'none',
      border: "".concat(variables.colors.greyTwo, " ").concat(variables.border, " solid"),
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: '600',
      transition: '0.2s ease-in-out',
      '& svg': {
        display: 'inline-block',
        marginRight: '0.5em'
      },
      '&$loading': {
        border: "".concat(variables.colors.greyTwo, " ").concat(variables.border, " solid"),
        cursor: 'default',
        boxShadow: 'unset'
      }
    }),
    leftIcon: {
      composes: 'btn-icon-left',
      '& span': {
        paddingLeft: '1rem'
      },
      '& svg': {
        position: 'absolute',
        left: '10%',
        top: 'calc(50% - 8px)'
      }
    },
    rightIcon: {
      composes: 'btn-icon-right',
      '& span': {
        paddingRight: '1rem'
      },
      '& svg': {
        position: 'absolute',
        right: '3%',
        top: 'calc(50% - 8px)'
      }
    },
    "default": {
      extend: 'button',
      composes: 'button button--default',
      borderColor: variables.colors.greyTwo,
      backgroundColor: 'transparent',
      color: variables.colors.text,
      '& .button__loader-inner': {
        borderColor: "".concat(color(variables.colors.greyThree).fade(0.8)),
        borderTopColor: variables.colors.greyFour
      },
      '&:hover, &:active, &:focus': {
        border: "".concat(variables.colors.greyTwo, " ").concat(variables.border, " solid")
      },
      '&$loading': {
        borderColor: variables.colors.greyTwo,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    primary: {
      extend: 'button',
      composes: 'button button--primary',
      borderColor: variables.colors.primaryAccent,
      backgroundColor: variables.colors.primary,
      color: variables.colors.light,
      '&:hover, &:focus': {
        backgroundColor: "".concat(color(variables.colors.primary).darken(0.1))
      },
      '&:active': {
        backgroundColor: "".concat(color(variables.colors.primary).darken(0.3))
      },
      '& .button__loader-inner': {
        borderColor: variables.colors.primaryAccent,
        borderTopColor: variables.colors.light
      },
      '&$loading': {
        borderColor: variables.colors.primaryAccent,
        backgroundColor: variables.colors.primary,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    secondary: {
      extend: 'button',
      composes: 'button button--secondary',
      borderColor: variables.colors.offBlack,
      backgroundColor: variables.colors.secondary,
      color: variables.colors.trueBlack,
      '&:hover, &:focus': {
        borderColor: variables.colors.offBlack,
        backgroundColor: "".concat(color(variables.colors.secondary).darken(0.1))
      },
      '&:active': {
        borderColor: variables.colors.offBlack,
        backgroundColor: "".concat(color(variables.colors.secondary).darken(0.2))
      },
      '& .button__loader-inner': {
        borderColor: "".concat(color(variables.colors.greyThree).fade(0.8)),
        borderTopColor: variables.colors.offBlack
      },
      '&$loading': {
        border: "".concat(variables.colors.offBlack, " ").concat(variables.border, " solid"),
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    success: {
      extend: 'button',
      composes: 'button button--success',
      borderColor: variables.colors.typeSuccess,
      backgroundColor: variables.colors.typeSuccess,
      color: variables.colors.light,
      '& .button__loader-inner': {
        borderColor: "".concat(color(variables.colors.typeSuccess).lighten(0.2)),
        borderTopColor: variables.colors.light
      },
      '&:hover, &:active, &:focus': {
        border: "".concat(variables.colors.typeSuccess, " ").concat(variables.border, " solid"),
        backgroundColor: "".concat(color(variables.colors.typeSuccess).lighten(0.1))
      },
      '&$loading': {
        border: "".concat(variables.colors.typeSuccess, " ").concat(variables.border, " solid"),
        backgroundColor: variables.colors.typeSuccess,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    info: {
      extend: 'button',
      composes: 'button button--info',
      borderColor: variables.colors.typeInfo,
      backgroundColor: variables.colors.typeInfo,
      color: variables.colors.light,
      '& .button__loader-inner': {
        borderColor: "".concat(color(variables.colors.typeInfo).lighten(0.2)),
        borderTopColor: variables.colors.light
      },
      '&:hover, &:active, &:focus': {
        backgroundColor: "".concat(color(variables.colors.typeInfo).lighten(0.1))
      },
      '&$loading': {
        border: "".concat(variables.colors.typeInfo, " ").concat(variables.border, " solid"),
        backgroundColor: variables.colors.typeInfo,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    warning: {
      extend: 'button',
      composes: 'button button--warning',
      borderColor: variables.colors.typeWarning,
      backgroundColor: variables.colors.typeWarning,
      color: variables.colors.dark,
      '& .button__loader-inner': {
        borderColor: "".concat(color(variables.colors.typeWarning).lighten(0.2)),
        borderTopColor: variables.colors.light
      },
      '&:hover, &:active, &:focus': {
        backgroundColor: "".concat(color(variables.colors.typeWarning).lighten(0.1))
      },
      '&$loading': {
        border: "".concat(variables.colors.typeWarning, " ").concat(variables.border, " solid"),
        backgroundColor: variables.colors.typeWarning,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    danger: {
      extend: 'button',
      composes: 'button button--danger',
      borderColor: variables.colors.typeDanger,
      backgroundColor: variables.colors.typeDanger,
      color: variables.colors.light,
      '& .button__loader-inner': {
        borderColor: color(variables.colors.typeDanger).lighten(0.1),
        borderTopColor: variables.colors.light
      },
      '&:hover, &:active, &:focus': {
        backgroundColor: "".concat(color(variables.colors.typeDanger).lighten(0.1))
      },
      '&$loading': {
        border: "".concat(variables.colors.typeDanger, " ").concat(variables.border, " solid"),
        backgroundColor: variables.colors.typeDanger,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    tertiary: {
      extend: 'button',
      composes: 'button button--tertiary',
      borderColor: variables.colors.tertiary,
      backgroundColor: variables.colors.tertiary,
      color: variables.colors.light,
      '& .button__loader-inner': {
        borderColor: color(variables.colors.tertiary).lighten(0.1),
        borderTopColor: variables.colors.light
      },
      '&:hover, &:active': {
        backgroundColor: "".concat(color(variables.colors.tertiary).lighten(0.1))
      },
      '&:focus': {
        backgroundColor: "".concat(color(variables.colors.tertiary).darken(0.3))
      },
      '&$loading': {
        border: "".concat(variables.colors.tertiary, " ").concat(variables.border, " solid"),
        backgroundColor: variables.colors.tertiary,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    outlined: {
      extend: 'button',
      composes: 'button button--outlined',
      border: "".concat(variables.colors.greyTwo, " ").concat(variables.border, " solid"),
      backgroundColor: variables.colors.trueWhite,
      color: variables.colors.trueBlack,
      '& .button__loader-inner': {
        borderColor: "".concat(color(variables.colors.greyThree).fade(0.8)),
        borderTopColor: variables.colors.greyFour
      },
      '&:hover': {
        backgroundColor: "".concat(color(variables.colors.brand).lighten(0.3)),
        borderColor: "".concat(color(variables.colors.brand).lighten(0.3)),
        color: variables.colors.trueBlack
      },
      '&:active, &:focus': {
        backgroundColor: variables.colors.brand,
        borderColor: variables.colors.brand,
        color: variables.colors.trueWhite
      },
      '&$loading': {
        borderColor: variables.colors.greyTwo,
        backgroundColor: variables.colors.trueWhite,
        cursor: 'default',
        boxShadow: 'unset'
      }
    },
    disabled: {
      cursor: 'default',
      extend: 'default',
      backgroundColor: "".concat(color(variables.colors.typeDefault).desaturate(0.5)),
      border: "".concat(color(variables.colors.typeDefault).desaturate(0.5), " ").concat(variables.border, " solid"),
      color: variables.colors.light,
      '& $title': {
        color: "".concat(color(variables.colors.dark).fade(0.2))
      },
      '&:hover, &:active, &:focus': {
        backgroundColor: "".concat(color(variables.colors.typeDefault).desaturate(0.5)),
        border: "".concat(color(variables.colors.typeDefault).desaturate(0.5), " ").concat(variables.border, " solid"),
        boxShadow: 'unset'
      },
      '&$loading': {
        backgroundColor: "".concat(color(variables.colors.typeDefault).desaturate(0.5)),
        border: "".concat(color(variables.colors.typeDefault).desaturate(0.5), " ").concat(variables.border, " solid"),
        boxShadow: 'unset'
      }
    },
    title: {
      display: 'block',
      pointerEvents: 'none',
      transition: 'opacity 0.2s ease-out'
    },
    large: {
      composes: 'button button--large',
      padding: '12px 20px',
      fontSize: '16px',
      fontStyle: 'normal',
      lineHeight: '21px',
      height: '48px',
      maxHeight: '48px',
      '&$leftIcon': {
        composes: 'btn-icon-left',
        '& span:not(.button__loader)': {
          paddingLeft: '1rem'
        },
        '& svg': {
          position: 'absolute',
          left: '14px',
          top: 'calc(50% - 8px)'
        }
      },
      '&$rightIcon': {
        composes: 'btn-icon-right',
        '& span:not(.button__loader)': {
          paddingRight: '1rem'
        },
        '& svg': {
          position: 'absolute',
          right: '0',
          top: 'calc(50% - 8px)'
        }
      }
    },
    medium: {
      borderRadius: '8px',
      composes: 'button button--medium',
      padding: '12px 16px',
      fontSize: '12px',
      fontStyle: 'normal',
      lineHeight: '26px',
      height: '46px',
      maxHeight: '46px',
      '&$leftIcon': {
        composes: 'btn-icon-left',
        '& span:not(.button__loader)': {
          paddingLeft: '1rem'
        },
        '& svg': {
          position: 'absolute',
          left: '12px',
          top: 'calc(50% - 6px)'
        }
      },
      '&$rightIcon': {
        composes: 'btn-icon-right',
        '& span:not(.button__loader)': {
          paddingRight: '1rem'
        },
        '& svg': {
          position: 'absolute',
          right: '4px',
          top: 'calc(50% - 6px)'
        }
      }
    },
    small: {
      composes: 'button button--small',
      fontSize: '12px',
      height: '32px',
      lineHeight: '12px',
      maxHeight: '32px',
      padding: '8px 12px',
      minWidth: '71px',
      '&$leftIcon': {
        composes: 'btn-icon-left',
        '& span:not(.button__loader)': {
          paddingLeft: '1rem'
        },
        '& svg': {
          position: 'absolute',
          left: '6px',
          top: 'calc(50% - 6px)'
        }
      },
      '&$rightIcon': {
        composes: 'btn-icon-right',
        '& span:not(.button__loader)': {
          paddingRight: '1rem'
        },
        '& svg': {
          position: 'absolute',
          right: '-2px',
          top: 'calc(50% - 6px)'
        }
      }
    },
    wide: {
      composes: 'Button Button--width',
      fontSize: '12px',
      fontStyle: 'normal',
      height: '48px',
      lineHeight: '15px',
      maxHeight: '48px',
      padding: '8px 12px',
      width: '100%',
      '&$leftIcon': {
        composes: 'btn-icon-left',
        '& span:not(.button__loader)': {
          paddingLeft: '0'
        },
        '& svg': {
          position: 'absolute',
          left: '14px',
          top: 'calc(50% - 8px)'
        }
      },
      '&$rightIcon': {
        composes: 'btn-icon-right',
        '& span:not(.button__loader)': {
          paddingRight: '0'
        },
        '& svg': {
          position: 'absolute',
          right: '14px',
          top: 'calc(50% - 8px)'
        }
      }
    }
  };
};

var ButtonV2 = function ButtonV2(_ref) {
  var _classNames;

  var align = _ref.align,
      ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      classes = _ref.classes,
      dataAction = _ref.dataAction,
      disabled = _ref.disabled,
      loading = _ref.loading,
      onClick = _ref.onClick,
      size = _ref.size,
      testId = _ref.testId,
      type = _ref.type,
      value = _ref.value,
      variant = _ref.variant,
      rightIconProp = _ref.rightIcon,
      leftIconProp = _ref.leftIcon;

  var handleOnClick = function handleOnClick(event) {
    return !disabled && !loading && onClick(event);
  };

  var leftIcon = leftIconProp && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: leftIconProp,
    className: "".concat(classes.leftIcon, " ").concat(className !== null && className !== void 0 ? className : '')
  });
  var rightIcon = rightIconProp && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: rightIconProp,
    className: "".concat(classes.rightIcon, " ").concat(className !== null && className !== void 0 ? className : '')
  });
  return /*#__PURE__*/React.createElement("button", {
    className: classNames$1(classes[variant], classes[size], classes[align], (_classNames = {}, _defineProperty(_classNames, classes === null || classes === void 0 ? void 0 : classes.disabled, disabled), _defineProperty(_classNames, classes === null || classes === void 0 ? void 0 : classes.loading, loading), _defineProperty(_classNames, className, true), _defineProperty(_classNames, classes === null || classes === void 0 ? void 0 : classes.leftIcon, leftIconProp), _defineProperty(_classNames, classes === null || classes === void 0 ? void 0 : classes.rightIcon, rightIconProp), _classNames)),
    "data-action": dataAction,
    "data-test": createTestId(testId),
    disabled: disabled,
    type: type,
    value: value,
    "aria-label": ariaLabel,
    onClick: handleOnClick
  }, loading && /*#__PURE__*/React.createElement("span", {
    className: classes === null || classes === void 0 ? void 0 : classes.loader
  }, /*#__PURE__*/React.createElement("span", {
    "data-test": createTestId(testId, 'isLoading'),
    className: classes === null || classes === void 0 ? void 0 : classes.loaderInner
  })), leftIcon, /*#__PURE__*/React.createElement("span", {
    "data-test": createTestId(testId, 'text'),
    className: classes === null || classes === void 0 ? void 0 : classes.title
  }, children), rightIcon);
};

ButtonV2.displayName = "ButtonV2";
ButtonV2.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  ariaLabel: PropTypes.string,
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.string,
  dataAction: PropTypes.string,
  disabled: PropTypes.bool,
  leftIcon: PropTypes.any,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  rightIcon: PropTypes.any,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'wide']),
  testId: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  value: PropTypes.string,
  variant: PropTypes.oneOf(['danger', 'default', 'info', 'primary', 'secondary', 'tertiary', 'success', 'warning', 'outlined'])
};
ButtonV2.defaultProps = {
  align: 'center',
  ariaLabel: '',
  children: null,
  classes: {},
  className: '',
  dataAction: null,
  disabled: false,
  leftIcon: null,
  loading: false,
  onClick: noop,
  rightIcon: null,
  size: 'medium',
  testId: '',
  type: 'button',
  value: '',
  variant: 'default'
};
var Button$2 = withStyles(styles$p)(ButtonV2);

var styles$q = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    fieldWrapper: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'fieldWrapper',
      margin: '0.5rem 0 0',
      width: '100%'
    }),
    select: {
      composes: 'select',
      display: 'block',
      marginTop: '1.8rem',
      '& .select__wrapper': {
        '& .Select__control': {
          composes: 'select_control',
          backgroundColor: '#ffffff',
          border: '1px solid #e1e7ee',
          boxShadow: 'none',
          borderRadius: 4,
          color: variables.colors.dark,
          height: 48,
          '&:focus': {
            border: '2px solid #0095ff',
            outline: 'none'
          },
          '&:hover': {
            border: '1px solid #a9bac6'
          },
          '&--is-disabled': {
            backgroundColor: variables.colors.greyOne,
            border: "1px solid ".concat(variables.colors.greyTwo)
          },
          '& .Select__indicators': {
            position: 'relative',
            '& .Select__indicator-separator': {
              backgroundColor: 'transparent !important'
            },
            '& .Select__indicator': {
              position: 'absolute',
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)'
            }
          },
          '& .Select__value-container--has-value': {
            '& .Select__single-value': {
              color: '#333',
              marginLeft: '-2px',
              transform: 'translateY(-29%)'
            }
          }
        }
      },
      '& .select__input': {
        outline: 'none'
      },
      '& .select__menu': {
        borderRadius: '0',
        marginTop: '0'
      },
      '& .select__option': {
        cursor: 'pointer',
        '&:hover, &--is-focused': {
          backgroundColor: variables.colors.greyOne
        },
        '&--is-selected, &--is-selected:hover': {
          backgroundColor: variables.colors.primaryAccent,
          cursor: 'auto'
        }
      }
    },
    valid: {
      composes: 'select select--valid',
      display: 'block',
      marginTop: '1.8rem',
      '& .select__wrapper': {
        '& .Select__control': {
          boxShadow: '0px 0px 0px 2px #ffffff',
          outline: 'none',
          border: "2px solid ".concat(variables.colors.typeSuccess),
          backgroundColor: '#ffffff',
          height: 48,
          borderRadius: 4,
          '& .Select__value-container--has-value': {
            '& .Select__single-value': {
              color: '#333',
              marginLeft: '-2px',
              transform: 'translateY(-29%)'
            }
          }
        }
      }
    },
    invalid: {
      composes: 'select select--invalid',
      display: 'block',
      marginTop: '1.8rem',
      '& .select__wrapper': {
        '& .Select__control': {
          boxShadow: '0px 0px 0px 2px #ffffff',
          outline: 'none',
          border: "2px solid ".concat(variables.colors.typeDanger),
          backgroundColor: '#ffffff',
          height: 48,
          borderRadius: 4,
          '& .Select__value-container--has-value': {
            '& .Select__single-value': {
              color: '#333',
              marginLeft: '-2px',
              transform: 'translateY(-29%)'
            }
          }
        }
      }
    },
    disabled: {
      composes: 'select select--disabled',
      display: 'block',
      marginTop: '1.8rem',
      '& .select__wrapper': {
        '& .Select__control': {
          borderRadius: 4,
          border: "1px solid ".concat(variables.colors.greyTwo),
          backgroundColor: '#f1f1f1',
          color: variables.colors.greyOne,
          cursor: 'not-allowed',
          userSelect: 'none',
          '&:hover, &:focus, &:active': {
            borderColor: variables.colors.greyTwo
          },
          '& .Select__value-container--has-value': {
            '& .Select__single-value': {
              color: '#acacac',
              marginLeft: '-2px',
              transform: 'translateY(-29%)'
            }
          }
        }
      }
    },
    wrapper: {
      composes: 'select__wrapper',
      outline: 'none'
    },
    label: {
      composes: 'select__label',
      position: 'absolute',
      transition: 'all 0.3s ease-out',
      transform: 'translate(0, 0.7rem)',
      marginLeft: '0.75rem',
      color: '#838383',
      pointerEvents: 'none',
      fontSize: '1rem',
      width: '100%',
      zIndex: 1
    },
    labelActive: {
      composes: 'select__labelActive',
      color: '#333',
      fontSize: '0.8rem',
      marginLeft: '0.75rem',
      pointerEvents: 'none',
      position: 'absolute',
      transform: 'translate(0.1rem, 0.5rem)',
      transition: 'all 0.3s ease-out',
      zIndex: 1
    },
    required: {
      composes: 'select__required',
      color: "".concat(variables.colors.requiredRed, " !important")
    },
    error: {
      composes: 'inputField__error',
      display: 'block',
      fontSize: '0.8em',
      padding: '0 0.5em',
      border: 'none',
      color: variables.colors.typeDanger,
      backgroundColor: variables.colors.blue,
      marginTop: '0.25em'
    }
  };
};

var Option = components.Option;
/* eslint max-lines-per-function: "off" */

var SelectV2 = function SelectV2(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      controlled = _ref.controlled,
      disabled = _ref.disabled,
      errors = _ref.errors,
      label = _ref.label,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      options = _ref.options,
      placeholder = _ref.placeholder,
      required = _ref.required,
      searchable = _ref.searchable,
      testId = _ref.testId,
      value = _ref.value,
      forwardRef = _ref.forwardRef,
      valid = _ref.valid;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      selectedOption = _useState2[0],
      setSelectedOption = _useState2[1];

  var getInputState = function getInputState() {
    if (disabled) {
      return classes === null || classes === void 0 ? void 0 : classes.disabled;
    } else if (errors.length) {
      return classes === null || classes === void 0 ? void 0 : classes.invalid;
    } else if (valid && !errors.length) {
      return classes === null || classes === void 0 ? void 0 : classes.valid;
    }

    return classes === null || classes === void 0 ? void 0 : classes.select;
  };

  useEffect(function () {
    if (controlled && value !== selectedOption) {
      setSelectedOption(value);
    }
  }, [value]);

  var TextOption = function TextOption(props) {
    return Option && /*#__PURE__*/React.createElement(Option, props, props.label);
  };

  var addTestAttribute = function addTestAttribute(Component) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return function (props) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        innerProps: _objectSpread2(_objectSpread2({}, props.innerProps), {}, {
          // eslint-disable-next-line react/prop-types
          'data-test': createTestId(testId, suffix !== null && suffix !== void 0 ? suffix : props.value)
        })
      }));
    };
  };

  var onHandleChange = function onHandleChange(newValue) {
    onChange(newValue);
    setSelectedOption(newValue);
  };

  var customStyles = {
    control: function control(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        padding: '0.25rem 0.2rem'
      });
    },
    menu: function menu(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        zIndex: 99
      });
    }
  };
  var CUSTOM_COMPONENTS = {
    Option: addTestAttribute(TextOption),
    Menu: addTestAttribute(components.Menu, 'menu')
  };

  var getPlaceholderValue = function getPlaceholderValue() {
    return label ? '' : placeholder;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes === null || classes === void 0 ? void 0 : classes.fieldWrapper
  }, /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId),
    className: "".concat(getInputState(), " ").concat(className !== null && className !== void 0 ? className : '')
  }, label && /*#__PURE__*/React.createElement("label", {
    "data-test": createTestId(testId, 'label'),
    className: value === '' ? classes.label : classes.labelActive
  }, label, required && /*#__PURE__*/React.createElement("span", {
    className: classes.required
  }, "*")), /*#__PURE__*/React.createElement(Select$1, {
    "data-test": createTestId(testId, 'select'),
    className: classes.wrapper,
    classNamePrefix: "Select",
    placeholder: getPlaceholderValue,
    components: CUSTOM_COMPONENTS,
    options: options,
    required: required,
    onChange: onHandleChange,
    onBlur: onBlur,
    onFocus: onFocus,
    isSearchable: searchable,
    isDisabled: disabled,
    value: selectedOption,
    styles: customStyles,
    ref: forwardRef
  })), (errors === null || errors === void 0 ? void 0 : errors.length) ? errors.map(function (error) {
    return /*#__PURE__*/React.createElement("span", {
      key: error,
      className: classes.error
    }, error);
  }) : /*#__PURE__*/React.createElement("span", {
    className: classes.error
  }, "\xA0"));
};

SelectV2.displayName = "SelectV2";
SelectV2.propTypes = {
  classes: PropTypes.shape({
    disabled: PropTypes.string,
    error: PropTypes.string,
    fieldWrapper: PropTypes.string,
    invalid: PropTypes.string,
    label: PropTypes.string,
    labelActive: PropTypes.string,
    required: PropTypes.string,
    select: PropTypes.string,
    valid: PropTypes.string,
    wrapper: PropTypes.string
  }),
  className: PropTypes.string,
  controlled: PropTypes.bool,
  defaultValue: PropTypes.shape({}),
  disabled: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  forwardRef: PropTypes.any,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  searchable: PropTypes.bool,
  testId: PropTypes.string,
  valid: PropTypes.bool,
  value: PropTypes.shape({})
};
SelectV2.defaultProps = {
  classes: {},
  className: null,
  controlled: false,
  defaultValue: null,
  disabled: false,
  errors: [],
  forwardRef: null,
  label: null,
  onBlur: noop,
  onChange: noop,
  onFocus: noop,
  options: [],
  placeholder: 'Please Select',
  required: false,
  searchable: true,
  testId: null,
  valid: null,
  value: null
};
var SelectV2$1 = withStyles(styles$q)(SelectV2);

var styles$r = function styles(_ref) {
  var variables = _ref.variables;
  return {
    container: {
      composes: 'checkbox',
      display: 'flex',
      position: 'relative',
      minHeight: '1.5em',
      lineHeight: '1.5em'
    },
    title: {
      composes: 'checkbox--label-title',
      display: 'block'
    },
    subTitle: {
      composes: 'checkbox--label-sub-title',
      display: 'block'
    },
    checked: {
      composes: 'checkbox--label-checked'
    },
    titleContainer: {
      composes: 'checkbox--label',
      display: 'block',
      margin: '0.5em 0.5em 0.5em 2.5em',
      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        left: '0.25em',
        top: 'calc(50% - 0.5em)',
        margin: '0',
        width: '1em',
        height: '1em',
        zIndex: 0,
        transition: '.1s ease',
        border: '2px solid',
        borderColor: variables.colors.greyFive
      },
      '&$checked::after': {
        content: '""',
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='17' height='14' viewBox='0 0 17 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.76923L6.28571 12L16 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E%0A\")",
        borderWidth: '2px',
        borderStyle: '2px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '75%'
      }
    },
    large: {
      '&$titleContainer': {
        marginLeft: 'calc(1.5em + 1.5em)',
        '&::before, &::after': {
          width: '1.5em',
          height: '1.5em',
          top: 'calc(50% - 0.75em)'
        }
      },
      composes: 'checkbox--large'
    },
    medium: {
      '&$titleContainer': {
        marginLeft: 'calc(1.5em + 1em)',
        '&::before, &::after': {
          width: '1em',
          height: '1em',
          top: 'calc(50% - 0.5em)'
        }
      },
      composes: 'checkbox--medium'
    },
    small: {
      '&$titleContainer': {
        marginLeft: 'calc(1.5em + 0.75em)',
        '&::before, &::after': {
          width: '0.75em',
          height: '0.75em',
          top: 'calc(50% - 0.375em)'
        }
      },
      composes: 'checkbox--small'
    },
    input: {
      composes: 'checkbox--input',
      display: 'none'
    },
    "default": {
      '&::before,&::after': {
        borderColor: variables.colors.greyFive
      },
      '&$checked::before': {
        borderColor: variables.colors.greyFive
      },
      '&:hover, &:active, &:focus': {
        '&::before': {
          boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.greyFive).fade(0.7))
        }
      },
      '&$checked::after': {
        backgroundColor: variables.colors.greyFive,
        borderColor: variables.colors.greyFive
      }
    },
    success: {
      '&::before,&::after': {
        borderColor: variables.colors.typeSuccess
      },
      '&$checked::before': {
        borderColor: variables.colors.typeSuccess
      },
      '&:hover, &:active, &:focus': {
        '&::before': {
          boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.typeSuccess).fade(0.7))
        }
      },
      '&$checked::after': {
        backgroundColor: variables.colors.typeSuccess,
        borderColor: variables.colors.typeSuccess
      }
    },
    primary: {
      '&::before,&::after': {
        borderColor: variables.colors.primaryAccent
      },
      '&$checked::before': {
        borderColor: variables.colors.primaryAccent
      },
      '&:hover, &:active, &:focus': {
        '&::before': {
          boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.primaryAccent).fade(0.7))
        }
      },
      '&$checked::after': {
        backgroundColor: variables.colors.primaryAccent,
        borderColor: variables.colors.primaryAccent
      }
    },
    secondary: {
      '&::before,&::after': {
        borderColor: variables.colors.secondaryAccent
      },
      '&$checked::before': {
        borderColor: variables.colors.secondaryAccent
      },
      '&:hover, &:active, &:focus': {
        '&::before': {
          boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.secondaryAccent).fade(0.7))
        }
      },
      '&$checked::after': {
        backgroundColor: variables.colors.secondaryAccent,
        borderColor: variables.colors.secondaryAccent
      }
    },
    info: {
      '&::before,&::after': {
        borderColor: variables.colors.typeInfo
      },
      '&$checked::before': {
        borderColor: variables.colors.typeInfo
      },
      '&:hover, &:active, &:focus': {
        '&::before': {
          boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.typeInfo).fade(0.7))
        }
      },
      '&$checked::after': {
        backgroundColor: variables.colors.typeInfo,
        borderColor: variables.colors.typeInfo
      }
    },
    warning: {
      '&::before,&::after': {
        borderColor: variables.colors.typeWarning
      },
      '&$checked::before': {
        borderColor: variables.colors.typeWarning
      },
      '&:hover, &:active, &:focus': {
        '&::before': {
          boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.typeWarning).fade(0.7))
        }
      },
      '&$checked::after': {
        backgroundColor: variables.colors.typeWarning,
        borderColor: variables.colors.typeWarning
      }
    },
    danger: {
      '&::before,&::after': {
        borderColor: variables.colors.typeDanger
      },
      '&$checked::before': {
        borderColor: variables.colors.typeDanger
      },
      '&:hover, &:active, &:focus': {
        '&::before': {
          boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.typeDanger).fade(0.7))
        }
      },
      '&$checked::after': {
        backgroundColor: variables.colors.typeDanger,
        borderColor: variables.colors.typeDanger
      }
    },
    disabled: {
      '&::before,&::after': {
        borderColor: variables.colors.greyTwo
      },
      '&$checked::before': {
        borderColor: variables.colors.greyTwo
      },
      '&:hover, &:active, &:focus': {
        '&::before': {
          boxShadow: 'none'
        }
      },
      '&$checked::after': {
        backgroundColor: variables.colors.greyTwo,
        borderColor: variables.colors.greyTwo
      }
    }
  };
};

var Checkbox = function Checkbox(_ref) {
  var _classNames;

  var ariaLabel = _ref.ariaLabel,
      checked = _ref.checked,
      children = _ref.children,
      className = _ref.className,
      classes = _ref.classes,
      disabled = _ref.disabled,
      name = _ref.name,
      onChangeProp = _ref.onChange,
      size = _ref.size,
      title = _ref.title,
      testId = _ref.testId,
      subTitle = _ref.subTitle,
      value = _ref.value,
      variant = _ref.variant;

  var onChange = function onChange(event) {
    return !disabled && onChangeProp(event);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes === null || classes === void 0 ? void 0 : classes.container,
    "data-test": createTestId(testId)
  }, /*#__PURE__*/React.createElement("label", {
    "data-test": createTestId(testId, 'label'),
    className: classNames$1(classes === null || classes === void 0 ? void 0 : classes.titleContainer, classes[variant], classes[size], (_classNames = {}, _defineProperty(_classNames, classes === null || classes === void 0 ? void 0 : classes.disabled, disabled), _defineProperty(_classNames, classes === null || classes === void 0 ? void 0 : classes.checked, checked), _defineProperty(_classNames, className, true), _classNames)),
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement("input", {
    className: classNames$1(classes.input, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.disabled, disabled)),
    type: "checkbox",
    name: name,
    value: value,
    onChange: onChange,
    checked: checked,
    disabled: disabled,
    "data-test": createTestId(testId)
  }), /*#__PURE__*/React.createElement("strong", {
    className: classes === null || classes === void 0 ? void 0 : classes.title
  }, title), /*#__PURE__*/React.createElement("span", {
    className: classes === null || classes === void 0 ? void 0 : classes.subTitle
  }, subTitle)), children);
};

Checkbox.displayName = "Checkbox";
Checkbox.propTypes = {
  ariaLabel: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  subTitle: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.oneOf(['danger', 'default', 'info', 'primary', 'secondary', 'success', 'warning'])
};
Checkbox.defaultProps = {
  ariaLabel: '',
  checked: false,
  children: null,
  classes: {},
  className: '',
  disabled: false,
  name: '',
  onChange: noop,
  size: 'medium',
  subTitle: '',
  testId: '',
  title: '',
  value: 'on',
  variant: 'default'
};
var Checkbox$1 = withStyles(styles$r)(Checkbox);

var styles$s = function styles(_ref) {
  var breakpoints = _ref.breakpoints;
  return {
    container: {
      composes: 'checkboxlist'
    },
    checkboxContainer: {
      composes: 'checkboxlist--container',
      display: 'flex',
      position: 'relative',
      flexDirection: 'column'
    },
    row: _defineProperty({
      flexDirection: 'row',
      alignItems: 'center'
    }, breakpoints.mobileonly, {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }),
    label: _defineProperty({
      composes: 'checkboxlist--label',
      display: 'block',
      marginBottom: '1.5em'
    }, breakpoints.mobileonly, {
      marginBottom: '.5em'
    })
  };
};

var CheckboxList = function CheckboxList(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      classes = _ref.classes,
      direction = _ref.direction,
      onChange = _ref.onChange,
      size = _ref.size,
      label = _ref.label,
      testId = _ref.testId,
      variant = _ref.variant,
      options = _ref.options;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames$1(classes.container, _defineProperty({}, className, true)),
    "data-test": createTestId(testId)
  }, /*#__PURE__*/React.createElement("label", {
    "aria-label": ariaLabel,
    className: classes.label
  }, label), /*#__PURE__*/React.createElement("div", {
    className: classNames$1(classes.checkboxContainer, classes[direction])
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(Checkbox$1, {
      checked: option.checked,
      variant: variant,
      size: size,
      disabled: option.disabled,
      key: option.value,
      name: option.name,
      title: option.title,
      subTitle: option.subTitle,
      value: option.value,
      onChange: onChange
    }, option.children);
  })), children);
};

CheckboxList.displayName = "CheckboxList";
CheckboxList.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'column']),
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    name: PropTypes.string
  })),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  testId: PropTypes.string,
  variant: PropTypes.oneOf(['danger', 'default', 'info', 'primary', 'secondary', 'success', 'warning'])
};
CheckboxList.defaultProps = {
  ariaLabel: '',
  children: null,
  classes: {},
  className: '',
  direction: 'column',
  label: '',
  onChange: noop,
  options: [],
  size: 'medium',
  testId: '',
  variant: 'default'
};
var CheckboxList$1 = withStyles(styles$s)(CheckboxList);

var styles$t = function styles(_ref) {
  var variables = _ref.variables;
  return {
    container: {
      composes: 'radio',
      display: 'flex',
      position: 'relative',
      minHeight: '1.5em',
      lineHeight: '1.5em'
    },
    title: {
      composes: 'radio--label-title',
      display: 'block'
    },
    subTitle: {
      composes: 'radio--label-sub-title',
      display: 'block',
      marginTop: '0.5em'
    },
    titleContainer: {
      composes: 'radio--label',
      display: 'block',
      margin: '0.4em 0 0.5em 0',
      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '10px',
        margin: 0,
        width: '1em',
        height: '1em',
        zIndex: 0,
        transition: '.1s ease',
        borderRadius: '50%',
        border: '2px solid',
        borderColor: variables.colors.greyFive
      }
    },
    large: {
      '&+$titleContainer': {
        marginLeft: 'calc(1em + 1em)',
        '&::before, &::after': {
          width: '1.5em',
          height: '1.5em',
          top: 'calc(25% - 0.75em)'
        }
      },
      composes: 'radio--large'
    },
    medium: {
      '&+$titleContainer': {
        marginLeft: 'calc(1.5em + 1em)',
        '&::before, &::after': {
          width: '1em',
          height: '1em'
        }
      },
      composes: 'radio--medium'
    },
    small: {
      '&+$titleContainer': {
        marginLeft: 'calc(1.5em + 0.75em)',
        '&::before, &::after': {
          width: '0.75em',
          height: '0.75em',
          top: 'calc(34% - 0.75em)'
        }
      },
      composes: 'radio--small'
    },
    input: {
      composes: 'radio--input',
      display: 'none',
      '&:checked+label::after': {
        '-webkit-transform': 'scale(0.6)',
        transform: 'scale(0.6)',
        borderWidth: '2px',
        borderStyle: '2px'
      }
    },
    "default": {
      '&+$titleContainer::before,&+$titleContainer::after': {
        borderColor: variables.colors.greyFive
      },
      '&:checked+$titleContainer::before': {
        borderColor: variables.colors.greyFive
      },
      '&+$titleContainer': {
        '&:hover, &:active, &:focus': {
          '&::before': {
            boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.greyFive).fade(0.7))
          }
        }
      },
      '&:checked+$titleContainer::after': {
        backgroundColor: variables.colors.greyFive,
        borderColor: variables.colors.greyFive
      }
    },
    success: {
      '&+$titleContainer::before,&+$titleContainer::after': {
        borderColor: variables.colors.greyFive
      },
      '&:checked+$titleContainer::before': {
        borderColor: variables.colors.typeSuccess
      },
      '&+$titleContainer': {
        '&:hover, &:active, &:focus': {
          '&::before': {
            boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.typeSuccess).fade(0.7))
          }
        }
      },
      '&:checked+$titleContainer::after': {
        backgroundColor: variables.colors.typeSuccess,
        borderColor: variables.colors.typeSuccess
      }
    },
    primary: {
      '&+$titleContainer::before,&+$titleContainer::after': {
        borderColor: variables.colors.greyFive
      },
      '&:checked+$titleContainer::before': {
        borderColor: variables.colors.primaryAccent
      },
      '&+$titleContainer': {
        '&:hover, &:active, &:focus': {
          '&::before': {
            boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.primaryAccent).fade(0.7))
          }
        }
      },
      '&:checked+$titleContainer::after': {
        backgroundColor: variables.colors.primaryAccent,
        borderColor: variables.colors.primaryAccent
      }
    },
    secondary: {
      '&+$titleContainer::before,&+$titleContainer::after': {
        borderColor: variables.colors.greyFive
      },
      '&:checked+$titleContainer::before': {
        borderColor: variables.colors.secondaryAccent
      },
      '&+$titleContainer': {
        '&:hover, &:active, &:focus': {
          '&::before': {
            boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.secondaryAccent).fade(0.7))
          }
        }
      },
      '&:checked+$titleContainer::after': {
        backgroundColor: variables.colors.secondaryAccent,
        borderColor: variables.colors.secondaryAccent
      }
    },
    info: {
      '&+$titleContainer::before,&+$titleContainer::after': {
        borderColor: variables.colors.greyFive
      },
      '&:checked+$titleContainer::before': {
        borderColor: variables.colors.typeInfo
      },
      '&+$titleContainer': {
        '&:hover, &:active, &:focus': {
          '&::before': {
            boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.typeInfo).fade(0.7))
          }
        }
      },
      '&:checked+$titleContainer::after': {
        backgroundColor: variables.colors.typeInfo,
        borderColor: variables.colors.typeInfo
      }
    },
    warning: {
      '&+$titleContainer::before,&+$titleContainer::after': {
        borderColor: variables.colors.greyFive
      },
      '&:checked+$titleContainer::before': {
        borderColor: variables.colors.typeWarning
      },
      '&+$titleContainer': {
        '&:hover, &:active, &:focus': {
          '&::before': {
            boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.typeWarning).fade(0.7))
          }
        }
      },
      '&:checked+$titleContainer::after': {
        backgroundColor: variables.colors.typeWarning,
        borderColor: variables.colors.typeWarning
      }
    },
    danger: {
      '&+$titleContainer::before,&+$titleContainer::after': {
        borderColor: variables.colors.greyFive
      },
      '&:checked+$titleContainer::before': {
        borderColor: variables.colors.typeDanger
      },
      '&+$titleContainer': {
        '&:hover, &:active, &:focus': {
          '&::before': {
            boxShadow: "0px 0px 5px 3px ".concat(color(variables.colors.typeDanger).fade(0.7))
          }
        }
      },
      '&:checked+$titleContainer::after': {
        backgroundColor: variables.colors.typeDanger,
        borderColor: variables.colors.typeDanger
      }
    },
    disabled: {
      '&+$titleContainer::before,&+$titleContainer::after': {
        borderColor: variables.colors.greyTwo
      },
      '&:checked+$titleContainer::before': {
        borderColor: variables.colors.greyTwo
      },
      '&+$titleContainer': {
        '&:hover, &:active, &:focus': {
          '&::before': {
            boxShadow: 'none'
          }
        }
      },
      '&:checked+$titleContainer::after': {
        backgroundColor: variables.colors.greyTwo,
        borderColor: variables.colors.greyTwo
      }
    }
  };
};

var Radio = function Radio(_ref) {
  var _classNames, _classNames2;

  var ariaLabel = _ref.ariaLabel,
      checked = _ref.checked,
      children = _ref.children,
      className = _ref.className,
      classes = _ref.classes,
      disabled = _ref.disabled,
      name = _ref.name,
      onChangeProp = _ref.onChange,
      size = _ref.size,
      title = _ref.title,
      testId = _ref.testId,
      subTitle = _ref.subTitle,
      valueProp = _ref.value,
      variant = _ref.variant;

  var onChange = function onChange(event) {
    return !disabled && onChangeProp(event);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes === null || classes === void 0 ? void 0 : classes.container,
    "data-test": createTestId(testId)
  }, /*#__PURE__*/React.createElement("input", {
    className: classNames$1(classes.input, classes[variant], classes[size], (_classNames = {}, _defineProperty(_classNames, classes === null || classes === void 0 ? void 0 : classes.disabled, disabled), _defineProperty(_classNames, className, true), _classNames)),
    type: "radio",
    name: name,
    id: "".concat(name, "_id"),
    value: valueProp,
    onChange: onChange,
    checked: checked,
    disabled: disabled,
    "data-test": createTestId(testId)
  }), /*#__PURE__*/React.createElement("label", {
    "data-test": createTestId(testId, 'label'),
    className: classNames$1(classes === null || classes === void 0 ? void 0 : classes.titleContainer, classes[size], (_classNames2 = {}, _defineProperty(_classNames2, classes === null || classes === void 0 ? void 0 : classes.disabled, disabled), _defineProperty(_classNames2, className, true), _classNames2)),
    "aria-label": ariaLabel,
    htmlFor: "".concat(name, "_id")
  }, /*#__PURE__*/React.createElement("strong", {
    className: classes === null || classes === void 0 ? void 0 : classes.title
  }, title), subTitle && /*#__PURE__*/React.createElement("span", {
    className: classes === null || classes === void 0 ? void 0 : classes.subTitle
  }, subTitle)), children);
};

Radio.displayName = "Radio";
Radio.propTypes = {
  ariaLabel: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  subTitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  testId: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  value: PropTypes.string,
  variant: PropTypes.oneOf(['danger', 'default', 'info', 'primary', 'secondary', 'success', 'warning'])
};
Radio.defaultProps = {
  ariaLabel: '',
  checked: false,
  children: null,
  classes: {},
  className: '',
  disabled: false,
  name: '',
  onChange: noop,
  size: 'medium',
  subTitle: '',
  testId: '',
  title: '',
  value: '',
  variant: 'default'
};
var Radio$1 = withStyles(styles$t)(Radio);

var styles$u = function styles(_ref) {
  var breakpoints = _ref.breakpoints;
  return {
    container: {
      composes: 'radiolist'
    },
    radioContainer: {
      composes: 'radiolist--container',
      display: 'flex',
      position: 'relative',
      flexDirection: 'column'
    },
    row: _defineProperty({
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }, breakpoints.mobileonly, {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }),
    label: _defineProperty({
      composes: 'radiolist--label',
      display: 'block',
      marginBottom: '1.5em'
    }, breakpoints.mobileonly, {
      marginBottom: '.5em'
    })
  };
};

var RadioList = function RadioList(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      classes = _ref.classes,
      direction = _ref.direction,
      onChangeProp = _ref.onChange,
      size = _ref.size,
      label = _ref.label,
      name = _ref.name,
      testId = _ref.testId,
      variant = _ref.variant,
      value = _ref.value,
      options = _ref.options;
  var onChange = useCallback(function (newValue) {
    return function (event) {
      return onChangeProp(event, newValue);
    };
  }, [onChangeProp]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames$1(classes.container, _defineProperty({}, className, true)),
    "data-test": createTestId(testId)
  }, /*#__PURE__*/React.createElement("label", {
    "aria-label": ariaLabel,
    className: classes.label
  }, label), /*#__PURE__*/React.createElement("div", {
    className: classNames$1(classes.radioContainer, classes[direction])
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(Radio$1, {
      checked: value === option.value,
      variant: variant,
      size: size,
      disabled: option.disabled,
      key: option.value,
      name: name + option.value,
      title: option.title,
      subTitle: option.subTitle,
      onChange: onChange(option.value)
    }, option.children);
  })), children);
};

RadioList.displayName = "RadioList";
RadioList.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'column']),
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    name: PropTypes.string
  })),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  testId: PropTypes.string,
  value: PropTypes.string,
  variant: PropTypes.oneOf(['danger', 'default', 'info', 'primary', 'secondary', 'success', 'warning'])
};
RadioList.defaultProps = {
  ariaLabel: '',
  children: null,
  classes: {},
  className: '',
  direction: 'column',
  label: '',
  name: 'radio-list',
  onChange: noop,
  options: [],
  size: 'medium',
  testId: '',
  value: null,
  variant: 'default'
};
var RadioList$1 = withStyles(styles$u)(RadioList);

var styles$v = function styles(_ref) {
  var variables = _ref.variables;
  return {
    container: {
      composes: 'radiobox',
      display: 'flex',
      position: 'relative',
      minHeight: '1.5em',
      borderWidth: '1.5px',
      borderStyle: 'solid',
      borderColor: variables.colors.light,
      margin: '0.5em 0',
      transition: 'all 0.2s ease-in',
      textAlign: 'center',
      lineHeight: '1.5em',
      boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.25)",
      '&:hover': {
        '& > label:after': {
          position: 'absolute',
          textAlign: 'center',
          lineHeight: '18px',
          color: '#fff',
          backgroundColor: '#00adef',
          content: '""',
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='17' height='14' viewBox='0 0 17 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.76923L6.28571 12L16 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E%0A\")",
          borderRadius: '50%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '70%'
        }
      }
    },
    center: {
      textAlign: 'center'
    },
    left: {
      textAlign: 'left'
    },
    right: {
      textAlign: 'right'
    },
    checked: {
      composes: 'radiobox--checked'
    },
    title: {
      composes: 'radiobox--label-title',
      display: 'block',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '22px'
    },
    subTitle: {
      composes: 'radiobox--label-sub-title',
      display: 'block'
    },
    titleContainer: {
      composes: 'radiobox--label',
      display: 'block',
      padding: '1em',
      flex: 1
    },
    large: {
      '&+$titleContainer': {
        '&::after': {
          width: '1.5em',
          height: '1.5em',
          top: "calc(50% - 0.75em)",
          right: "-0.9em"
        }
      },
      composes: 'radiobox--large'
    },
    medium: {
      '&+$titleContainer': {
        '&::after': {
          width: '1em',
          height: '1em',
          top: "calc(50% - 0.5em)",
          right: "-0.6em"
        }
      },
      composes: 'radiobox--medium'
    },
    small: {
      '&+$titleContainer': {
        '&::before, &::after': {
          width: '0.75em',
          height: '0.75em',
          top: "calc(50% - 0.375em)",
          right: "-0.4em"
        }
      },
      composes: 'radiobox--small'
    },
    input: {
      composes: 'radiobox--input',
      display: 'none',
      '&:checked+label::after': {
        position: 'absolute',
        textAlign: 'center',
        lineHeight: '18px',
        color: '#fff',
        backgroundColor: '#00adef',
        content: '""',
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='17' height='14' viewBox='0 0 17 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.76923L6.28571 12L16 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E%0A\")",
        borderRadius: '50%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '70%'
      }
    },
    "default": {
      '&:hover, &$checked': {
        borderColor: variables.colors.greyFive
      },
      '&:hover > $titleContainer:after, &$checked  > $titleContainer:after': {
        backgroundColor: variables.colors.greyFive
      },
      '&+$titleContainer::after': {
        borderColor: variables.colors.greyFive
      }
    },
    success: {
      '&:hover,&$checked': {
        borderColor: variables.colors.typeSuccess
      },
      '&:hover > $titleContainer:after, &$checked  > $titleContainer:after': {
        backgroundColor: variables.colors.typeSuccess
      },
      '&+$titleContainer::after': {
        borderColor: variables.colors.typeSuccess
      }
    },
    primary: {
      '&:hover,&$checked': {
        borderColor: variables.colors.primaryAccent
      },
      '&:hover > $titleContainer:after, &$checked  > $titleContainer:after': {
        backgroundColor: variables.colors.primaryAccent
      },
      '&+$titleContainer::after': {
        borderColor: variables.colors.primaryAccent
      },
      orderColor: variables.colors.primaryAccent
    },
    secondary: {
      '&:hover,&$checked': {
        borderColor: variables.colors.secondaryAccent
      },
      '&:hover > $titleContainer:after, &$checked  > $titleContainer:after': {
        backgroundColor: variables.colors.secondaryAccent
      },
      '&+$titleContainer::after': {
        borderColor: variables.colors.secondaryAccent
      }
    },
    info: {
      '&:hover,&$checked': {
        borderColor: variables.colors.typeInfo
      },
      '&:hover > $titleContainer:after, &$checked  > $titleContainer:after': {
        backgroundColor: variables.colors.typeInfo
      },
      '&+$titleContainer::after': {
        borderColor: variables.colors.typeInfo
      }
    },
    warning: {
      '&:hover,&$checked': {
        borderColor: variables.colors.typeWarning
      },
      '&:hover > $titleContainer:after, &$checked  > $titleContainer:after': {
        backgroundColor: variables.colors.typeWarning
      },
      '&+$titleContainer::after': {
        borderColor: variables.colors.typeWarning
      }
    },
    danger: {
      '&:hover,&$checked': {
        borderColor: variables.colors.typeDanger
      },
      '&:hover > $titleContainer:after, &$checked  > $titleContainer:after': {
        backgroundColor: variables.colors.typeDanger
      },
      '&+$titleContainer::after': {
        borderColor: variables.colors.typeDanger
      }
    },
    disabled: {
      '&:hover, &$checked': {
        borderColor: variables.colors.light,
        '&+$titleContainer::after': {
          borderColor: variables.colors.greyTwo
        },
        '&  > $titleContainer:after': {
          backgroundColor: variables.colors.greyTwo
        }
      },
      '&:hover:not($checked) > $titleContainer:after': {
        content: 'unset'
      }
    }
  };
};

var RadioBox = function RadioBox(_ref) {
  var _classNames;

  var ariaLabel = _ref.ariaLabel,
      checked = _ref.checked,
      children = _ref.children,
      className = _ref.className,
      classes = _ref.classes,
      disabled = _ref.disabled,
      align = _ref.align,
      name = _ref.name,
      onChangeProp = _ref.onChange,
      size = _ref.size,
      title = _ref.title,
      testId = _ref.testId,
      subTitle = _ref.subTitle,
      variant = _ref.variant;

  var onChange = function onChange(event) {
    return !disabled && onChangeProp(event);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames$1(classes === null || classes === void 0 ? void 0 : classes.container, classes[variant], classes[align], (_classNames = {}, _defineProperty(_classNames, classes === null || classes === void 0 ? void 0 : classes.disabled, disabled), _defineProperty(_classNames, classes.checked, checked), _defineProperty(_classNames, className, true), _classNames)),
    "data-test": createTestId(testId)
  }, /*#__PURE__*/React.createElement("input", {
    className: classNames$1(classes.input, classes[variant], classes[size], _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.disabled, disabled)),
    type: "radio",
    name: name,
    id: "".concat(name, "_id"),
    value: "activate",
    onChange: onChange,
    checked: checked,
    disabled: disabled,
    "data-test": createTestId(testId)
  }), /*#__PURE__*/React.createElement("label", {
    "data-test": createTestId(testId, 'label'),
    className: classNames$1(classes === null || classes === void 0 ? void 0 : classes.titleContainer, classes[size]),
    "aria-label": ariaLabel,
    htmlFor: "".concat(name, "_id")
  }, /*#__PURE__*/React.createElement("span", {
    className: classes === null || classes === void 0 ? void 0 : classes.title
  }, title), subTitle && /*#__PURE__*/React.createElement("span", {
    className: classes === null || classes === void 0 ? void 0 : classes.subTitle
  }, subTitle)), children);
};

RadioBox.displayName = "RadioBox";
RadioBox.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  ariaLabel: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  subTitle: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.oneOf(['danger', 'default', 'info', 'primary', 'secondary', 'success', 'warning'])
};
RadioBox.defaultProps = {
  align: 'center',
  ariaLabel: '',
  checked: false,
  children: null,
  classes: {},
  className: '',
  disabled: false,
  name: '',
  onChange: noop,
  size: 'medium',
  subTitle: '',
  testId: '',
  title: '',
  variant: 'default'
};
var RadioBox$1 = withStyles(styles$v)(RadioBox);

var styles$w = function styles(_ref) {
  var breakpoints = _ref.breakpoints;
  return {
    container: {
      composes: 'radioboxlist'
    },
    radioboxContainer: {
      composes: 'radioboxlist--container',
      display: 'flex',
      position: 'relative',
      flexDirection: 'column',
      alignItems: 'stretch',
      '&>div': {
        alignItems: 'center'
      }
    },
    radioItem: {
      flexGrow: 1
    },
    row: _defineProperty({
      flexDirection: 'row',
      justifyContent: 'space-between'
    }, breakpoints.mobileonly, {
      flexDirection: 'column',
      alignItems: 'stretch'
    }),
    label: _defineProperty({
      composes: 'radioboxlist--label',
      display: 'block',
      marginBottom: '1.5em'
    }, breakpoints.mobileonly, {
      marginBottom: '.5em'
    })
  };
};

var RadioBoxList = function RadioBoxList(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      classes = _ref.classes,
      direction = _ref.direction,
      align = _ref.align,
      onChangeProp = _ref.onChange,
      size = _ref.size,
      label = _ref.label,
      name = _ref.name,
      testId = _ref.testId,
      variant = _ref.variant,
      value = _ref.value,
      options = _ref.options;
  var onChange = useCallback(function (newValue) {
    return function (event) {
      return onChangeProp(event, newValue);
    };
  }, [onChangeProp]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames$1(classes.container, _defineProperty({}, className, true)),
    "data-test": createTestId(testId)
  }, /*#__PURE__*/React.createElement("label", {
    "aria-label": ariaLabel,
    className: classes.label
  }, label), /*#__PURE__*/React.createElement("div", {
    className: classNames$1(classes.radioboxContainer, classes[direction])
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(RadioBox$1, {
      className: classes.radioItem,
      checked: value === option.value,
      align: align,
      variant: variant,
      size: size,
      disabled: option.disabled,
      key: option.value,
      name: name + option.value,
      title: option.title,
      subTitle: option.subTitle,
      onChange: onChange(option.value)
    }, option.children);
  })), children);
};

RadioBoxList.displayName = "RadioBoxList";
RadioBoxList.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  ariaLabel: PropTypes.string,
  children: PropTypes.any,
  classes: PropTypes.object,
  className: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'column']),
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    name: PropTypes.string
  })),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  testId: PropTypes.string,
  value: PropTypes.string,
  variant: PropTypes.oneOf(['danger', 'default', 'info', 'primary', 'secondary', 'success', 'warning'])
};
RadioBoxList.defaultProps = {
  align: 'center',
  ariaLabel: '',
  children: null,
  classes: {},
  className: '',
  direction: 'column',
  label: '',
  name: 'radiobox-list',
  onChange: noop,
  options: [],
  size: 'medium',
  testId: '',
  value: null,
  variant: 'default'
};
var RadioBoxList$1 = withStyles(styles$w)(RadioBoxList);

var styles$x = {
  phoneField: {
    composes: 'phoneField',
    position: 'relative',
    '& > .PhoneInputCountry': {
      position: 'absolute',
      zIndex: 1,
      left: '1rem',
      height: '63px !important',
      '&:after': {
        content: "''",
        height: '23%',
        width: '1px',
        display: 'block',
        background: '#767677',
        marginLeft: '0.5em'
      },
      '& .PhoneInputCountrySelectArrow': {
        borderColor: '#ffffff'
      }
    }
  },
  input: {
    '& label.inputField__label': {
      left: '2.5em',
      transform: 'translate(1em, 0.95rem)'
    },
    '& input': {
      padding: '0.2rem 4em 0',
      color: '#333'
    }
  }
};

var PhoneField = function PhoneField(_ref) {
  var ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      classes = _ref.classes,
      controlled = _ref.controlled,
      disabled = _ref.disabled,
      defaultCountry = _ref.defaultCountry,
      label = _ref.label,
      errors = _ref.errors,
      lineBlank = _ref.lineBlank,
      id = _ref.id,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      required = _ref.required,
      testId = _ref.testId,
      value = _ref.value,
      autoComplete = _ref.autoComplete,
      valid = _ref.valid,
      name = _ref.name,
      forwardRef = _ref.forwardRef,
      showBlankSpace = _ref.showBlankSpace;
  return /*#__PURE__*/React.createElement(PhoneInput, {
    defaultCountry: defaultCountry,
    id: id,
    required: required,
    "aria-required": true,
    autoComplete: autoComplete,
    className: classNames$1(classes.phoneField, _defineProperty({}, className, true)),
    disabled: disabled,
    name: name,
    onBlur: disabled ? noop : onBlur,
    onFocus: disabled ? noop : onFocus,
    onChange: disabled ? noop : onChange,
    type: "tel",
    "data-test": createTestId(testId, 'phone-number'),
    value: value,
    inputComponent: InputFieldV2$1,
    label: label,
    "aria-label": ariaLabel,
    errors: errors,
    valid: valid,
    numberInputProps: {
      className: classes.input
    },
    ref: forwardRef,
    controlled: controlled,
    showBlankSpace: showBlankSpace,
    lineBlank: lineBlank
  });
};

PhoneField.displayName = "PhoneField";
PhoneField.propTypes = {
  ariaLabel: PropTypes.string,
  autoComplete: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  controlled: PropTypes.bool,
  defaultCountry: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  forwardRef: PropTypes.any,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  lineBlank: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  required: PropTypes.bool,
  showBlankSpace: PropTypes.bool,
  testId: PropTypes.string,
  valid: PropTypes.bool,
  value: PropTypes.string
};
PhoneField.defaultProps = {
  ariaLabel: '',
  autoComplete: '',
  classes: {},
  className: null,
  controlled: false,
  defaultCountry: 'GB',
  disabled: false,
  errors: [],
  forwardRef: null,
  lineBlank: 1,
  name: '',
  onBlur: noop,
  onFocus: noop,
  required: false,
  showBlankSpace: false,
  testId: null,
  valid: true,
  value: null
};
var PhoneField$1 = withStyles(styles$x)(PhoneField);

var styles$y = function styles(_ref) {
  var variables = _ref.variables;
  return {
    addNewAddressBtn: {
      padding: '1rem',
      width: '358px',
      maxWidth: '358px',
      height: '240px',
      backgroundColor: variables.colors.trueWhite,
      boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.25)',
      margin: '1rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: 0,
      flexDirection: 'column'
    },
    addNewAddressBtnLabel: {
      display: 'flex',
      color: variables.colors.trueBlack,
      padding: '0 6px',
      fontWeight: 600,
      marginBottom: '2rem'
    }
  };
};

var AddNewAddressBtn = function AddNewAddressBtn(_ref) {
  var classes = _ref.classes,
      onCreateNew = _ref.onCreateNew,
      testId = _ref.testId;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classes.addNewAddressBtn,
    onClick: onCreateNew,
    "data-test": createTestId(testId, 'button')
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.addNewAddressBtnLabel
  }, "Add new address"), /*#__PURE__*/React.createElement(Icon$1, {
    icon: ICON_PLUS
  }));
};

AddNewAddressBtn.displayName = "AddNewAddressBtn";
AddNewAddressBtn.propTypes = {
  classes: PropTypes.shape({
    addNewAddressBtn: PropTypes.string.isRequired,
    addNewAddressBtnLabel: PropTypes.string.isRequired
  }),
  onCreateNew: PropTypes.func,
  testId: PropTypes.string
};
AddNewAddressBtn.defaultProps = {
  classes: {},
  onCreateNew: noop,
  testId: ''
};
var AddNewAddressBtn$1 = withStyles(styles$y)(AddNewAddressBtn);

var styles$z = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    status: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'Status',
      display: 'flex',
      justifyContent: 'center',
      maxWidth: '73px',
      width: '73px',
      height: '26px',
      borderRadius: '4px',
      '& span': {
        color: variables.colors.trueWhite,
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: '24px',
        textAlign: 'center'
      }
    }),
    disabled: {
      composes: 'Status Status--disabled',
      backgroundColor: variables.colors.greyThree
    },
    off: {
      composes: 'Status Status--off',
      backgroundColor: variables.colors.inActiveRed
    },
    on: {
      composes: 'Status Status--on',
      backgroundColor: variables.colors.activeGreen
    }
  };
};

var Status = function Status(_ref) {
  var classes = _ref.classes,
      testId = _ref.testId,
      type = _ref.type;
  var statusType = {
    on: classes.on,
    off: classes.off,
    disabled: classes.disabled
  };
  var statusText = {
    on: 'On sale',
    off: 'Off sale',
    disabled: 'Inactive'
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId, 'statusType'),
    className: "".concat(classes.status, " ").concat(statusType[type])
  }, /*#__PURE__*/React.createElement("span", null, statusText[type]));
};

Status.displayName = "Status";
Status.propTypes = {
  classes: PropTypes.shape({
    disabled: PropTypes.string,
    off: PropTypes.string,
    on: PropTypes.string,
    status: PropTypes.string
  }),
  testId: PropTypes.string,
  type: PropTypes.oneOf(['on', 'off', 'disabled'])
};
Status.defaultProps = {
  classes: {},
  testId: null,
  type: 'disabled'
};
var Status$1 = withStyles(styles$z)(Status);

var styles$A = function styles(_ref) {
  var variables = _ref.variables;
  return {
    ActionListContainer: {
      composes: 'ActionList-container',
      maxWidth: '112px',
      borderRadius: 4,
      backgroundColor: variables.colors.trueWhite,
      boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)',
      position: 'relative',
      padding: '1rem 0.5rem 0.5rem 0.7rem',
      width: '98px',
      zIndex: '10'
    },
    ActionListStackList: {
      composes: 'ActionList-listStack',
      display: 'flex',
      flexDirection: 'column',
      margin: 0,
      paddingLeft: 0
    },
    ActionListStackItem: {
      composes: 'ActionList-listStack__item',
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '0.5rem'
    },
    ActionListBtn: {
      composes: 'ActionList-btn',
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 0,
      color: variables.colors.trueBlack,
      display: 'flex',
      fontFamily: 'Montserrat',
      fontSize: '12px',
      height: '22px',
      justifyContent: 'flex-start',
      position: 'relative',
      transition: 'all 0s ease-in-out',
      width: '100%',
      '& svg': {
        left: '7px',
        marginRight: '1rem',
        position: 'absolute'
      },
      '& span': {
        fontFamily: 'Montserrat',
        fontWeight: '600',
        marginLeft: '1.5rem'
      },
      '&:disabled': {
        color: variables.colors.greyThree
      },
      '&:hover:not(:disabled)': {
        transition: 'all 0s ease-in-out',
        '& span': {
          color: variables.colors.inActiveRed,
          fontWeight: '700'
        },
        '& svg': {
          color: variables.colors.inActiveRed
        }
      }
    }
  };
};

var useOnClickOutside = function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, // Add ref and handler to effect dependencies
  // It's worth noting that because passed in handler is a new ...
  // ... function on every render that will cause this effect ...
  // ... callback/cleanup to run every render. It's not a big deal ...
  // ... but to optimize you can wrap handler in useCallback before ...
  // ... passing it into this hook.
  [ref, handler]);
};

var ActionList = function ActionList(_ref) {
  var classes = _ref.classes,
      testId = _ref.testId,
      show = _ref.show,
      showCallBack = _ref.showCallBack,
      actionList = _ref.actionList;
  var compRef = /*#__PURE__*/createRef();
  useOnClickOutside(compRef, function () {
    return showCallBack(!show);
  });

  var renderActionList = function renderActionList() {
    return actionList.map(function (_ref2) {
      var label = _ref2.label,
          icon = _ref2.icon,
          action = _ref2.action,
          isDisabled = _ref2.isDisabled;
      return /*#__PURE__*/React.createElement("li", {
        key: label,
        className: classes.ActionListStackItem
      }, /*#__PURE__*/React.createElement("button", {
        "data-test": createTestId(label, 'btn'),
        className: classes.ActionListBtn,
        onClick: action,
        type: "button",
        disabled: isDisabled
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: icon
      }), /*#__PURE__*/React.createElement("span", {
        className: "label"
      }, label)));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement("div", {
    ref: compRef,
    className: classes.ActionListContainer,
    "data-test": createTestId(testId, 'comp')
  }, /*#__PURE__*/React.createElement("ul", {
    className: classes.ActionListStackList
  }, renderActionList())));
};

ActionList.propTypes = {
  actionList: PropTypes.arrayOf(PropTypes.shape({
    action: PropTypes.func.isRequired,
    icon: PropTypes.any.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  classes: PropTypes.shape({
    ActionListBtn: PropTypes.string,
    ActionListContainer: PropTypes.string,
    ActionListStackItem: PropTypes.string,
    ActionListStackList: PropTypes.string
  }),
  show: PropTypes.bool,
  showCallBack: PropTypes.func,
  testId: PropTypes.string
};
ActionList.defaultProps = {
  classes: {},
  show: false,
  showCallBack: noop$1,
  testId: null
};
var ActionList$1 = withStyles(styles$A)(ActionList);

var styles$B = function styles(_ref) {
  var variables = _ref.variables;
  return {
    TabListContainer: {
      composes: 'TabList-container',
      height: '91px',
      position: 'relative'
    },
    TabListStackList: {
      composes: 'TabList-listStack',
      display: 'flex',
      flexDirection: 'row',
      margin: 0,
      paddingLeft: 0
    },
    TabListStackItem: {
      composes: 'TabList-listStack__item',
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '0.5rem',
      '&:not(:last-child)': {
        marginRight: '3rem'
      }
    },
    TabListBtn: {
      composes: 'TabList-btn',
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 0,
      color: variables.colors.textBlack,
      display: 'flex',
      fontSize: '20px',
      justifyContent: 'flex-start',
      width: '100%',
      padding: '0 0 0.25rem 0',
      marginBottom: '3px',
      '&:disabled': {
        color: variables.colors.greyThree
      },
      '&:hover:not(:disabled)': {
        color: variables.colors.inActiveRed
      }
    },
    TabListActive: {
      composes: 'TabList-active',
      fontWeight: 'bold',
      marginBottom: '0',
      borderBottom: "3px solid ".concat(variables.colors.inActiveRed)
    }
  };
};

var TabList = function TabList(_ref) {
  var classes = _ref.classes,
      onClick = _ref.onClick,
      tabs = _ref.tabs,
      testId = _ref.testId,
      valueProp = _ref.value;

  var renderList = function renderList() {
    return tabs.map(function (_ref2) {
      var value = _ref2.value,
          label = _ref2.label,
          isDisabled = _ref2.isDisabled;
      return /*#__PURE__*/React.createElement("li", {
        key: label,
        className: classes.TabListStackItem
      }, /*#__PURE__*/React.createElement("button", {
        "data-test": createTestId(value, 'btn'),
        className: classNames$1(classes.TabListBtn, _defineProperty({}, classes.TabListActive, valueProp === value)),
        onClick: isDisabled ? null : onClick,
        value: value,
        type: "button",
        disabled: isDisabled
      }, label));
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.TabListContainer,
    "data-test": createTestId(testId, 'comp')
  }, /*#__PURE__*/React.createElement("ul", {
    className: classes.TabListStackList
  }, renderList()));
};

TabList.displayName = "TabList";
TabList.propTypes = {
  classes: PropTypes.shape({
    TabListContainer: PropTypes.string,
    TabListBtn: PropTypes.string,
    TabListStackItem: PropTypes.string,
    TabListStackList: PropTypes.string,
    TabListActive: PropTypes.string
  }),
  onClick: PropTypes.func,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    isDisabled: PropTypes.bool
  })),
  testId: PropTypes.string,
  value: PropTypes.string
};
TabList.defaultProps = {
  classes: {},
  onClick: noop,
  tabs: [],
  testId: null,
  value: ''
};
var TabList$1 = withStyles(styles$B)(TabList);

var styles$C = function styles(_ref) {
  var variables = _ref.variables;
  return {
    ButtonGroupContainer: {
      composes: 'ButtonGroup-container',
      height: '91px',
      position: 'relative'
    },
    ButtonGroup: {
      composes: 'ButtonGroup',
      display: 'flex',
      flexDirection: 'row',
      margin: 0,
      paddingLeft: 0
    },
    ButtonGroupRow: {
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    ButtonGroupColumn: {
      flexDirection: 'column',
      '&:not(:last-child)': {
        marginBottom: '1em'
      }
    },
    ButtonGroupStackItem: {
      composes: 'ButtonGroup__item',
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '1rem'
    },
    ButtonGroupBtn: {
      composes: 'ButtonGroup-btn',
      alignItems: 'center',
      color: variables.colors.textBlack,
      display: 'flex',
      fontSize: '20px',
      justifyContent: 'flex-start',
      width: '100%',
      borderRadius: '10px !important',
      '&:disabled': {
        color: variables.colors.greyThree
      }
    },
    ButtonGroupActive: {
      composes: 'ButtonGroup__active',
      backgroundColor: "".concat(variables.colors.inActiveRed, " !important"),
      color: "".concat(variables.colors.trueWhite, " !important")
    }
  };
};

var ButtonGroup = function ButtonGroup(_ref) {
  var _buttons$, _classNames2;

  var classes = _ref.classes,
      defaultSelected = _ref.defaultSelected,
      direction = _ref.direction,
      onClick = _ref.onClick,
      buttons = _ref.buttons,
      testId = _ref.testId,
      selectedProp = _ref.selected;
  var selected = selectedProp || defaultSelected && ((_buttons$ = buttons[0]) === null || _buttons$ === void 0 ? void 0 : _buttons$.value);

  var renderList = function renderList() {
    return buttons.map(function (_ref2) {
      var id = _ref2.id,
          value = _ref2.value,
          label = _ref2.label,
          isDisabled = _ref2.isDisabled;
      return /*#__PURE__*/React.createElement("li", {
        key: id,
        className: classes.ButtonGroupStackItem
      }, /*#__PURE__*/React.createElement(Button$2, {
        testId: "".concat(id, "-btn"),
        className: classNames$1(classes.ButtonGroupBtn, _defineProperty({}, classes.ButtonGroupActive, selected === value)),
        onClick: onClick,
        value: value,
        type: "button",
        disabled: isDisabled
      }, label));
    });
  };

  return /*#__PURE__*/React.createElement("ul", {
    "data-test": createTestId(testId, 'comp'),
    className: classNames$1(classes.ButtonGroup, (_classNames2 = {}, _defineProperty(_classNames2, classes.ButtonGroupRow, direction === 'row'), _defineProperty(_classNames2, classes.ButtonGroupColumn, direction === 'column'), _classNames2))
  }, renderList());
};

ButtonGroup.displayName = "ButtonGroup";
ButtonGroup.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    isDisabled: PropTypes.bool
  })),
  classes: PropTypes.shape({
    ButtonGroupContainer: PropTypes.string,
    ButtonGroupBtn: PropTypes.string,
    ButtonGroupStackItem: PropTypes.string,
    ButtonGroup: PropTypes.string,
    ButtonGroupActive: PropTypes.string,
    ButtonGroupRow: PropTypes.string,
    ButtonGroupColumn: PropTypes.string
  }),
  defaultSelected: PropTypes.bool,
  direction: PropTypes.oneOf(['row', 'column']),
  onClick: PropTypes.func,
  selected: PropTypes.string,
  testId: PropTypes.string
};
ButtonGroup.defaultProps = {
  buttons: [],
  classes: {},
  defaultSelected: false,
  direction: 'row',
  onClick: noop,
  selected: '',
  testId: null
};
var ButtonGroup$1 = withStyles(styles$C)(ButtonGroup);

var styles$D = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    Avatar: _objectSpread2(_objectSpread2({
      composes: 'avatar'
    }, mixins.init()), {}, {
      backgroundColor: variables.colors.trueWhite,
      border: '1px solid',
      borderColor: variables.colors.greyThree,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden'
    }),
    AvatarImage: {
      composes: 'avatar--image',
      width: '100%',
      height: '100%'
    },
    AvatarInitials: {
      composes: 'avatar--text',
      display: 'flex'
    },
    small: {
      composes: 'avatar--small',
      fontSize: '12px',
      height: '26px',
      width: '26px',
      '& .default-img': {
        width: '12px',
        height: '16px'
      }
    },
    medium: {
      composes: 'avatar--medium',
      fontSize: '14px',
      height: '33px',
      width: '33px',
      '& .default-img': {
        width: '14px',
        height: '18px'
      }
    },
    large: {
      composes: 'avatar--large',
      fontSize: '16px',
      height: '42px',
      width: '42px',
      '& .default-img': {
        width: '20px',
        height: '23px'
      }
    },
    circle: {
      composes: 'avatar--circle',
      borderRadius: '100%'
    },
    rounded: {
      composes: 'avatar--rounded',
      borderRadius: '5px'
    },
    square: {
      composes: 'avatar--square',
      borderRadius: 0
    },
    DefaultImage: {
      composes: 'default-img',
      width: '100%',
      height: '100%'
    }
  };
};

var Avatar = function Avatar(_ref) {
  var alt = _ref.alt,
      classes = _ref.classes,
      src = _ref.src,
      size = _ref.size,
      type = _ref.type,
      testId = _ref.testId,
      variant = _ref.variant;

  var getAcronym = function getAcronym(text) {
    return text.split(/\s/).reduce(function (accumulator, word) {
      return accumulator + word.charAt(0);
    }, '');
  };

  return /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId, 'comp'),
    className: classNames$1(classes.Avatar, classes[variant], classes[size])
  }, type === 'image' ? /*#__PURE__*/React.createElement("img", {
    className: src.includes('LOGO') ? classes.DefaultImage : classes.AvatarImage,
    src: src,
    alt: alt
  }) : /*#__PURE__*/React.createElement("span", {
    className: classes.AvatarInitials
  }, getAcronym(alt)));
};

Avatar.displayName = "Avatar";
Avatar.propTypes = {
  alt: PropTypes.string,
  classes: PropTypes.shape({
    Avatar: PropTypes.string,
    AvatarImage: PropTypes.string,
    AvatarInitials: PropTypes.string,
    DefaultImage: PropTypes.string
  }),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  src: PropTypes.string,
  testId: PropTypes.string,
  type: PropTypes.oneOf(['image', 'text']),
  variant: PropTypes.oneOf(['circle', 'rounded', 'square'])
};
Avatar.defaultProps = {
  alt: 'KB',
  classes: {},
  size: 'medium',
  src: 'https://kaboodlecdn.s3.eu-west-1.amazonaws.com/Kaboodle/KAB_LOGO-RGB-ICON-RED.png',
  testId: '',
  type: 'text',
  variant: 'circle'
};
var Avatar$1 = withStyles(styles$D)(Avatar);

var styles$E = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    ValidationModalWrapper: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'ValidationModal-wrapper',
      backgroundColor: variables.colors.trueWhite,
      borderRadius: 4,
      border: '1px solid transparent',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      height: '176px',
      maxWidth: '383px',
      padding: '0.8rem',
      width: '383px',
      overflow: 'hidden'
    }),
    ValidationModalContainer: {
      composes: 'ValidationModal-container',
      height: '100%',
      padding: '1rem 2rem',
      width: '100%',
      position: 'relative',
      paddingTop: 0
    },
    ValidationModalTitle: {
      composes: 'ValidationModal-title',
      fontSize: '16px',
      fontWeight: 700,
      marginBottom: '0.85rem'
    },
    ValidationModalDesc: {
      composes: 'ValidationModal-desc',
      color: variables.colors.trueBlack,
      fontSize: '13px',
      fontWeight: 400,
      marginBottom: '0.75rem',
      lineHeight: 1.25,
      width: '100%'
    },
    ValidationModalFooter: {
      composes: 'ValidationModal-footer',
      border: '13px',
      bottom: 0,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: ' space-evenly',
      position: 'absolute',
      width: '84%',
      '& button': {
        display: 'flex',
        alignItems: 'center',
        padding: '0.46rem 0.75rem',
        width: '70%',
        '& span': {
          fontSize: '14px',
          lineHeight: '1.2'
        },
        '&:first-child': {
          marginRight: '0.75rem'
        },
        '&:last-child': {
          border: 'none',
          '& span': {
            color: '#787878'
          }
        }
      }
    }
  };
};

var ValidationModal = function ValidationModal(_ref) {
  var classes = _ref.classes,
      eventType = _ref.eventType,
      message = _ref.message,
      onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      testId = _ref.testId;

  var capitalize = function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  var getTitle = function getTitle(type) {
    var eventTitle = {
      accept: 'Accept Changes',
      copy: 'Do you want to copy this event ?',
      "delete": 'Delete Event'
    };
    return eventTitle[type];
  };

  var getVariantStyle = function getVariantStyle(type) {
    var eventTitle = {
      accept: 'primary',
      copy: 'tertiary',
      "delete": 'danger'
    };
    return eventTitle[type];
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.ValidationModalWrapper,
    "data-test": createTestId(testId, 'comp')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.ValidationModalContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.ValidationModalTitle
  }, getTitle(eventType)), /*#__PURE__*/React.createElement("div", {
    className: classes.ValidationModalDesc
  }, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: message
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.ValidationModalFooter
  }, /*#__PURE__*/React.createElement(Button$2, {
    testId: "confirmBtn",
    onClick: onConfirm,
    size: "small",
    variant: getVariantStyle(eventType)
  }, capitalize(eventType)), /*#__PURE__*/React.createElement(Button$2, {
    testId: "cancelBtn",
    onClick: onCancel,
    size: "small",
    variant: "secondary"
  }, "Cancel"))));
};

ValidationModal.displayName = "ValidationModal";
ValidationModal.propTypes = {
  classes: PropTypes.shape({
    ValidationModalWrapper: PropTypes.string,
    ValidationModalContainer: PropTypes.string,
    ValidationModalTitle: PropTypes.string,
    ValidationModalDesc: PropTypes.string,
    ValidationModalFooter: PropTypes.string
  }),
  eventType: PropTypes.oneOf(['accept', 'copy', 'delete']),
  message: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  testId: PropTypes.string
};
ValidationModal.defaultProps = {
  classes: {},
  eventType: 'accept',
  message: '',
  onCancel: noop,
  onConfirm: noop,
  testId: null
};
var ValidationModal$1 = withStyles(styles$E)(ValidationModal);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "/* DayPicker styles */\n\n.style_DayPicker__b_Yn_ {\n  display: inline-block;\n  font-size: 1rem;\n}\n\n.style_DayPicker-wrapper__1DQ2u {\n  position: relative;\n\n  flex-direction: row;\n  padding-bottom: 1em;\n\n  -webkit-user-select: none;\n\n     -moz-user-select: none;\n\n      -ms-user-select: none;\n\n          user-select: none;\n}\n\n.style_DayPicker-Months__30tQu {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.style_DayPicker-Month__1HU_F {\n  display: table;\n  margin: 0 1em;\n  margin-top: 1em;\n  border-spacing: 0;\n  border-collapse: collapse;\n\n  -webkit-user-select: none;\n\n     -moz-user-select: none;\n\n      -ms-user-select: none;\n\n          user-select: none;\n}\n\n.style_DayPicker-NavBar__2jS0A {\n}\n\n.style_DayPicker-NavButton__2Hu2W {\n  position: absolute;\n  top: 1em;\n  right: 1.5em;\n  left: auto;\n\n  display: inline-block;\n  margin-top: 2px;\n  width: 1.25em;\n  height: 1.25em;\n  background-position: center;\n  background-size: 50%;\n  background-repeat: no-repeat;\n  color: #8B9898;\n  cursor: pointer;\n}\n\n.style_DayPicker-NavButton__2Hu2W:hover {\n  opacity: 0.8;\n}\n\n.style_DayPicker-NavButton--prev__2HxCU {\n  margin-right: 1.5em;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC');\n}\n\n.style_DayPicker-NavButton--next__3Lca4 {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==');\n}\n\n.style_DayPicker-NavButton--interactionDisabled__31kmP {\n  display: none;\n}\n\n.style_DayPicker-Caption__2dsPy {\n  display: table-caption;\n  margin-bottom: 0.5em;\n  padding: 0 0.5em;\n  text-align: left;\n}\n\n.style_DayPicker-Caption__2dsPy > div {\n  font-weight: 500;\n  font-size: 1.15em;\n}\n\n.style_DayPicker-Weekdays__1rmHF {\n  display: table-header-group;\n  margin-top: 1em;\n}\n\n.style_DayPicker-WeekdaysRow__2epDC {\n  display: table-row;\n}\n\n.style_DayPicker-Weekday__2-qDg {\n  display: table-cell;\n  padding: 0.5em;\n  color: #8B9898;\n  text-align: center;\n  font-size: 0.875em;\n}\n\n.style_DayPicker-Weekday__2-qDg abbr[title] {\n  border-bottom: none;\n  text-decoration: none;\n}\n\n.style_DayPicker-Body__2jfXi {\n  display: table-row-group;\n}\n\n.style_DayPicker-Week__7sfNy {\n  display: table-row;\n}\n\n.style_DayPicker-Day__1yI5M {\n  display: table-cell;\n  padding: 0.5em;\n  border-radius: 50%;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n}\n\n.style_DayPicker-WeekNumber__1GPST {\n  display: table-cell;\n  padding: 0.5em;\n  min-width: 1em;\n  border-right: 1px solid #EAECEC;\n  color: #8B9898;\n  vertical-align: middle;\n  text-align: right;\n  font-size: 0.75em;\n  cursor: pointer;\n}\n\n.style_DayPicker--interactionDisabled__1H3Hf .style_DayPicker-Day__1yI5M {\n  cursor: default;\n}\n\n.style_DayPicker-Footer__1g4vZ {\n  padding-top: 0.5em;\n}\n\n.style_DayPicker-TodayButton__3lZw4 {\n  border: none;\n  background-color: transparent;\n  background-image: none;\n  box-shadow: none;\n  color: #4A90E2;\n  font-size: 0.875em;\n  cursor: pointer;\n}\n\n/* Default modifiers */\n\n.style_DayPicker-Day--today__HghuE {\n  color: #D0021B;\n  font-weight: 700;\n}\n\n.style_DayPicker-Day--outside__1UEkI {\n  color: #8B9898;\n  cursor: default;\n}\n\n.style_DayPicker-Day--disabled__2z4yQ {\n  color: #DCE0E0;\n  cursor: default;\n  /* background-color: #eff1f1; */\n}\n\n/* Example modifiers */\n\n.style_DayPicker-Day--sunday__2HBYf {\n  background-color: #F7F8F8;\n}\n\n.style_DayPicker-Day--sunday__2HBYf:not(.style_DayPicker-Day--today__HghuE) {\n  color: #DCE0E0;\n}\n\n.style_DayPicker-Day--selected__VUWNj:not(.style_DayPicker-Day--disabled__2z4yQ):not(.style_DayPicker-Day--outside__1UEkI) {\n  position: relative;\n\n  background-color: #4A90E2;\n  color: #F0F8FF;\n}\n\n.style_DayPicker-Day--selected__VUWNj:not(.style_DayPicker-Day--disabled__2z4yQ):not(.style_DayPicker-Day--outside__1UEkI):hover {\n  background-color: #51A0FA;\n}\n\n.style_DayPicker__b_Yn_:not(.style_DayPicker--interactionDisabled__1H3Hf)\n  .style_DayPicker-Day__1yI5M:not(.style_DayPicker-Day--disabled__2z4yQ):not(.style_DayPicker-Day--selected__VUWNj):not(.style_DayPicker-Day--outside__1UEkI):hover {\n  background-color: #F0F8FF;\n}\n\n/* DayPickerInput */\n\n.style_DayPickerInput__SgZgd {\n  display: inline-block;\n}\n\n.style_DayPickerInput-OverlayWrapper__1do3F {\n  position: relative;\n}\n\n.style_DayPickerInput-Overlay__3X2ZF {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n\n  background: white;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);\n}\n";
styleInject(css);

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var LocaleUtils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};

});

var keys = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var TAB = exports.TAB = 9;

});

var Caption_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _LocaleUtils2 = _interopRequireDefault(LocaleUtils);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption(props) {
    _classCallCheck(this, Caption);

    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === keys.ENTER) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement(
        'div',
        { className: classNames.caption, role: 'heading', 'aria-live': 'polite' },
        _react2.default.createElement(
          'div',
          { onClick: onClick, onKeyUp: this.handleKeyUp },
          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
        )
      );
    }
  }]);

  return Caption;
}(React.Component);

Caption.defaultProps = {
  localeUtils: _LocaleUtils2.default
};
exports.default = Caption;

});

var classNames = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};

});

var Navbar_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _classNames2 = _interopRequireDefault(classNames);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== keys.ENTER && e.keyCode !== keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== keys.ENTER && e.keyCode !== keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;


      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement(
        'div',
        { className: className || classNames.navBar },
        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
      );
    }
  }]);

  return Navbar;
}(React.Component);

Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;

});

var Weekdays_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement(
        'div',
        { className: classNames.weekdays, role: 'rowgroup' },
        _react2.default.createElement(
          'div',
          { className: classNames.weekdaysRow, role: 'row' },
          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
          days
        )
      );
    }
  }]);

  return Weekdays;
}(React.Component);

exports.default = Weekdays;

});

var DateUtils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.isDate = isDate;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */
function isDate(value) {
  return value instanceof Date && !isNaN(value.valueOf());
}

/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {Date} d
 * @param {number} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameMonth(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDate: isDate,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth
};

});

var Helpers = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;







var _classNames2 = _interopRequireDefault(classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

});

var Day_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);







var _classNames2 = _interopRequireDefault(classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;


      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = _extends({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement(
        'div',
        {
          className: className,
          tabIndex: tabIndex,
          style: style,
          role: 'gridcell',
          'aria-label': ariaLabel,
          'aria-disabled': ariaDisabled,
          'aria-selected': ariaSelected,
          onClick: handleEvent(onClick, day, modifiers),
          onKeyDown: handleEvent(onKeyDown, day, modifiers),
          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
          onMouseUp: handleEvent(onMouseUp, day, modifiers),
          onMouseDown: handleEvent(onMouseDown, day, modifiers),
          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
          onTouchStart: handleEvent(onTouchStart, day, modifiers),
          onFocus: handleEvent(onFocus, day, modifiers)
        },
        children
      );
    }
  }]);

  return Day;
}(React.Component);

Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;

});

var ModifiersUtils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;





/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, DateUtils.isSameDay)(day, mod);
    }
    if ((0, Helpers.isRangeOfDates)(mod)) {
      return (0, DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, DateUtils.isDayAfter)(day, mod.after) && (0, DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, DateUtils.isDayAfter)(mod.after, mod.before) || (0, DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, DateUtils.isDayAfter)(day, mod.after) || (0, DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };

});

var Month_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _Weekdays2 = _interopRequireDefault(Weekdays_1);



var _Day2 = _interopRequireDefault(Day_1);





var ModifiersUtils$1 = _interopRequireWildcard(ModifiersUtils);



var Helpers$1 = _interopRequireWildcard(Helpers);



var DateUtils$1 = _interopRequireWildcard(DateUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers$1.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils$1.getModifiersForDay(day, propModifiers);
      if (DateUtils$1.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(
        _Day2.default,
        {
          key: '' + (isOutside ? 'outside-' : '') + key,
          classNames: _this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: _this.props.modifiersStyles,
          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf(_this.props.classNames.disabled) > -1,
          ariaSelected: dayModifiers.indexOf(_this.props.classNames.selected) > -1,
          onClick: _this.props.onDayClick,
          onFocus: _this.props.onDayFocus,
          onKeyDown: _this.props.onDayKeyDown,
          onMouseEnter: _this.props.onDayMouseEnter,
          onMouseLeave: _this.props.onDayMouseLeave,
          onMouseDown: _this.props.onDayMouseDown,
          onMouseUp: _this.props.onDayMouseUp,
          onTouchEnd: _this.props.onDayTouchEnd,
          onTouchStart: _this.props.onDayTouchStart
        },
        _this.props.renderDay(day, modifiers)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          showWeekNumbers = _props.showWeekNumbers,
          showWeekDays = _props.showWeekDays,
          onWeekClick = _props.onWeekClick;


      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers$1.getWeekArray(month, firstDayOfWeek, fixedWeeks);
      return _react2.default.createElement(
        'div',
        { className: classNames.month, role: 'grid' },
        caption,
        showWeekDays && _react2.default.createElement(_Weekdays2.default, {
          classNames: classNames,
          weekdaysShort: weekdaysShort,
          weekdaysLong: weekdaysLong,
          firstDayOfWeek: firstDayOfWeek,
          showWeekNumbers: showWeekNumbers,
          locale: locale,
          localeUtils: localeUtils,
          weekdayElement: weekdayElement
        }),
        _react2.default.createElement(
          'div',
          { className: classNames.body, role: 'rowgroup' },
          weeks.map(function (week) {
            var weekNumber = void 0;
            if (showWeekNumbers) {
              weekNumber = DateUtils$1.getWeekNumber(week[6]);
            }
            return _react2.default.createElement(
              'div',
              {
                key: week[0].getTime(),
                className: classNames.week,
                role: 'row'
              },
              showWeekNumbers && _react2.default.createElement(
                'div',
                {
                  className: classNames.weekNumber,
                  tabIndex: onWeekClick ? 0 : -1,
                  role: 'gridcell',
                  onClick: onWeekClick ? function (e) {
                    return onWeekClick(weekNumber, week, e);
                  } : undefined,
                  onKeyUp: onWeekClick ? function (e) {
                    return e.keyCode === keys.ENTER && onWeekClick(weekNumber, week, e);
                  } : undefined
                },
                _this2.props.renderWeek(weekNumber, week, month)
              ),
              week.map(_this2.renderDay)
            );
          })
        )
      );
    }
  }]);

  return Month;
}(React.Component);

exports.default = Month;

});

var Weekday_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement(
        'div',
        { className: className, role: 'columnheader' },
        _react2.default.createElement(
          'abbr',
          { title: title },
          content
        )
      );
    }
  }]);

  return Weekday;
}(React.Component);

exports.default = Weekday;

});

var DayPicker_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _Caption2 = _interopRequireDefault(Caption_1);



var _Navbar2 = _interopRequireDefault(Navbar_1);



var _Month2 = _interopRequireDefault(Month_1);



var _Weekday2 = _interopRequireDefault(Weekday_1);



var Helpers$1 = _interopRequireWildcard(Helpers);



var DateUtils$1 = _interopRequireWildcard(DateUtils);



var LocaleUtils$1 = _interopRequireWildcard(LocaleUtils);



var ModifiersUtils$1 = _interopRequireWildcard(ModifiersUtils);



var _classNames2 = _interopRequireDefault(classNames);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayPicker = exports.DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.dayPicker = null;

    _this.showNextMonth = function (callback) {
      if (!_this.allowNextMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var nextMonth = DateUtils$1.addMonths(_this.state.currentMonth, deltaMonths);
      _this.showMonth(nextMonth, callback);
    };

    _this.showPreviousMonth = function (callback) {
      if (!_this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var previousMonth = DateUtils$1.addMonths(_this.state.currentMonth, -deltaMonths);
      _this.showMonth(previousMonth, callback);
    };

    _this.handleKeyDown = function (e) {
      e.persist();

      switch (e.keyCode) {
        case keys.LEFT:
          if (_this.props.dir === 'rtl') {
            _this.showNextMonth();
          } else {
            _this.showPreviousMonth();
          }
          Helpers$1.cancelEvent(e);
          break;
        case keys.RIGHT:
          if (_this.props.dir === 'rtl') {
            _this.showPreviousMonth();
          } else {
            _this.showNextMonth();
          }
          Helpers$1.cancelEvent(e);
          break;
        case keys.UP:
          _this.showPreviousYear();
          Helpers$1.cancelEvent(e);
          break;
        case keys.DOWN:
          _this.showNextYear();
          Helpers$1.cancelEvent(e);
          break;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleDayKeyDown = function (day, modifiers, e) {
      e.persist();

      switch (e.keyCode) {
        case keys.LEFT:
          Helpers$1.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusNextDay(e.target);
          } else {
            _this.focusPreviousDay(e.target);
          }
          break;
        case keys.RIGHT:
          Helpers$1.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusPreviousDay(e.target);
          } else {
            _this.focusNextDay(e.target);
          }
          break;
        case keys.UP:
          Helpers$1.cancelEvent(e);
          _this.focusPreviousWeek(e.target);
          break;
        case keys.DOWN:
          Helpers$1.cancelEvent(e);
          _this.focusNextWeek(e.target);
          break;
        case keys.ENTER:
        case keys.SPACE:
          Helpers$1.cancelEvent(e);
          if (_this.props.onDayClick) {
            _this.handleDayClick(day, modifiers, e);
          }
          break;
      }
      if (_this.props.onDayKeyDown) {
        _this.props.onDayKeyDown(day, modifiers, e);
      }
    };

    _this.handleDayClick = function (day, modifiers, e) {
      e.persist();

      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
        _this.handleOutsideDayClick(day);
      }
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, modifiers, e);
      }
    };

    _this.handleTodayButtonClick = function (e) {
      var today = new Date();
      var month = new Date(today.getFullYear(), today.getMonth());
      _this.showMonth(month);
      e.target.blur();
      if (_this.props.onTodayButtonClick) {
        e.persist();
        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils$1.getModifiersForDay(today, _this.props.modifiers), e);
      }
    };

    var currentMonth = _this.getCurrentMonthFromProps(props);
    _this.state = { currentMonth: currentMonth };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Changing the `month` props means changing the current displayed month
      if (prevProps.month !== this.props.month && !DateUtils$1.isSameMonth(prevProps.month, this.props.month)) {
        var currentMonth = this.getCurrentMonthFromProps(this.props);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ currentMonth: currentMonth });
      }
    }
  }, {
    key: 'getCurrentMonthFromProps',


    /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */
    value: function getCurrentMonthFromProps(props) {
      var initialMonth = Helpers$1.startOfMonth(props.month || props.initialMonth || new Date());
      var currentMonth = initialMonth;

      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
        var fromMonth = Helpers$1.startOfMonth(props.fromMonth);
        var diffInMonths = Helpers$1.getMonthsDiff(fromMonth, currentMonth);
        currentMonth = DateUtils$1.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers$1.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
        currentMonth = DateUtils$1.addMonths(Helpers$1.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
      }
      return currentMonth;
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils$1.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils$1.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils$1.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils$1.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers$1.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers$1.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers$1.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils$1.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils$1.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.wrapper.focus();
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers$1.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers$1.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers$1.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers$1.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        month: this.state.currentMonth,
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers$1.getFirstDayOfWeekFromProps(this.props);
      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils$1.addMonths(this.state.currentMonth, i);
        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.props.todayButton) {
        return _react2.default.createElement(
          'div',
          { className: this.props.classNames.footer },
          this.renderTodayButton()
        );
      }
      return null;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          tabIndex: 0,
          className: this.props.classNames.todayButton,
          'aria-label': this.props.todayButton,
          onClick: this.handleTodayButtonClick
        },
        this.props.todayButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement(
        'div',
        _extends({}, this.props.containerProps, {
          className: className,
          ref: function ref(el) {
            return _this7.dayPicker = el;
          },
          lang: this.props.locale
        }),
        _react2.default.createElement(
          'div',
          {
            className: this.props.classNames.wrapper,
            ref: function ref(el) {
              return _this7.wrapper = el;
            },
            tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
            onKeyDown: this.handleKeyDown,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur
          },
          this.renderNavbar(),
          _react2.default.createElement(
            'div',
            { className: this.props.classNames.months },
            this.renderMonths()
          ),
          this.renderFooter()
        )
      );
    }
  }]);

  return DayPicker;
}(React.Component);

DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils$1,
  showOutsideDays: false,
  enableOutsideDaysClick: true,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  showWeekDays: true,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  renderWeek: function renderWeek(weekNumber) {
    return weekNumber;
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};
DayPicker.VERSION = '7.4.10';


DayPicker.DateUtils = DateUtils$1;
DayPicker.LocaleUtils = LocaleUtils$1;
DayPicker.ModifiersUtils = ModifiersUtils$1;

exports.DateUtils = DateUtils$1;
exports.LocaleUtils = LocaleUtils$1;
exports.ModifiersUtils = ModifiersUtils$1;
exports.default = DayPicker;

});

var build = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(DayPicker_1).default;
  }
});



Object.defineProperty(exports, 'DateUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(DateUtils).default;
  }
});



Object.defineProperty(exports, 'LocaleUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(LocaleUtils).default;
  }
});



Object.defineProperty(exports, 'ModifiersUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(ModifiersUtils).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

});

var DayPicker = /*@__PURE__*/unwrapExports(build);

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

var styles$F = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    CalenderWrapper: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'Calender_Wrapper',
      zIndex: 10,
      '& .kbDateRangePicker': {
        '& .DayPicker': {
          '& .DayPicker-wrapper': {
            paddingBottom: 0,
            '& .DayPicker-NavBar': {
              position: 'relative'
            },
            '& .DayPicker-Months': {
              '& .DayPicker-Month': {
                '& .DayPicker-Caption': {
                  '& div': {
                    fontSize: '16px'
                  }
                },
                '& .DayPicker-Weekdays': {
                  '& .DayPicker-WeekdaysRow': {
                    '& .DayPicker-Weekday': {
                      maxWidth: '38px'
                    }
                  }
                },
                '& .DayPicker-Body': {
                  '& .DayPicker-Week': {
                    fontSize: '0.875em',
                    width: '39px',
                    height: '39px',
                    maxWidth: '39px',
                    maxHeight: '39px',
                    '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
                      backgroundColor: '#FF5453 !important'
                    },
                    '& .DayPicker-Day': {
                      width: '38px',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 84, 83, 0.2)'
                      },
                      '&:first-child:is(.DayPicker-Day--selected):not(.DayPicker-Day--start):not(.DayPicker-Day--end)': {
                        position: 'relative',
                        backgroundColor: 'transparent !important',
                        color: "".concat(variables.colors.trueBlack),
                        '&:before': {
                          backgroundColor: 'rgba(255, 84, 83, 0.2)',
                          borderTopLeftRadius: '46% !important',
                          borderBottomLeftRadius: '46% !important',
                          borderTopRightRadius: '0%',
                          borderBottomRightRadius: '0%',
                          content: '""',
                          height: '30px',
                          left: '-3px',
                          position: 'absolute',
                          top: '6px !important',
                          width: '107% !important',
                          zIndex: -1
                        }
                      },
                      '&:last-child:is(.DayPicker-Day--selected):not(.DayPicker-Day--start):not(.DayPicker-Day--end)': {
                        position: 'relative',
                        backgroundColor: 'transparent !important',
                        color: "".concat(variables.colors.trueBlack),
                        '&:before': {
                          backgroundColor: 'rgba(255, 84, 83, 0.2)',
                          borderTopLeftRadius: '0%',
                          borderBottomLeftRadius: '0%',
                          borderTopRightRadius: '46% !important',
                          borderBottomRightRadius: '46% !important',
                          content: '""',
                          height: '30px',
                          paddingRight: '3px !important',
                          position: 'absolute',
                          top: '6px !important',
                          width: '104% !important',
                          zIndex: -1
                        }
                      },
                      '&:last-child:is(.DayPicker-Day--selected):is(.DayPicker-Day--start)': {
                        position: 'relative',
                        backgroundColor: 'transparent !important',
                        color: "".concat(variables.colors.trueBlack),
                        '&:after': {
                          background: 'transparent',
                          borderRadius: '0px',
                          content: '""',
                          height: '30px',
                          right: 0,
                          position: 'absolute',
                          top: '6px',
                          width: '20px',
                          zIndex: -1
                        }
                      },
                      '& + .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--today)': {
                        backgroundColor: 'transparent !important',
                        color: variables.colors.trueBlack,
                        position: 'relative',
                        '&:before': {
                          backgroundColor: 'rgba(255, 84, 83, 0.2)',
                          borderRadius: '0px',
                          content: '""',
                          height: '30px',
                          left: 0,
                          position: 'absolute',
                          top: '6px',
                          width: '100%',
                          zIndex: -1
                        }
                      },
                      '& + .DayPicker-Day--selected': {
                        borderRadius: '26px'
                      },
                      '& + .DayPicker-Day--today': {
                        backgroundColor: 'transparent !important',
                        color: '#FF5453'
                      },
                      '& + .DayPicker-Day--start': {
                        position: 'relative',
                        backgroundColor: 'transparent !important',
                        color: "".concat(variables.colors.trueWhite, " !important"),
                        overflow: 'visible',
                        zIndex: 1,
                        '&:before': {
                          backgroundColor: '#FF5453',
                          borderRadius: '26px',
                          content: '""',
                          height: '35px',
                          left: '1px',
                          position: 'absolute',
                          top: '2px',
                          width: '35px',
                          zIndex: -1
                        },
                        '&:after': {
                          background: 'rgba(255, 84, 83, 0.2)',
                          borderRadius: '0px',
                          content: '""',
                          height: '30px',
                          right: 0,
                          position: 'absolute',
                          top: '6px',
                          width: '20px',
                          zIndex: -1
                        }
                      },
                      '& + .DayPicker-Day--end': {
                        position: 'relative',
                        backgroundColor: 'transparent !important',
                        color: "".concat(variables.colors.trueWhite),
                        overflow: 'visible',
                        zIndex: 1,
                        '&:before': {
                          backgroundColor: '#FF5453',
                          borderRadius: '26px',
                          content: '""',
                          height: '35px',
                          left: '1px',
                          position: 'absolute',
                          top: '2px',
                          width: '35px',
                          zIndex: -1
                        },
                        '&:after': {
                          background: 'rgba(255, 84, 83, 0.2)',
                          borderRadius: '0px',
                          content: '""',
                          height: '30px',
                          left: 0,
                          position: 'absolute',
                          top: '6px',
                          width: '20px',
                          zIndex: -1
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      },
      '& .kbDatePicker': {
        '& .DayPicker': {
          '& .DayPicker-wrapper': {
            paddingBottom: 0,
            '& .DayPicker-NavBar': {
              position: 'relative'
            },
            '& .DayPicker-Months': {
              '& .DayPicker-Month': {
                '& .DayPicker-Caption': {
                  '& div': {
                    fontSize: '16px'
                  }
                },
                '& .DayPicker-Weekdays': {
                  '& .DayPicker-WeekdaysRow': {
                    '& .DayPicker-Weekday': {
                      maxWidth: '38px'
                    }
                  }
                },
                '& .DayPicker-Body': {
                  '& .DayPicker-Week': {
                    fontSize: '0.875em',
                    width: '39px',
                    height: '39px',
                    maxWidth: '39px',
                    maxHeight: '39px',
                    '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
                      backgroundColor: '#FF5453 !important',
                      color: "".concat(variables.colors.trueWhite, " !important")
                    },
                    '& .DayPicker-Day': {
                      width: '38px',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 84, 83, 0.2)'
                      },
                      '& + .DayPicker-Day--today': {
                        backgroundColor: 'transparent !important',
                        color: '#FF5453'
                      },
                      '&:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover': {
                        backgroundColor: 'rgba(255, 84, 83, 0.2)'
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    })
  };
};

var today = new Date();

var Calendar = function Calendar(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      from = _ref.from,
      to = _ref.to,
      dateRangePicker = _ref.dateRangePicker,
      modifiers = _ref.modifiers,
      selectedDate = _ref.selectedDate,
      maxAvailableMonths = _ref.maxAvailableMonths,
      onHandleDayClick = _ref.onHandleDayClick,
      testId = _ref.testId;

  var _useState = useState(to),
      _useState2 = _slicedToArray(_useState, 2),
      hoveredToDate = _useState2[0],
      setHoveredToDate = _useState2[1];

  var handleDayMouseEnter = function handleDayMouseEnter(day) {
    var modifierObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (modifierObj === null || modifierObj === void 0 ? void 0 : modifierObj.disabled) {
      return;
    }

    if (dateRangePicker && (from && !to || !from && to)) {
      setHoveredToDate(day);
    }
  };

  var disabledAfter = addMonths(from, maxAvailableMonths);
  var datePickerRange = {
    from: from,
    to: hoveredToDate
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.CalenderWrapper,
    "data-test": createTestId(testId, 'comp')
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(DayPicker, {
    selectedDays: dateRangePicker ? datePickerRange : selectedDate,
    showOutsideDays: true,
    disabledDays: dateRangePicker ? {
      before: today,
      after: disabledAfter
    } : {
      before: today
    },
    onDayClick: onHandleDayClick,
    onDayMouseEnter: handleDayMouseEnter,
    modifiers: modifiers,
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    navbarElement: /*#__PURE__*/React.createElement(Navbar, null)
  })));
};

Calendar.displayName = "Calendar";
Calendar.propTypes = {
  classes: PropTypes.shape({
    CalenderWrapper: PropTypes.string
  }),
  className: PropTypes.string,
  dateRangePicker: PropTypes.bool,
  from: PropTypes.objectOf(Date),
  maxAvailableMonths: PropTypes.number,
  modifiers: PropTypes.object,
  onHandleDayClick: PropTypes.func,
  selectedDate: PropTypes.objectOf(Date),
  testId: PropTypes.string,
  to: PropTypes.objectOf(Date)
};
Calendar.defaultProps = {
  classes: {},
  className: '',
  dateRangePicker: false,
  from: undefined,
  maxAvailableMonths: 11,
  modifiers: {},
  onHandleDayClick: noop$1,
  selectedDate: undefined,
  testId: null,
  to: undefined
};

var Navbar = function Navbar(_ref2) {
  var onPreviousClick = _ref2.onPreviousClick,
      onNextClick = _ref2.onNextClick,
      className = _ref2.className;
  var styleLeft = {
    fontSize: '12px',
    boxShadow: 'none',
    border: 0,
    top: '18px',
    right: '30px',
    position: 'absolute',
    backgroundColor: 'transparent'
  };
  var styleRight = {
    fontSize: '12px',
    boxShadow: 'none',
    border: 0,
    top: '18px',
    right: '10px',
    position: 'absolute',
    backgroundColor: 'transparent'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: styleLeft,
    onClick: function onClick() {
      return onPreviousClick();
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronLeft
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: styleRight,
    onClick: function onClick() {
      return onNextClick();
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight
  })));
};

Navbar.displayName = "Navbar";
Navbar.propTypes = {
  className: PropTypes.string,
  onNextClick: PropTypes.func,
  onPreviousClick: PropTypes.func
};
Navbar.defaultProps = {
  className: '',
  onNextClick: noop$1,
  onPreviousClick: noop$1
};
var Calendar$1 = withStyles(styles$F)(Calendar);

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return !isNaN(date);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters$1 = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

var styles$G = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    DatePickerWrapper: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'DatePicker_Wrapper',
      position: 'relative'
    }),
    KBDatePicker: {
      composes: 'kbDatePicker'
    },
    DatePickerInputWrapper: {
      composes: 'DatePicker_inputwrapper',
      display: 'flex',
      flexDirection: 'row',
      marginTop: '0.75rem',
      boxShadow: '0 0 25px rgb(0 0 0 / 8%)',
      width: '100%',
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
      position: 'relative',
      alignItems: 'center'
    },
    DateFieldIcon: {
      composes: 'datePicker_icon',
      position: 'absolute',
      marginLeft: '0.75rem',
      '& .disabled': {
        '& svg': {
          color: variables.colors.greyTwo
        }
      }
    },
    DatePickerInput: {
      composes: 'datePicker_input',
      color: '#333333',
      width: '100%',
      height: '42px',
      fontSize: '15px',
      border: '1px solid #e1e7ee',
      boxSizing: 'border-box',
      padding: '0 0.6rem 0 2.5rem',
      '&:hover, &:focus, &:active': {
        border: "1px solid ".concat(variables.colors.greyFour),
        outline: 'none'
      }
    },
    DatePickerToggleBtn: {
      composes: 'datePicker_toggleBtn',
      background: 'transparent',
      border: 0,
      color: '#575757',
      cursor: 'pointer',
      height: '40px',
      outline: 'none',
      padding: '5px 10px',
      position: 'absolute',
      right: 0,
      '&:disabled, &[disabled]': {
        '& svg': {
          color: variables.colors.greyTwo
        }
      }
    },
    DatePickerVisible: {
      composes: 'datePicker_visible',
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: '45px',
      left: 0,
      boxShadow: '0px 0px 25px rgba(0, 0, 0, 0.08)',
      backgroundColor: variables.colors.trueWhite,
      borderRadius: '8px',
      zIndex: 10
    },
    DatePickerHidden: {
      composes: 'DatePicker_hidden',
      display: 'none'
    },
    TimeSlotRow: {
      composes: 'datePicker_timeSlotRow',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: '0.5rem',
      paddingRight: '1.2rem',
      '& label': {
        color: variables.colors.trueBlack,
        fontWeight: 700,
        fontSize: '16px',
        paddingRight: '1.3rem'
      },
      '& input': {
        color: '#333333',
        width: '74px',
        height: '42px',
        border: '1.5px solid #E8ECF1',
        boxSizing: 'border-box',
        borderRadius: '4px',
        textAlign: 'center',
        fontSize: '15px'
      }
    },
    TimeSlotSpacer: {
      padding: '0 0.5rem'
    },
    Spacer: {
      borderTop: '1px solid #E8ECF1',
      width: '100%'
    },
    labelActive: {
      composes: 'datePicker_labelActive',
      color: '#000000',
      backgroundColor: 'white',
      fontSize: '0.75rem',
      marginLeft: '0.75rem',
      pointerEvents: 'none',
      position: 'absolute',
      transform: 'translate(0, -0.65rem)',
      transition: 'all 0.3s ease-out',
      zIndex: 1
    },
    label: {
      composes: 'datePicker_label',
      position: 'absolute',
      transition: 'all 0.3s ease-out',
      transform: 'translate(1.5rem, 0.7rem)',
      marginLeft: '0.75rem',
      color: 'rgba(200, 200, 200, 1)',
      pointerEvents: 'none',
      fontSize: '14px',
      width: '100%',
      zIndex: 1
    },
    required: {
      composes: 'datePicker__required',
      color: '#000000'
    },
    disabled: {
      color: variables.colors.greyTwo
    },
    valid: {
      composes: 'datePicker--valid',
      extend: 'datePicker_inputWrapper',
      '&:before': {
        content: "''",
        backgroundColor: variables.colors.typeSuccess,
        bottom: 0,
        height: '2px',
        left: '0.8em',
        position: 'absolute',
        zIndex: 1,
        animation: '$fadeInAnim 0.25s ease-out forwards'
      }
    },
    '@keyframes fadeInAnim': {
      from: {
        opacity: 0,
        width: 0
      },
      to: {
        opacity: 1,
        width: '99%'
      }
    },
    invalid: {
      composes: 'datePicker--invalid',
      extend: 'datePicker_inputWrapper',
      '&:before': {
        content: "''",
        backgroundColor: variables.colors.typeDanger,
        bottom: 0,
        height: '2px',
        left: '0.8em',
        position: 'absolute',
        width: '99%',
        zIndex: 1,
        animation: '$fadeInAnim 0.25s ease-out forwards'
      }
    },
    error: {
      composes: 'datePicker__error',
      display: 'block',
      fontSize: '0.8em',
      padding: '0 1em',
      border: 'none',
      color: variables.colors.typeDanger,
      backgroundColor: variables.colors.blue,
      position: 'absolute',
      bottom: '-1.7em',
      width: '100%',
      marginTop: '0.25em'
    }
  };
};

var minTwoDigits = function minTwoDigits(num) {
  return (num < 10 ? '0' : '') + num;
};

var DatePicker = function DatePicker(_ref) {
  var _dateValue$getUTCHour, _dateValue$getUTCMinu;

  var classes = _ref.classes,
      dateValue = _ref.dateValue,
      disabled = _ref.disabled,
      errors = _ref.errors,
      id = _ref.id,
      label = _ref.label,
      required = _ref.required,
      showTime = _ref.showTime,
      onDateChanged = _ref.onDateChanged,
      testId = _ref.testId,
      valid = _ref.valid;
  var compRef = /*#__PURE__*/createRef();
  var initialHour = (_dateValue$getUTCHour = dateValue === null || dateValue === void 0 ? void 0 : dateValue.getUTCHours()) !== null && _dateValue$getUTCHour !== void 0 ? _dateValue$getUTCHour : 0;
  var initialMinutes = (_dateValue$getUTCMinu = dateValue === null || dateValue === void 0 ? void 0 : dateValue.getUTCMinutes()) !== null && _dateValue$getUTCMinu !== void 0 ? _dateValue$getUTCMinu : 0;

  var _useState = useState({
    selectedDate: dateValue,
    timeHour: minTwoDigits(initialHour),
    timeMinutes: minTwoDigits(initialMinutes)
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      toggleDatePicker = _useState4[0],
      setToggleDatePicker = _useState4[1];

  useOnClickOutside(compRef, function () {
    return setToggleDatePicker(!toggleDatePicker);
  });

  var onToggleCalendar = function onToggleCalendar() {
    setToggleDatePicker(!toggleDatePicker);
  };

  var getInputState = function getInputState() {
    if (disabled) {
      return classes === null || classes === void 0 ? void 0 : classes.disabled;
    } else if (errors.length) {
      return classes === null || classes === void 0 ? void 0 : classes.invalid;
    } else if (valid && !errors.length) {
      return classes === null || classes === void 0 ? void 0 : classes.valid;
    }

    return classes === null || classes === void 0 ? void 0 : classes.inputField;
  };

  var onTimePropChange = function onTimePropChange(event, prop) {
    var _objectSpread2$1;

    var value = minTwoDigits(event.target.value);
    var currentDate = new Date(state.selectedDate);
    var currValue = parseInt(value, 10);

    if (prop === 'timeHour') {
      if (currValue > 23) {
        value = '23';
        currentDate.setHours(value);
      } else {
        currentDate.setHours(value);
      }
    }

    if (prop === 'timeMinutes') {
      if (currValue > 59) {
        value = '59';
        currentDate.setMinutes(value);
      } else {
        currentDate.setMinutes(value);
      }
    }

    if (currValue <= 0) {
      value = '00';

      if (prop === 'timeHour') {
        currentDate.setHours(value);
      }

      if (prop === 'timeMinutes') {
        currentDate.setMinutes(value);
      }
    }

    setState(_objectSpread2(_objectSpread2({}, state), {}, (_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, prop, value.slice(-2)), _defineProperty(_objectSpread2$1, "selectedDate", currentDate), _objectSpread2$1)));
    onDateChanged(currentDate);
  };

  var handleDayClick = function handleDayClick(day) {
    var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (modifiers.disabled) {
      return;
    }

    var newDay = new Date(day);

    if (showTime) {
      newDay.setHours(state.timeHour);
      newDay.setMinutes(state.timeMinutes);
    }

    setState(_objectSpread2(_objectSpread2({}, state), {}, {
      selectedDate: newDay
    }));
    onDateChanged(newDay);
  };

  var formatInputValue = function formatInputValue(inputVal) {
    if (inputVal instanceof Date) {
      return inputVal && showTime ? format(state.selectedDate, 'HH:mm - dd.MM.yyyy') : format(state.selectedDate, 'dd.MM.yyyy');
    }

    return '';
  };

  var selectedDate = state.selectedDate,
      timeHour = state.timeHour,
      timeMinutes = state.timeMinutes;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(getInputState(), " ").concat(classes.DatePickerWrapper),
    "data-test": createTestId(testId, 'comp')
  }, /*#__PURE__*/React.createElement("label", {
    "data-test": createTestId(testId, 'label'),
    className: selectedDate === null ? classes.label : classes.labelActive,
    htmlFor: "".concat(id, "-input")
  }, label, required && /*#__PURE__*/React.createElement("span", {
    "data-test": createTestId(testId, 'required'),
    className: classes === null || classes === void 0 ? void 0 : classes.required
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: classes.DatePickerInputWrapper
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCalendarDay,
    className: classNames$1(classes.DateFieldIcon, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.disabled, disabled))
  }), /*#__PURE__*/React.createElement("input", {
    id: "".concat(id, "-input"),
    "data-test": createTestId(testId, 'input'),
    className: classNames$1(classes.DatePickerInput, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.disabled, disabled)),
    disabled: disabled,
    value: formatInputValue(selectedDate),
    readOnly: true
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    disabled: disabled,
    className: classes.DatePickerToggleBtn,
    "data-test": createTestId(testId, 'btn'),
    onClick: onToggleCalendar
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronDown
  })), errors.map(function (error, idx) {
    return /*#__PURE__*/React.createElement("span", {
      key: error,
      className: classes === null || classes === void 0 ? void 0 : classes.error,
      "data-test": createTestId(testId, "errorMsg-".concat(idx))
    }, error);
  })), toggleDatePicker && /*#__PURE__*/React.createElement("div", {
    ref: compRef,
    className: toggleDatePicker ? classes.DatePickerVisible : classes.DatePickerHidden,
    "data-test": createTestId(testId, 'calendar')
  }, /*#__PURE__*/React.createElement(Calendar$1, {
    className: classes.KBDatePicker,
    selectedDate: selectedDate,
    onHandleDayClick: handleDayClick
  }), showTime && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
    className: classes.Spacer
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.TimeSlotRow,
    "data-test": createTestId(testId, 'timeSlot')
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "timeSlot"
  }, "Time"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: timeHour,
    onChange: function onChange(evt) {
      return onTimePropChange(evt, 'timeHour');
    },
    "data-test": createTestId(testId, 'hourInput')
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.TimeSlotSpacer
  }, ":"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: timeMinutes,
    onChange: function onChange(evt) {
      return onTimePropChange(evt, 'timeMinutes');
    },
    "data-test": createTestId(testId, 'minuteInput')
  })))));
};

DatePicker.displayName = "DatePicker";
DatePicker.propTypes = {
  classes: PropTypes.object,
  dateValue: PropTypes.objectOf(Date),
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  id: PropTypes.string,
  label: PropTypes.string,
  onDateChanged: PropTypes.func,
  required: PropTypes.bool,
  showTime: PropTypes.bool,
  testId: PropTypes.string,
  valid: PropTypes.bool
};
DatePicker.defaultProps = {
  classes: {},
  dateValue: null,
  disabled: false,
  errors: [],
  id: '',
  label: '',
  onDateChanged: noop$1,
  required: false,
  showTime: false,
  testId: null,
  valid: null
};
var DatePicker$1 = withStyles(styles$G)(DatePicker);

var styles$H = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    DateRangeWrapper: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'DateRangePicker_wrapper'
    }),
    KBDateRangePicker: {
      composes: 'kbDateRangePicker'
    },
    DateRangeInputWrapper: {
      composes: 'dateRangePicker_inputWrapper',
      display: 'flex',
      flexDirection: 'column',
      marginTop: '0.75rem',
      boxShadow: '0 0 25px rgb(0 0 0 / 8%)',
      width: '100%',
      borderRadius: '4px',
      position: 'relative',
      '&:before': {
        content: "''",
        width: 0,
        backgroundColor: variables.colors.greyFour,
        height: '2px',
        zIndex: 1
      }
    },
    DateRangeInput: {
      composes: 'dateRangePicker_input',
      color: '#333333',
      position: 'relative',
      width: '100%',
      height: '42px',
      border: 'none',
      borderRight: '1.5px solid #E8ECF1',
      boxSizing: 'border-box',
      fontSize: '15px',
      padding: '0 0.8rem',
      '&:hover, &:focus, &:active': {
        border: "1px solid ".concat(variables.colors.greyFour),
        outline: 'none'
      }
    },
    DateRangeToggleBtn: {
      composes: 'dateRangeCalendar_toggleBtn',
      color: '#575757',
      border: 'none',
      cursor: 'pointer',
      outline: 'none',
      height: '42px',
      padding: '5px 10px',
      background: 'transparent',
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px',
      position: 'absolute',
      right: '2px',
      '&:disabled, &[disabled]': {
        '& svg': {
          color: variables.colors.greyTwo
        }
      }
    },
    DateRangeVisible: {
      composes: 'dateRangeCalendar_visible',
      display: 'flex',
      flexDirection: 'column',
      marginTop: '0.75rem',
      position: 'absolute',
      top: '45px',
      left: 0,
      boxShadow: '0px 0px 25px rgba(0, 0, 0, 0.08)',
      backgroundColor: variables.colors.trueWhite,
      borderRadius: '8px',
      zIndex: 10
    },
    DateRangeHidden: {
      composes: 'dateRangeCalendar_hidden',
      display: 'none'
    },
    disabled: {
      color: variables.colors.greyTwo
    },
    valid: {
      composes: 'dateRangePicker--valid',
      extend: 'dateRangePicker_inputWrapper',
      '&:before': {
        content: "''",
        backgroundColor: variables.colors.typeSuccess,
        bottom: 0,
        height: '2px',
        left: '0.8em',
        position: 'absolute',
        zIndex: 1,
        animation: '$fadeInAnim 0.25s ease-out forwards'
      }
    },
    '@keyframes fadeInAnim': {
      from: {
        opacity: 0,
        width: 0
      },
      to: {
        opacity: 1,
        width: '99%'
      }
    },
    invalid: {
      composes: 'dateRangePicker--invalid',
      extend: 'dateRangePicker_inputWrapper',
      '&:before': {
        content: "''",
        backgroundColor: variables.colors.typeDanger,
        bottom: 0,
        height: '2px',
        left: '0.8em',
        position: 'absolute',
        width: '99%',
        zIndex: 1,
        animation: '$fadeInAnim 0.25s ease-out forwards'
      }
    },
    error: {
      composes: 'dateRangePicker__error',
      display: 'block',
      fontSize: '0.8em',
      padding: '0 1em',
      border: 'none',
      color: variables.colors.typeDanger,
      backgroundColor: variables.colors.blue,
      position: 'absolute',
      bottom: '-1.7em',
      width: '100%',
      marginTop: '0.25em'
    }
  };
};

var now = new Date();

var resolveToFromNow = function resolveToFromNow(years, months, days) {
  return new Date(now.getFullYear() + (years !== null && years !== void 0 ? years : 0), now.getMonth() + (months !== null && months !== void 0 ? months : 0), now.getDate() + (days !== null && days !== void 0 ? days : 0));
};

var DateRangePicker = function DateRangePicker(_ref) {
  var classes = _ref.classes,
      disabled = _ref.disabled,
      dispatcher = _ref.dispatcher,
      errors = _ref.errors,
      onDateChanged = _ref.onDateChanged,
      testId = _ref.testId,
      fromDate = _ref.fromDate,
      toDate = _ref.toDate,
      valid = _ref.valid;

  var _useState = useState({
    startDate: fromDate,
    endDate: toDate
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      toggleCalendar = _useState4[0],
      setToggleCalendar = _useState4[1];

  var handleCalendarClick = function handleCalendarClick() {
    return setToggleCalendar(!toggleCalendar);
  };

  var getInputState = function getInputState() {
    if (disabled) {
      return classes === null || classes === void 0 ? void 0 : classes.disabled;
    } else if (errors.length) {
      return classes === null || classes === void 0 ? void 0 : classes.invalid;
    } else if (valid && !errors.length) {
      return classes === null || classes === void 0 ? void 0 : classes.valid;
    }

    return classes === null || classes === void 0 ? void 0 : classes.inputField;
  };

  var handleDateChange = function handleDateChange(newDateRange) {
    if (newDateRange.from < now) {
      if (dispatcher && newDateRange.from && newDateRange.to) {
        dispatcher('past', {
          startDate: format(newDateRange.from, 'yyyy-MM-dd'),
          endDate: format(newDateRange.to, 'yyyy-MM-dd')
        });
      }

      if (newDateRange.to) {
        setToggleCalendar();
      }
    }

    setState({
      startDate: newDateRange.from,
      endDate: newDateRange.to
    });

    if (newDateRange.from && newDateRange.to) {
      setState({
        startDate: newDateRange.from,
        endDate: newDateRange.to
      });
    }

    onDateChanged({
      startDate: newDateRange.from,
      endDate: newDateRange.to
    });

    if (newDateRange.to) {
      setToggleCalendar();
    }
  };

  var onHandleDayClick = function onHandleDayClick(day) {
    var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (modifiers === null || modifiers === void 0 ? void 0 : modifiers.disabled) {
      return;
    }

    var range = {
      from: state.startDate,
      to: state.endDate
    };

    if (state.startDate && state.endDate) {
      range = {
        from: undefined,
        to: undefined
      };
    }

    var newRange = DayPicker.DateUtils.addDayToRange(day, range);
    handleDateChange(newRange);
  };

  var handleDayMouseEnter = function handleDayMouseEnter(day) {
    var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (modifiers.disabled) {
      return;
    }

    if (state.startDate && !state.endDate || !state.startDate && state.endDate) {
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        endDate: day
      }));
    }
  };

  var formatTimestamp = function formatTimestamp(fromG, toG) {
    var pickUpDateTimeStr = fromG ? format(fromG, 'dd.MM.yyyy') : '';
    var dropOffDateTimeStr = toG ? format(toG, 'dd.MM.yyyy') : '';
    return "".concat(pickUpDateTimeStr, " - ").concat(dropOffDateTimeStr);
  };

  var startDate = state.startDate,
      endDate = state.endDate;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.DateRangeWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(getInputState(), " ").concat(classes.DateRangeInputWrapper),
    "data-test": createTestId(testId, 'comp')
  }, /*#__PURE__*/React.createElement("input", {
    readOnly: true,
    disabled: disabled,
    value: formatTimestamp(startDate, endDate),
    "data-test": createTestId(testId, 'input'),
    className: classNames$1(classes.DateRangeInput, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.disabled, disabled))
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classes.DateRangeToggleBtn,
    disabled: disabled,
    "data-test": createTestId(testId, 'btn'),
    onClick: handleCalendarClick
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCalendarDay
  })), errors.map(function (error, idx) {
    return /*#__PURE__*/React.createElement("span", {
      key: error,
      className: classes === null || classes === void 0 ? void 0 : classes.error,
      "data-test": createTestId(testId, "errorMsg-".concat(idx))
    }, error);
  })), toggleCalendar && /*#__PURE__*/React.createElement("div", {
    className: toggleCalendar ? classes.DateRangeVisible : classes.DateRangeHidden,
    "data-test": createTestId(testId, 'calendar')
  }, /*#__PURE__*/React.createElement(Calendar$1, {
    className: classes.KBDateRangePicker,
    dateRangePicker: true,
    to: endDate,
    from: startDate,
    onHandleDayClick: onHandleDayClick,
    onDayMouseEnter: handleDayMouseEnter,
    modifiers: {
      start: startDate,
      end: endDate
    },
    maxAvailableMonths: 24
  })));
};

DateRangePicker.displayName = "DateRangePicker";
DateRangePicker.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  dispatcher: PropTypes.func,
  errors: PropTypes.array,
  fromDate: PropTypes.objectOf(Date),
  onDateChanged: PropTypes.func,
  testId: PropTypes.string,
  toDate: PropTypes.objectOf(Date),
  valid: PropTypes.bool
};
DateRangePicker.defaultProps = {
  classes: {},
  disabled: false,
  dispatcher: noop$1,
  errors: [],
  fromDate: now,
  onDateChanged: noop$1,
  testId: null,
  toDate: resolveToFromNow(0, 0, 4),
  valid: null
};
var DateRangePicker$1 = withStyles(styles$H)(DateRangePicker);

var styles$I = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    DateEntryWrapper: {},
    DateEntryFieldset: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    DateEntryLegend: {
      composes: 'DateEntryFields__legend',
      border: 'none',
      fontSize: '0.75rem',
      color: variables.colors.trueBlack,
      marginBottom: '2px'
    },
    DateEntryDay: {
      minWidth: '3em',
      flex: '1 1 27.27%',
      marginRight: '7px'
    },
    DateEntryMonth: {
      minWidth: '3em',
      flex: '1 1 27.27%',
      marginLeft: '7px',
      marginRight: '7px'
    },
    DateEntryYear: {
      minWidth: '5em',
      flex: '1 1 45.45%',
      marginLeft: '7px'
    },
    required: {
      composes: 'DateEntryFields__required',
      color: variables.colors.trueBlack
    },
    error: {
      composes: 'DateEntryFields__error',
      display: 'block',
      fontSize: '0.8em',
      padding: '0 0.5em',
      border: 'none',
      color: variables.colors.typeDanger,
      backgroundColor: variables.colors.blue,
      marginTop: '0.25em'
    },
    disabled: {
      composes: 'DateEntryFields DateEntryFields--disabled',
      extend: 'inputField'
    },
    invalid: {
      composes: 'inputField inputField--invalid',
      extend: 'inputField'
    },
    valid: {
      composes: 'inputField inputField--valid',
      extend: 'inputField'
    },
    inputField: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'inputField',
      display: 'block',
      marginTop: '0.75rem',
      width: '100%'
    }),
    lastError: {
      marginTop: 0
    }
  };
};

/* eslint-disable max-lines-per-function */

var DateEntryFields = function DateEntryFields(_ref) {
  var classes = _ref.classes,
      day = _ref.day,
      disabled = _ref.disabled,
      errors = _ref.errors,
      forwardRef = _ref.forwardRef,
      id = _ref.id,
      legend = _ref.legend,
      lineBlank = _ref.lineBlank,
      month = _ref.month,
      onChange = _ref.onChange,
      required = _ref.required,
      removeMargin = _ref.removeMargin,
      testId = _ref.testId,
      valid = _ref.valid,
      year = _ref.year;

  var _useState = useState({
    day: day,
    month: month,
    year: year
  }),
      _useState2 = _slicedToArray(_useState, 2),
      date = _useState2[0],
      setDate = _useState2[1];

  useEffect(function () {
    if (date.day !== day || date.month !== month || date.year !== year) {
      setDate({
        day: day,
        month: month,
        year: year
      });
    }
  }, [day, month, year]); // eslint-disable-next-line no-shadow

  var onDateChange = function onDateChange(_ref2) {
    var day = _ref2.day,
        month = _ref2.month,
        year = _ref2.year;
    setDate({
      day: day,
      month: month,
      year: year
    });
    onChange({
      // eslint-disable-next-line id-length
      d: day,
      // eslint-disable-next-line id-length
      m: month,
      // eslint-disable-next-line id-length
      y: year,
      iso: "".concat((year === null || year === void 0 ? void 0 : year.padStart(4, '0')) || '0000', "-").concat((month === null || month === void 0 ? void 0 : month.padStart(2, '0')) || '00', "-").concat((day === null || day === void 0 ? void 0 : day.padStart(2, '0')) || '00')
    });
  };

  var handleChangeDay = function handleChangeDay(val) {
    return onDateChange(_objectSpread2(_objectSpread2({}, date), {}, {
      day: val
    }));
  };

  var handleChangeMonth = function handleChangeMonth(val) {
    return onDateChange(_objectSpread2(_objectSpread2({}, date), {}, {
      month: val
    }));
  };

  var handleChangeYear = function handleChangeYear(val) {
    return onDateChange(_objectSpread2(_objectSpread2({}, date), {}, {
      year: val
    }));
  };

  var inputErrors = errors.length > 0 ? [''] : [];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.DateEntryWrapper,
    "data-test": createTestId(testId, 'comp')
  }, /*#__PURE__*/React.createElement("fieldset", {
    className: classes.DateEntryFieldset,
    role: "group"
  }, legend && /*#__PURE__*/React.createElement("legend", {
    className: classes.DateEntryLegend,
    "data-test": createTestId(testId, 'legend')
  }, legend, required && /*#__PURE__*/React.createElement("span", {
    "data-test": createTestId(testId, 'required'),
    className: classes === null || classes === void 0 ? void 0 : classes.required
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: classes.DateEntryDay
  }, /*#__PURE__*/React.createElement(InputFieldV2$1, {
    controlled: true,
    disabled: disabled,
    id: "day-".concat(id),
    name: "day-".concat(id),
    inputMode: "numeric",
    label: "Day",
    onChange: handleChangeDay,
    pattern: "[0-9]*",
    maxLength: "2",
    value: day,
    valid: valid,
    errors: inputErrors,
    ref: forwardRef,
    hiddenErrors: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.DateEntryMonth
  }, /*#__PURE__*/React.createElement(InputFieldV2$1, {
    controlled: true,
    disabled: disabled,
    id: "month-".concat(id),
    name: "month-".concat(id),
    inputMode: "numeric",
    label: "Month",
    onChange: handleChangeMonth,
    pattern: "[0-9]*",
    maxLength: "2",
    value: month,
    valid: valid,
    errors: inputErrors,
    hiddenErrors: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.DateEntryYear
  }, /*#__PURE__*/React.createElement(InputFieldV2$1, {
    controlled: true,
    disabled: disabled,
    id: "year-".concat(id),
    name: "year-".concat(id),
    inputMode: "numeric",
    label: "Year",
    onChange: handleChangeYear,
    pattern: "[0-9]*",
    maxLength: "4",
    value: year,
    valid: valid,
    errors: inputErrors,
    hiddenErrors: true
  }))), (errors === null || errors === void 0 ? void 0 : errors.length) ? errors.map(function (error) {
    return /*#__PURE__*/React.createElement("span", {
      key: error,
      className: classes === null || classes === void 0 ? void 0 : classes.error,
      "data-test": createTestId(testId, 'errorMsg'),
      role: "alert"
    }, error);
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, _toConsumableArray(Array(lineBlank).keys()).map(function (val) {
    return /*#__PURE__*/React.createElement("span", {
      key: val,
      className: classNames$1(classes === null || classes === void 0 ? void 0 : classes.error, _defineProperty({}, classes.lastError, removeMargin && val > 0 && val + 1 === lineBlank))
    }, "\xA0");
  })));
};

DateEntryFields.displayName = "DateEntryFields";
DateEntryFields.propTypes = {
  classes: PropTypes.shape({
    DateEntryDay: PropTypes.string,
    DateEntryFieldset: PropTypes.string,
    DateEntryLegend: PropTypes.string,
    DateEntryMonth: PropTypes.string,
    DateEntryWrapper: PropTypes.string,
    DateEntryYear: PropTypes.string,
    error: PropTypes.string,
    lastError: PropTypes.string,
    required: PropTypes.string
  }),
  day: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  forwardRef: PropTypes.any,
  id: PropTypes.string.isRequired,
  legend: PropTypes.node.isRequired,
  lineBlank: PropTypes.number,
  month: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  removeMargin: PropTypes.bool,
  required: PropTypes.bool,
  testId: PropTypes.string,
  valid: PropTypes.bool,
  year: PropTypes.string
};
DateEntryFields.defaultProps = {
  classes: {},
  day: null,
  disabled: false,
  errors: [],
  forwardRef: null,
  lineBlank: 1,
  month: null,
  removeMargin: false,
  required: null,
  testId: null,
  valid: true,
  year: null
};
var DateEntryFields$1 = withStyles(styles$I)(DateEntryFields);

var styles$J = function styles(_ref) {
  var mixins = _ref.mixins,
      variables = _ref.variables;
  return {
    fieldWrapper: _objectSpread2(_objectSpread2({}, mixins.init()), {}, {
      composes: 'fieldWrapper',
      margin: '0.5rem 0 0',
      width: '100%'
    }),
    textArea: {
      composes: 'textArea-wrapper',
      display: 'block',
      marginTop: '0.75rem',
      width: '100%',
      '& $textAreaContainer': {
        '& .textArea__input': {
          border: '1px solid #e1e7ee'
        }
      }
    },
    valid: {
      composes: 'textArea-wrapper--valid',
      extend: 'textArea',
      '& .textAreaContainer': {
        boxShadow: '0px 0px 0px 2px #ffffff',
        '&:before': {
          width: '99%',
          borderBottom: "2px solid ".concat(variables.colors.typeSuccess),
          zIndex: 1
        },
        '& .textArea__input': {
          border: "2px solid ".concat(variables.colors.typeSuccess)
        }
      }
    },
    '@keyframes fadeInAnim': {
      from: {
        opacity: 0,
        transform: 'translate(15px, 14px)'
      },
      to: {
        opacity: 1,
        transform: 'translate(-10px, 14px)'
      }
    },
    validIcon: {
      right: 0,
      position: 'absolute',
      color: "".concat(variables.colors.typeSuccess),
      animation: '$fadeInAnim 0.25s ease-out forwards'
    },
    invalid: {
      composes: 'textArea-wrapper--invalid',
      extend: 'textArea',
      '& .textAreaContainer': {
        boxShadow: '0px 0px 0px 2px #ffffff',
        '&:before': {
          width: '99%',
          borderBottom: "2px solid ".concat(variables.colors.typeDanger),
          zIndex: 1
        },
        '& .textArea__input': {
          border: "2px solid ".concat(variables.colors.typeDanger)
        }
      }
    },
    invalidIcon: {
      right: 0,
      position: 'absolute',
      color: "".concat(variables.colors.typeDanger),
      animation: '$fadeInAnim 0.25s ease-out forwards'
    },
    disabled: {
      composes: 'textArea-wrapper--disabled',
      extend: 'textArea',
      '& .textArea__input': {
        border: "1px solid ".concat(variables.colors.greyTwo),
        backgroundColor: '#f1f1f1',
        color: '#acacac',
        cursor: 'not-allowed',
        userSelect: 'none',
        '&:hover, &:focus, &:active': {
          borderColor: variables.colors.greyTwo
        }
      }
    },
    required: {
      composes: 'textArea__required',
      color: 'rgba(200, 200, 200, 1)'
    },
    label: {
      composes: 'textArea__label',
      position: 'absolute',
      transition: 'all 0.3s ease-out',
      transform: 'translate(0.1rem, 1rem)',
      marginLeft: '0.75rem',
      color: '#838383',
      pointerEvents: 'none',
      fontSize: '1rem',
      width: '100%',
      zIndex: 1
    },
    labelActive: {
      color: '#333',
      fontSize: '0.8rem',
      marginLeft: '0.75rem',
      pointerEvents: 'none',
      position: 'absolute',
      transform: 'translate(0.1rem, 0.5rem)',
      transition: 'all 0.3s ease-out',
      zIndex: 1
    },
    textAreaContainer: {
      composes: 'textAreaContainer',
      display: 'flex',
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 4,
      '&:before': {
        display: 'inline-block',
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '8px',
        width: '0%',
        height: '2px',
        borderBottom: '2px solid transparent',
        transition: '0.3s width ease-in-out'
      },
      '&:after': {
        display: 'inline-block',
        content: '""',
        position: 'absolute',
        bottom: '6px',
        right: 0,
        width: '26px',
        height: '26px',
        opacity: 0,
        transform: 'translate(0, 0)',
        transition: 'all 0.3s ease-out'
      },
      '&:focus-within': {
        boxShadow: '0px 0px 0px 2px #ffffff'
      }
    },
    textAreaInput: {
      appearance: 'none',
      backgroundColor: '#ffffff',
      borderRadius: 4,
      border: '1px solid #e1e1e1',
      color: '#333',
      composes: 'textArea__input',
      display: 'block',
      padding: '1.25rem 0.65em',
      resize: 'none',
      transition: 'border 0.2s ease-in-out',
      width: '100%',
      '&:active': {
        border: "1px solid ".concat(variables.colors.greyFour),
        outline: 'none'
      },
      '&:focus': {
        border: '2px solid #0095ff',
        outline: 'none'
      },
      '&:hover': {
        border: '1px solid #a9bac6'
      }
    },
    error: {
      composes: 'textArea__error',
      display: 'block',
      fontSize: '0.8em',
      padding: '0 0.5em',
      border: 'none',
      color: variables.colors.typeDanger,
      backgroundColor: variables.colors.blue,
      marginTop: '0.25em'
    }
  };
};

var TextArea = function TextArea(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      controlled = _ref.controlled,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      errors = _ref.errors,
      forwardRef = _ref.forwardRef,
      id = _ref.id,
      label = _ref.label,
      maxLength = _ref.maxLength,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      required = _ref.required,
      testId = _ref.testId,
      valid = _ref.valid,
      value = _ref.value,
      valueFormatter = _ref.valueFormatter,
      rows = _ref.rows,
      cols = _ref.cols,
      readOnly = _ref.readOnly,
      wrap = _ref.wrap;

  var _useState = useState(value !== null && value !== void 0 ? value : defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setValue = _useState2[1];

  var getInputState = function getInputState() {
    if (disabled) {
      return classes === null || classes === void 0 ? void 0 : classes.disabled;
    } else if (errors.length) {
      return classes === null || classes === void 0 ? void 0 : classes.invalid;
    } else if (valid && !errors.length) {
      return classes === null || classes === void 0 ? void 0 : classes.valid;
    }

    return classes === null || classes === void 0 ? void 0 : classes.textArea;
  };

  var formatValue = function formatValue(newValue) {
    return valueFormatter ? valueFormatter(newValue) : newValue;
  };

  var handleChange = function handleChange(event) {
    var newValue = formatValue(event.target.value);
    onChange(newValue);
    setValue(newValue);
  };

  var handleBlur = function handleBlur(event) {
    return onBlur(formatValue(event.target.value));
  };

  var handleFocus = function handleFocus(event) {
    return onFocus(formatValue(event.target.value));
  };

  var getClassName = function getClassName() {
    var checkValue = controlled ? value : inputValue;
    return checkValue === '' ? classes.label : classes.labelActive;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes === null || classes === void 0 ? void 0 : classes.fieldWrapper
  }, /*#__PURE__*/React.createElement("div", {
    "data-test": createTestId(testId, 'comp'),
    className: "".concat(getInputState(), " ").concat(className !== null && className !== void 0 ? className : '')
  }, /*#__PURE__*/React.createElement("label", {
    className: getClassName(),
    htmlFor: id,
    role: "group"
  }, label, required && /*#__PURE__*/React.createElement("span", {
    "data-test": createTestId(testId, 'required'),
    className: classes === null || classes === void 0 ? void 0 : classes.required
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: classes === null || classes === void 0 ? void 0 : classes.textAreaContainer
  }, /*#__PURE__*/React.createElement("textarea", {
    ref: forwardRef,
    id: id,
    name: name,
    "data-test": createTestId(testId, 'input'),
    className: classes === null || classes === void 0 ? void 0 : classes.textAreaInput,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    disabled: disabled,
    value: controlled ? value : inputValue,
    maxLength: maxLength,
    rows: rows,
    cols: cols,
    readOnly: readOnly,
    wrap: wrap
  }), (valid || errors.length > 0) && /*#__PURE__*/React.createElement(Icon$1, {
    icon: valid ? 'iconCheck' : 'iconClose',
    className: valid ? classes.validIcon : classes.invalidIcon
  }))), (errors === null || errors === void 0 ? void 0 : errors.length) ? errors.map(function (error) {
    return /*#__PURE__*/React.createElement("span", {
      key: error,
      className: classes === null || classes === void 0 ? void 0 : classes.error,
      "data-test": createTestId(testId, 'errorMsg'),
      role: "alert"
    }, error);
  }) : /*#__PURE__*/React.createElement("span", {
    className: classes === null || classes === void 0 ? void 0 : classes.error
  }, "\xA0"));
};

TextArea.displayName = "TextArea";
TextArea.propTypes = {
  classes: PropTypes.shape({
    disabled: PropTypes.string,
    error: PropTypes.string,
    fieldWrapper: PropTypes.string,
    invalid: PropTypes.string,
    invalidIcon: PropTypes.string,
    label: PropTypes.string,
    labelActive: PropTypes.string,
    required: PropTypes.string,
    textArea: PropTypes.string,
    textAreaContainer: PropTypes.string,
    textAreaInput: PropTypes.string,
    valid: PropTypes.string,
    validIcon: PropTypes.string
  }),
  className: PropTypes.string,
  cols: PropTypes.number,
  controlled: PropTypes.bool,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  forwardRef: PropTypes.any,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  maxLength: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  rows: PropTypes.number,
  testId: PropTypes.string,
  valid: PropTypes.bool,
  value: PropTypes.string,
  valueFormatter: PropTypes.func,
  wrap: PropTypes.oneOf(['soft', 'hard', 'off'])
};
TextArea.defaultProps = {
  classes: {},
  className: null,
  cols: 40,
  controlled: false,
  defaultValue: '',
  disabled: false,
  errors: [],
  forwardRef: null,
  id: '',
  maxLength: null,
  name: '',
  onBlur: noop,
  onFocus: noop,
  readOnly: false,
  required: false,
  rows: 4,
  testId: null,
  valid: null,
  value: null,
  valueFormatter: null,
  wrap: 'soft'
};
var TextArea$1 = withStyles(styles$J)(TextArea);

var styles$K = function styles(_ref) {
  var variables = _ref.variables;
  return {
    smallSwitch: {
      composes: 'small-switch'
    },
    toggleSwitch: {
      composes: 'toggle-switch',
      '& .toggle-switch-label': {
        '& .toggle-switch-innerActive': {
          '&:focus, &:focused-within': {
            display: 'block',
            "float": 'left',
            width: '50%',
            height: 34,
            padding: 0,
            lineHeight: '30px',
            fontSize: 14,
            color: '#fff',
            fontWeight: 'bold',
            boxSizing: 'border-box',
            background: '#0c8f9f !important'
          }
        }
      }
    },
    toggleSwitchCheckbox: {
      composes: 'toggle-switch_checkbox',
      display: 'none',
      'input[type=checkbox]': {
        height: 0,
        width: 0,
        visibility: 'hidden',
        background: '#4a4a4acc'
      },
      '&:checked + .toggle-switch-label': {
        background: "".concat(variables.colors.primary, " !important")
      },
      '&:checked + .toggle-switch-label .toggle-switch-switch': {
        right: '-2px'
      },
      '&:checked + .toggle-switch-label:after': {
        left: 'calc(100% - 5px)',
        transform: 'translateX(-100%)'
      }
    },
    toggleSwitchCheckboxDisabled: {
      composes: 'toggle-switch-disabled',
      background: '#c9c9c9 !important'
    },
    toggleSwitchInner: {
      composes: 'toggle-switch-inner',
      display: 'block',
      width: '100%',
      marginLeft: '30%',
      transition: 'all 0.3s ease-in 0s',
      '&:before, &:after': {
        display: 'block',
        "float": 'left',
        width: '50%',
        height: 34,
        padding: 0,
        lineHeight: '30px',
        fontSize: 14,
        color: '#fff',
        fontWeight: 'bold',
        boxSizing: 'border-box'
      },
      '&:before': {
        content: 'attr(data-no)',
        textTransform: 'uppercase',
        transform: 'translateX(3px)',
        paddingLeft: 10,
        color: '#fff'
      }
    },
    toggleSwitchLabelActive: {
      composes: 'toggle-switch-innerActive',
      display: 'block',
      width: '100%',
      marginLeft: 0,
      transition: 'all 0.3s ease-in 0s',
      background: "".concat(variables.colors.primary, " !important"),
      '&:before, &:after': {
        display: 'block',
        "float": 'left',
        width: '50%',
        height: 34,
        padding: 0,
        lineHeight: '30px',
        fontSize: 14,
        color: '#fff',
        fontWeight: 'bold',
        boxSizing: 'border-box'
      },
      '&:before': {
        content: 'attr(data-yes)',
        textTransform: 'uppercase',
        transform: 'translateX(0)',
        paddingLeft: 10,
        color: '#fff'
      }
    },
    toggleSwitchLabel: {
      composes: 'toggle-switch-label',
      cursor: 'pointer',
      width: 70,
      height: 30,
      background: 'grey',
      display: 'block',
      borderRadius: 100,
      position: 'relative'
    },
    toggleSwitchSwitch: {
      composes: 'toggle-switch-switch',
      display: 'block',
      width: 24,
      height: 24,
      margin: 5,
      background: '#fff',
      position: 'absolute',
      top: '-2px',
      bottom: 0,
      right: 38,
      border: '0 solid #bbb',
      borderRadius: 20,
      transition: 'all 0.3s ease-in 0s'
    }
  };
};

var ToggleSwitch = function ToggleSwitch(_ref) {
  var _classNames;

  var classes = _ref.classes,
      id = _ref.id,
      name = _ref.name,
      checked = _ref.checked,
      _onChange = _ref.onChange,
      optionLabels = _ref.optionLabels,
      disabled = _ref.disabled;

  var handleKeyPress = function handleKeyPress(evt) {
    if (disabled) return;
    evt.preventDefault();

    _onChange(!checked);
  };

  var getLabelClassName = classNames$1(classes.toggleSwitchInner, (_classNames = {}, _defineProperty(_classNames, classes.toggleSwitchDisabled, disabled), _defineProperty(_classNames, classes.toggleSwitchLabelActive, checked), _classNames));
  return /*#__PURE__*/React.createElement("div", {
    className: classes.toggleSwitch
  }, /*#__PURE__*/React.createElement("input", {
    className: classes.toggleSwitchCheckbox,
    checked: checked,
    disabled: disabled,
    id: id,
    name: name,
    onChange: function onChange(evt) {
      return _onChange(evt.target.checked);
    },
    type: "checkbox"
  }), /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: disabled ? "".concat(classes.toggleSwitchLabel, " ").concat(classes.toggleSwitchCheckboxDisabled) : classes.toggleSwitchLabel,
    onClick: function onClick(evt) {
      return handleKeyPress(evt);
    },
    onKeyDown: function onKeyDown(evt) {
      return handleKeyPress(evt);
    },
    role: "button",
    tabIndex: disabled ? -1 : 1
  }, /*#__PURE__*/React.createElement("span", {
    className: getLabelClassName,
    "data-yes": optionLabels[0],
    "data-no": optionLabels[1],
    tabIndex: -1
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.toggleSwitchSwitch,
    tabIndex: -1
  })));
};

ToggleSwitch.displayName = "ToggleSwitch";
ToggleSwitch.defaultProps = {
  disabled: false,
  name: 'switch',
  optionLabels: ['Yes', 'No']
};
ToggleSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    smallSwitch: PropTypes.string,
    toggleSwitch: PropTypes.string,
    toggleSwitchCheckbox: PropTypes.string,
    toggleSwitchDisabled: PropTypes.string,
    toggleSwitchCheckboxDisabled: PropTypes.string,
    toggleSwitchInner: PropTypes.string,
    toggleSwitchLabel: PropTypes.string,
    toggleSwitchLabelActive: PropTypes.string,
    toggleSwitchSwitch: PropTypes.string
  }).isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  optionLabels: PropTypes.array
};
var ToggleSwitch$1 = withStyles(styles$K)(ToggleSwitch);

var breakpoints = {
  mobileonly: '@media (max-width: 37.5em)',
  phablet: '@media (min-width: 37.5em)',
  tablet: '@media (min-width: 50em)',
  laptop: '@media (min-width: 64em) ',
  desktop: '@media (min-width: 70em)',
  xs: '@media (max-width: 36rem)',
  sm: '@media (min-width: 36rem)',
  md: '@media (min-width: 45rem)',
  lg: '@media (min-width: 60rem)',
  xl: '@media (min-width: 75rem)',
  xxl: '@media (min-width: 90rem)'
};

var ms = function ms(value, baseObject) {
  return Math.pow(baseObject.scale, value) * baseObject.fontSize;
};

var functions = {
  modularScale: ms
};

var variables = {
  kaboodleGreen: '#0D8191',
  kaboodleTurquoise: '#15a0b3',
  kaboodleOrange: '#FA754D',
  kaboodleRed: '#EA5557',
  requiredRed: '#FF5453',
  containerWidth: '1600px',
  containerPadding: '2rem',
  focus: 'rgb(224, 240, 243)',
  background: '#fffefe',
  text: '#5c6365',
  boxShadow: 'rgba(176, 204, 218, 0.32)',
  border: '1px',
  fontFamily: ['Heebo', 'sans-serif'],
  bottomNavBackground: '#f1f1f1',
  lineHeight: 1.5,
  baseDesktop: {
    fontSize: 16,
    lineHeight: 1.5
  },
  baseMobile: {
    fontSize: 14,
    lineHeight: 1.5
  },
  colors: {
    brand: '#781fff',
    primary: '#000',
    primaryAccent: '#000',
    secondary: '#E5E5E5',
    secondaryAccent: '#F76F50',
    tertiary: '#0469C6',
    tertiaryAccent: '#0a6ac2',
    dark: '#000',
    light: '#FCFCFC',
    offBlack: '#454545',
    trueBlack: '#000',
    trueWhite: '#fff',
    greyOne: '#f2f6fa',
    greyTwo: '#e1e7ee',
    greyThree: '#d2d9e4',
    greyFour: '#a9bac6',
    greyFive: '#646f7a',
    typeDefault: '#C7C7C7',
    typeSuccess: '#10ac84',
    typeInfo: '#578CA2',
    typeWarning: '#f0ad4e',
    typeDanger: '#FF5453',
    text: '#000',
    textBlack: '#000',
    textAccent: '#578CA2',
    activeGreen: '#1BB58A',
    inActiveRed: '#FF5453'
  },
  type: {
    h1: {
      fontSize: '1.68em',
      lineHeight: '1.111',
      fontWeight: 700,
      display: 'block'
    },
    h2: {
      fontSize: '1.476em',
      lineHeight: '1.111',
      fontWeight: 700,
      display: 'block'
    },
    h3: {
      fontSize: '1.296em',
      lineHeight: '1.111',
      fontWeight: 700,
      display: 'block'
    },
    h4: {
      fontSize: '1.138em',
      lineHeight: '1.111',
      fontWeight: 700,
      display: 'block'
    },
    p: {
      fontSize: '1em',
      fontWeight: 400,
      display: 'block'
    }
  }
};

var box = function box() {
  return {
    boxShadow: "0 10px 20px 0 ".concat(variables.boxShadow),
    backgroundColor: 'white',
    border: "1px solid ".concat(variables.border)
  };
};

var gradientBackground = function gradientBackground(startColor, endColor) {
  return {
    backgroundImage: "linear-gradient(-225deg, ".concat(startColor, " 0%, ").concat(endColor, " 100%)")
  };
};

var init = function init() {
  var _ref;

  return _ref = {
    extend: variables.baseMobile
  }, _defineProperty(_ref, breakpoints.lg, {
    extend: variables.baseDesktop
  }), _defineProperty(_ref, "fontFamily", variables.fontFamily), _ref;
};

var loader = function loader(size) {
  return {
    display: 'inline-block',
    width: "".concat(size),
    height: "".concat(size),
    border: "3px solid ".concat(variables.colors.greyTwo),
    borderRadius: '50%',
    borderTopColor: variables.colors.greyFive,
    animation: 'spin 1s ease-in-out infinite'
  };
};

var mixins = {
  box: box,
  loader: loader,
  gradientBackground: gradientBackground,
  init: init
};

var base = {
  name: 'base',
  type: 'gradient',
  variables: variables,
  mixins: mixins,
  functions: functions,
  breakpoints: breakpoints
};

var breakpoints$1 = {};

var box$1 = function box() {
  return {};
};

var gradientBackground$1 = function gradientBackground() {
  return {};
};

var init$1 = function init() {
  return {};
};

var loader$1 = function loader() {
  return {};
};

var mixins$1 = {
  box: box$1,
  loader: loader$1,
  gradientBackground: gradientBackground$1,
  init: init$1
};

var variables$1 = {
  baseDesktop: {},
  baseMobile: {},
  colors: {},
  type: {
    h1: {},
    h2: {},
    h3: {},
    h4: {},
    p: {}
  }
};

var blank = {
  name: 'blank',
  type: 'default',
  variables: variables$1,
  mixins: mixins$1,
  breakpoints: breakpoints$1
};

export { ActionList$1 as ActionList, AddNewAddressBtn$1 as AddNewAddressBtn, Address$1 as Address, AddressForm$1 as AddressForm, Avatar$1 as Avatar, Badge$1 as Badge, Boilerplate$1 as Boilerplate, Button$1 as Button, ButtonGroup$1 as ButtonGroup, Button$2 as ButtonV2, Calendar$1 as Calendar, Checkbox$1 as Checkbox, CheckboxList$1 as CheckboxList, Col$1 as Col, CustomerAddress$1 as CustomerAddress, DateEntryFields$1 as DateEntryFields, DatePicker$1 as DatePicker, DateRangePicker$1 as DateRangePicker, WrappedForm as Form, Grid$1 as Grid, Hello$1 as Hello, Icon$1 as Icon, InputField$1 as InputField, InputFieldV2$1 as InputFieldV2, Loader$1 as Loader, Menu, MenuEntry$1 as MenuEntry, WrappedMessage as Message, PhoneField$1 as PhoneField, Price$1 as Price, Prompt$1 as Prompt, Radio$1 as Radio, RadioBox$1 as RadioBox, RadioBoxList$1 as RadioBoxList, RadioList$1 as RadioList, Select, SelectV2$1 as SelectV2, Status$1 as Status, Switch$1 as Switch, TabList$1 as TabList, Table$1 as Table, TextArea$1 as TextArea, theming as ThemeContext, Title$1 as Title, Toast$1 as Toast, ToggleSwitch$1 as ToggleSwitch, UIContext, ValidationModal$1 as ValidationModal, WrapLoader$1 as WrapLoader, base as baseTheme, blank as blankTheme, defaultContext, withStyles, withUI };
//# sourceMappingURL=index.es.js.map
